
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "act", () => $72b03fdf46effee2$export$3ba232387fd5d6dd, (v) => $72b03fdf46effee2$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$3ba232387fd5d6dd;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray, $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$noop$1() {}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop$1, $72b03fdf46effee2$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$noop() {}
$72b03fdf46effee2$export$dca3b0875bd9a954 = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$3ba232387fd5d6dd = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, void 0, void 0, null, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
var $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$0) {
                                control = x$0;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$1) {
                            control = x$1;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1), fiber;
        case 11:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1), fiber;
        case 1:
            return fiber = $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0), fiber;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                if (child$2 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$2 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$2 = child$2.sibling;
            }
            if (!didFindChild) {
                for(child$2 = parentB.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    fiber = nextRootInstance.nodeType;
    switch(fiber){
        case 9:
        case 11:
            nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance) : 0 : 0;
            break;
        default:
            if (fiber = 8 === fiber ? nextRootInstance.parentNode : nextRootInstance, nextRootInstance = fiber.tagName, fiber = fiber.namespaceURI) fiber = $dca0ddb82b882518$var$getOwnHostContext(fiber), nextRootInstance = $dca0ddb82b882518$var$getChildHostContextProd(fiber, nextRootInstance);
            else switch(nextRootInstance){
                case "svg":
                    nextRootInstance = 1;
                    break;
                case "math":
                    nextRootInstance = 2;
                    break;
                default:
                    nextRootInstance = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, nextRootInstance);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$onCommitRoot(root) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, root, void 0, 128 === (root.current.flags & 128));
    } catch (err) {}
}
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionLane = 128, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194176;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
    root = 0 !== root.finishedLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(warmLanes))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
            return currentTime + 250;
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextTransitionLane() {
    var lane = $dca0ddb82b882518$var$nextTransitionLane;
    $dca0ddb82b882518$var$nextTransitionLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextTransitionLane & 4194176) && ($dca0ddb82b882518$var$nextTransitionLane = 128);
    return lane;
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node) {
    var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    node._valueTracker || (node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node));
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_418) {
            var $dca0ddb82b882518$var$element$jscomp$inline_419 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_419.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_418 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_419.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = $dca0ddb82b882518$var$isSupported$jscomp$inline_418;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$283 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
function $dca0ddb82b882518$var$restoreSelection(priorSelectionInformation, containerInfo) {
    var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(containerInfo);
    containerInfo = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== containerInfo && containerInfo && containerInfo.ownerDocument && $dca0ddb82b882518$var$containsNode(containerInfo.ownerDocument.documentElement, containerInfo)) {
        if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(containerInfo)) {
            if (priorSelectionInformation = priorSelectionRange.start, curFocusedElem = priorSelectionRange.end, void 0 === curFocusedElem && (curFocusedElem = priorSelectionInformation), "selectionStart" in containerInfo) containerInfo.selectionStart = priorSelectionInformation, containerInfo.selectionEnd = Math.min(curFocusedElem, containerInfo.value.length);
            else if (curFocusedElem = (priorSelectionInformation = containerInfo.ownerDocument || document) && priorSelectionInformation.defaultView || window, curFocusedElem.getSelection) {
                curFocusedElem = curFocusedElem.getSelection();
                var length = containerInfo.textContent.length, start = Math.min(priorSelectionRange.start, length);
                priorSelectionRange = void 0 === priorSelectionRange.end ? start : Math.min(priorSelectionRange.end, length);
                !curFocusedElem.extend && start > priorSelectionRange && (length = priorSelectionRange, priorSelectionRange = start, start = length);
                length = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, start);
                var endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(containerInfo, priorSelectionRange);
                length && endMarker && (1 !== curFocusedElem.rangeCount || curFocusedElem.anchorNode !== length.node || curFocusedElem.anchorOffset !== length.offset || curFocusedElem.focusNode !== endMarker.node || curFocusedElem.focusOffset !== endMarker.offset) && (priorSelectionInformation = priorSelectionInformation.createRange(), priorSelectionInformation.setStart(length.node, length.offset), curFocusedElem.removeAllRanges(), start > priorSelectionRange ? (curFocusedElem.addRange(priorSelectionInformation), curFocusedElem.extend(endMarker.node, endMarker.offset)) : (priorSelectionInformation.setEnd(endMarker.node, endMarker.offset), curFocusedElem.addRange(priorSelectionInformation)));
            }
        }
        priorSelectionInformation = [];
        for(curFocusedElem = containerInfo; curFocusedElem = curFocusedElem.parentNode;)1 === curFocusedElem.nodeType && priorSelectionInformation.push({
            element: curFocusedElem,
            left: curFocusedElem.scrollLeft,
            top: curFocusedElem.scrollTop
        });
        "function" === typeof containerInfo.focus && containerInfo.focus();
        for(containerInfo = 0; containerInfo < priorSelectionInformation.length; containerInfo++)curFocusedElem = priorSelectionInformation[containerInfo], curFocusedElem.element.scrollLeft = curFocusedElem.left, curFocusedElem.element.scrollTop = curFocusedElem.top;
    }
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll scrollEnd toggle touchMove waiting wheel".split(" ");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
        update
    ] : sourceFiber.push(update), update.lane = lane | 536870912);
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {}, $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $dca0ddb82b882518$var$track(instance);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children), $dca0ddb82b882518$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 3:
        case 27:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        case 5:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var shouldClear = !1, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== fiber.tag && 27 !== fiber.tag) {
        if (JSCompiler_temp = 5 === fiber.tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && (shouldClear = !0);
    shouldClear && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === fiber.tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(shouldClear = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === shouldClear) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        shouldClear--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || shouldClear++;
                }
                fiber = fiber.nextSibling;
            }
            $dca0ddb82b882518$var$nextHydratableInstance = null;
        }
    } else $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$noop$3() {}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$3, $dca0ddb82b882518$var$noop$3);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    thenableState = thenable.reason;
                    if (thenableState === $dca0ddb82b882518$var$SuspenseException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
                    throw thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
        newFiber.flags |= 33554434;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = fiber);
        }
    } else $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || "$!" === state.data)) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber$1.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
var $dca0ddb82b882518$var$createFunctionComponentUpdateQueue;
$dca0ddb82b882518$var$createFunctionComponentUpdateQueue = function() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
};
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber$1.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$54 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$54 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$54 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$60) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$60);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber$1;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? $dca0ddb82b882518$var$useThenable(currentStateHook) : currentStateHook;
    var actionQueueHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
    action !== actionQueueHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= 2048, $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), {
        destroy: void 0
    }, null));
    return [
        currentStateHook,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushEffect(tag, create, inst, deps) {
    tag = {
        tag: tag,
        create: create,
        inst: inst,
        deps: deps,
        next: null
    };
    create = $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue;
    null === create && (create = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber$1.updateQueue = create);
    inst = create.lastEffect;
    null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, {
        destroy: void 0
    }, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushEffect(hookFlags, create, inst, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushEffect(1 | hookFlags, create, inst, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber$1.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop$2() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop$2 : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$63 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$63 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$63, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$63, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber$1 || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber$1;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194176)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useCacheRefresh = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useMemoCache = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useHostTransitionStatus = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useFormState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useActionState = $dca0ddb82b882518$var$throwInvalidHookError;
$dca0ddb82b882518$var$ContextOnlyDispatcher.useOptimistic = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber$1, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 60) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushEffect(9, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
            destroy: void 0
        }, null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += ":";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
        return hook.memoizedState = identifierPrefix;
    },
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1);
    }
};
$dca0ddb82b882518$var$HooksDispatcherOnMount.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useFormState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useActionState = $dca0ddb82b882518$var$mountActionState;
$dca0ddb82b882518$var$HooksDispatcherOnMount.useOptimistic = function(passthrough) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    hook.memoizedState = hook.baseState = passthrough;
    var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
    };
    hook.queue = queue;
    hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber$1, !0, queue);
    queue.dispatch = hook;
    return [
        passthrough,
        hook
    ];
};
var $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useFormState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useActionState = $dca0ddb82b882518$var$updateActionState;
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
};
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useCacheRefresh = $dca0ddb82b882518$var$updateRefresh;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useMemoCache = $dca0ddb82b882518$var$useMemoCache;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useHostTransitionStatus = $dca0ddb82b882518$var$useHostTransitionStatus;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useFormState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useActionState = $dca0ddb82b882518$var$rerenderActionState;
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    hook.baseState = passthrough;
    return [
        passthrough,
        hook.queue.dispatch
    ];
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    isMounted: function(component) {
        return (component = component._reactInternals) ? $dca0ddb82b882518$var$getNearestMountedFiber(component) === component : !1;
    },
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$67 in Component)void 0 === newProps[propName$67] && (newProps[propName$67] = Component[propName$67]);
    }
    return newProps;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $hPtJY && "function" === typeof $hPtJY.emit) {
        $hPtJY.emit("uncaughtException", error);
        return;
    }
    console.error(error);
};
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$68) {
        setTimeout(function() {
            throw e$68;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$69) {
        setTimeout(function() {
            throw e$69;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    if ("hidden" === nextProps.mode || nextIsDetached) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = nextIsDetached & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($dca0ddb82b882518$var$isHydrating) {
                var nextInstance = $dca0ddb82b882518$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                            id: $dca0ddb82b882518$var$treeContextId,
                            overflow: $dca0ddb82b882518$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return "$!" === nextInstance.data ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), "$!" === nextInstance.data) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp) {
                nextProps = renderLanes & -renderLanes;
                if (0 !== (nextProps & 42)) nextProps = 1;
                else switch(nextProps){
                    case 2:
                        nextProps = 1;
                        break;
                    case 8:
                        nextProps = 4;
                        break;
                    case 32:
                        nextProps = 16;
                        break;
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                        nextProps = 64;
                        break;
                    case 268435456:
                        nextProps = 134217728;
                        break;
                    default:
                        nextProps = 0;
                }
                nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            }
            "$?" === nextInstance.data || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, current), nextInstance._reactRetry = workInProgress, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextInstance.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && ($dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow, $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider, $dca0ddb82b882518$var$treeContextId = current.id, $dca0ddb82b882518$var$treeContextOverflow = current.overflow, $dca0ddb82b882518$var$treeContextProvider = workInProgress), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== digest ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(digest, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $dca0ddb82b882518$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $dca0ddb82b882518$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, nextProps;
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    return $dca0ddb82b882518$var$createFiberFromOffscreen(offscreenProps, mode, 0, null);
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $dca0ddb82b882518$var$shouldConstruct(lazyComponent) ? (current = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $dca0ddb82b882518$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                var nextProps = workInProgress.pendingProps;
                init = workInProgress.memoizedState;
                lazyComponent = init.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                nextProps = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, nextProps);
                nextProps !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                nextProps = nextState.element;
                if (init.isDehydrated) {
                    if (init = {
                        element: nextProps,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else if (nextProps !== lazyComponent) {
                        lazyComponent = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError(lazyComponent);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                        break a;
                    } else for($dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(workInProgress.stateNode.containerInfo.firstChild), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !0, renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (nextProps === lazyComponent) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, lazyComponent[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(lazyComponent, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (lazyComponent = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild)), lazyComponent = workInProgress.pendingProps.children, null !== current || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (init = lazyComponent = $dca0ddb82b882518$var$nextHydratableInstance) lazyComponent = $dca0ddb82b882518$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(lazyComponent.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            nextProps = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = nextProps.children;
            $dca0ddb82b882518$var$shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = init);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), init = $dca0ddb82b882518$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), lazyComponent = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? (init = $dca0ddb82b882518$var$peekCacheFromPool(), null === init && (init = $dca0ddb82b882518$var$workInProgressRoot, nextProps = $dca0ddb82b882518$var$createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                        try {
                            destroy();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            var instance = current.stateNode;
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = instance;
                    break;
                default:
                    instanceToUse = instance;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$112) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$112);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 27 !== fiber.tag && 18 !== fiber.tag;){
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? 8 === parent.nodeType ? parent.parentNode.insertBefore(node, before) : parent.insertBefore(node, before) : (8 === parent.nodeType ? (before = parent.parentNode, before.insertBefore(node, parent)) : (before = parent, before.appendChild(node)), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && 27 !== tag && (node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
    resolvedPrevProps = $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur;
    $dca0ddb82b882518$var$shouldFireAfterActiveInstanceBlur = !1;
    return resolvedPrevProps;
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$111) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$111);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                finishedRoot = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        finishedRoot = finishedWork.child.stateNode;
                        break;
                    case 1:
                        finishedRoot = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(flags, finishedRoot);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 26:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 22:
            prevProps = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!prevProps) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return) : $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber = deletedFiber.stateNode;
            for(nearestMountedAncestor = deletedFiber.attributes; nearestMountedAncestor.length;)deletedFiber.removeAttributeNode(nearestMountedAncestor[0]);
            $dca0ddb82b882518$var$detachDeletedInstance(deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParent;
            var prevHostParentIsContainer$119 = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParentIsContainer;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer$119;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    finishedRoot = $dca0ddb82b882518$var$hostParent, prevHostParent = deletedFiber.stateNode, 8 === finishedRoot.nodeType ? finishedRoot.parentNode.removeChild(prevHostParent) : finishedRoot.removeChild(prevHostParent);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (nearestMountedAncestor = $dca0ddb82b882518$var$hostParent, deletedFiber = deletedFiber.stateNode, 8 === nearestMountedAncestor.nodeType ? $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor.parentNode, deletedFiber) : 1 === nearestMountedAncestor.nodeType && $dca0ddb82b882518$var$clearSuspenseBoundary(nearestMountedAncestor, deletedFiber), $dca0ddb82b882518$var$retryIfBlockedOn(nearestMountedAncestor)) : $dca0ddb82b882518$var$clearSuspenseBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            if (flags & 4 && null === finishedWork.alternate) {
                hoistableRoot = finishedWork.stateNode;
                currentResource = finishedWork.memoizedProps;
                try {
                    for(var node = hoistableRoot.firstChild; node;){
                        var nextNode = node.nextSibling, nodeName = node.nodeName;
                        node[$dca0ddb82b882518$var$internalHoistableMarker] || "HEAD" === nodeName || "BODY" === nodeName || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node.rel.toLowerCase() || hoistableRoot.removeChild(node);
                        node = nextNode;
                    }
                    for(var type = finishedWork.type, attributes = hoistableRoot.attributes; attributes.length;)hoistableRoot.removeAttributeNode(attributes[0]);
                    $dca0ddb82b882518$var$setInitialProperties(hoistableRoot, type, currentResource);
                    hoistableRoot[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                    hoistableRoot[$dca0ddb82b882518$var$internalPropsKey] = currentResource;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            node = null !== finishedWork.memoizedState;
            nextNode = null !== current && null !== current.memoizedState;
            nodeName = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            type = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName || node;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type || nextNode;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = type;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = nodeName;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            root = finishedWork.stateNode;
            root._current = finishedWork;
            root._visibility &= -3;
            root._visibility |= root._pendingVisibility & 2;
            if (flags & 8192 && (root._visibility = node ? root._visibility & -2 : root._visibility | 1, node && (root = $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, null === current || nextNode || root || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode)) a: for(current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag || 27 === root.tag) {
                    if (null === current) {
                        nextNode = current = root;
                        try {
                            if (hoistableRoot = nextNode.stateNode, node) currentResource = hoistableRoot.style, "function" === typeof currentResource.setProperty ? currentResource.setProperty("display", "none", "important") : currentResource.display = "none";
                            else {
                                maybeNodes = nextNode.stateNode;
                                i = nextNode.memoizedProps.style;
                                var display = void 0 !== i && null !== i && i.hasOwnProperty("display") ? i.display : null;
                                maybeNodes.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        nextNode = root;
                        try {
                            nextNode.stateNode.nodeValue = node ? "" : nextNode.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(nextNode, nextNode.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            if (27 !== finishedWork.tag) {
                a: {
                    for(var parent = finishedWork.return; null !== parent;){
                        if ($dca0ddb82b882518$var$isHostParent(parent)) {
                            var JSCompiler_inline_result = parent;
                            break a;
                        }
                        parent = parent.return;
                    }
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
                }
                switch(JSCompiler_inline_result.tag){
                    case 27:
                        var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                        break;
                    case 5:
                        var parent$113 = JSCompiler_inline_result.stateNode;
                        JSCompiler_inline_result.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$113, ""), JSCompiler_inline_result.flags &= -33);
                        var before$114 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$114, parent$113);
                        break;
                    case 3:
                    case 4:
                        var parent$115 = JSCompiler_inline_result.stateNode.containerInfo, before$116 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                        $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$116, parent$115);
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
                }
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 26:
            case 27:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 4 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource($dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 4 && (i._visibility &= -5, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 31457280;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 31457282;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE:
            return $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key);
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_PROVIDER_TYPE:
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromOffscreen(pendingProps, mode, lanes, key) {
    pendingProps = $dca0ddb82b882518$var$createFiberImplClass(22, pendingProps, key, mode);
    pendingProps.elementType = $dca0ddb82b882518$var$REACT_OFFSCREEN_TYPE;
    pendingProps.lanes = lanes;
    var primaryChildInstance = {
        _visibility: 1,
        _pendingVisibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null,
        _current: null,
        detach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility |= 2, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        },
        attach: function() {
            var fiber = primaryChildInstance._current;
            if (null === fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(456));
            if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
                null !== root && (primaryChildInstance._pendingVisibility &= -3, $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2));
            }
        }
    };
    pendingProps.stateNode = primaryChildInstance;
    return pendingProps;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        resource = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null !== $dca0ddb82b882518$var$shellBoundary : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || resource !== $dca0ddb82b882518$var$shellBoundary)) throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$131 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$131 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$131 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$131.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags & 31457280, subtreeFlags |= child$132.flags & 31457280, child$132.return = completedWork, child$132 = child$132.sibling;
    else for(child$132 = completedWork.child; null !== child$132;)newChildLanes |= child$132.lanes | child$132.childLanes, subtreeFlags |= child$132.subtreeFlags, subtreeFlags |= child$132.flags, child$132.return = completedWork, child$132 = child$132.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null));
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== renderLanes ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else null !== $dca0ddb82b882518$var$hydrationErrors && ($dca0ddb82b882518$var$queueRecoverableErrors($dca0ddb82b882518$var$hydrationErrors), $dca0ddb82b882518$var$hydrationErrors = null), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$144 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$144 = newProps.memoizedState.cachePool.pool);
                cache$144 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$144 = type.rendering;
            if (null === cache$144) {
                if (newProps) $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$144 = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== cache$144) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1);
                            current = cache$144.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(cache$144), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$144.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - type.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$144.sibling = workInProgress.child, workInProgress.child = cache$144) : (current = type.last, null !== current ? current.sibling = cache$144 : workInProgress.child = cache$144, type.last = cache$144);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $dca0ddb82b882518$var$now(), workInProgress.sibling = null, current = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes) return $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes;
    if (null !== $dca0ddb82b882518$var$ReactSharedInternals.T) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $dca0ddb82b882518$var$requestTransitionLane();
    }
    return $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    0 === $dca0ddb82b882518$var$workInProgressDeferredLane && ($dca0ddb82b882518$var$workInProgressDeferredLane = 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else if (6 === exitStatus) $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
        else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && $dca0ddb82b882518$var$queueRecoverableErrors(renderWasConcurrent);
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                switch(exitStatus){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194176) === lanes) {
                            $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        }
                        break;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                shouldTimeSlice.finishedWork = forceSync;
                shouldTimeSlice.finishedLanes = lanes;
                if ((lanes & 62914560) === lanes && (renderWasConcurrent = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < renderWasConcurrent)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0)) break a;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$queueRecoverableErrors(errors) {
    null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = errors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, errors);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var subtreeFlags = finishedWork.subtreeFlags;
    if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if ($dca0ddb82b882518$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $dca0ddb82b882518$var$noop
        }, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = $dca0ddb82b882518$var$waitForCommitToBeReady(), null !== finishedWork) {
            root.cancelPendingCommit = finishedWork($dca0ddb82b882518$var$commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    root.finishedWork = null;
    root.finishedLanes = 0;
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194176) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$164) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$164);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 === $dca0ddb82b882518$var$workInProgressSuspendedReason && $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : 1) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrent();
        break;
    } catch (thrownValue$166) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$166);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrent() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousUpdateLanePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$ReactSharedInternals.T = null, $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    } finally{
        $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousUpdateLanePriority;
    }
}
function $dca0ddb82b882518$var$commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
    do $dca0ddb82b882518$var$flushPassiveEffects();
    while (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var finishedWork = root.finishedWork;
    didIncludeRenderPhaseUpdate = root.finishedLanes;
    if (null === finishedWork) return null;
    root.finishedWork = null;
    root.finishedLanes = 0;
    if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
    root.callbackNode = null;
    root.callbackPriority = 0;
    root.cancelPendingCommit = null;
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
    0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || $dca0ddb82b882518$var$rootDoesHavePassiveEffects || ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !0, $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = remainingLanes, $dca0ddb82b882518$var$pendingPassiveTransitions = transitions, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects(!0);
        return null;
    }));
    transitions = 0 !== (finishedWork.flags & 15990);
    0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = $dca0ddb82b882518$var$ReactSharedInternals.T, $dca0ddb82b882518$var$ReactSharedInternals.T = null, spawnedLane = $dca0ddb82b882518$var$ReactDOMSharedInternals.p, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, updatedLanes = $dca0ddb82b882518$var$executionContext, $dca0ddb82b882518$var$executionContext |= 4, $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root), $dca0ddb82b882518$var$restoreSelection($dca0ddb82b882518$var$selectionInformation, root.containerInfo), $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled, $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null, root.current = finishedWork, $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), $dca0ddb82b882518$var$requestPaint(), $dca0ddb82b882518$var$executionContext = updatedLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = spawnedLane, $dca0ddb82b882518$var$ReactSharedInternals.T = transitions) : root.current = finishedWork;
    $dca0ddb82b882518$var$rootDoesHavePassiveEffects ? ($dca0ddb82b882518$var$rootDoesHavePassiveEffects = !1, $dca0ddb82b882518$var$rootWithPendingPassiveEffects = root, $dca0ddb82b882518$var$pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    remainingLanes = root.pendingLanes;
    0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
    $dca0ddb82b882518$var$onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
    if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
        componentStack: remainingLanes.stack
    });
    0 !== ($dca0ddb82b882518$var$pendingPassiveEffectsLanes & 3) && $dca0ddb82b882518$var$flushPassiveEffects();
    remainingLanes = root.pendingLanes;
    0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    return null;
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (null !== $dca0ddb82b882518$var$rootWithPendingPassiveEffects) {
        var root$170 = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, remainingLanes = $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes;
        $dca0ddb82b882518$var$pendingPassiveEffectsRemainingLanes = 0;
        var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingPassiveEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        try {
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            if (null === $dca0ddb82b882518$var$rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
            else {
                renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
                $dca0ddb82b882518$var$pendingPassiveTransitions = null;
                var root = $dca0ddb82b882518$var$rootWithPendingPassiveEffects, lanes = $dca0ddb82b882518$var$pendingPassiveEffectsLanes;
                $dca0ddb82b882518$var$rootWithPendingPassiveEffects = null;
                $dca0ddb82b882518$var$pendingPassiveEffectsLanes = 0;
                if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
                var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
                $dca0ddb82b882518$var$executionContext |= 4;
                $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root.current);
                $dca0ddb82b882518$var$commitPassiveMountOnFiber(root, root.current, lanes, renderPriority);
                $dca0ddb82b882518$var$executionContext = prevExecutionContext;
                $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
                if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
                    $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root);
                } catch (err) {}
                JSCompiler_inline_result = !0;
            }
            return JSCompiler_inline_result;
        } finally{
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root$170, remainingLanes);
        }
    }
    return !1;
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateTask($dca0ddb82b882518$var$processRootScheduleInMicrotask));
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$172 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$172;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$172.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$172.suspendedLanes, pingedLanes = root$172.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$172, root$172 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$172, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$172, JSCompiler_inline_result));
                }
                root$172 = root$172.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane), $dca0ddb82b882518$var$currentEventTransitionLane = 0);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && 2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPassiveEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateTask(cb) {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, cb) : cb();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    0 === $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = $dca0ddb82b882518$var$claimNextTransitionLane());
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1439 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1439 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1439++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1440 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1439], $dca0ddb82b882518$var$domEventName$jscomp$inline_1441 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442 = $dca0ddb82b882518$var$eventName$jscomp$inline_1440[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1440.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1441, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1442);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer || 8 === container.nodeType && container.parentNode === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if (3 === grandTag || 4 === grandTag) {
                    if (grandTag = nodeTag.stateNode.containerInfo, grandTag === targetContainer || 8 === grandTag.nodeType && grandTag.parentNode === targetContainer) return;
                }
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $dca0ddb82b882518$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $dca0ddb82b882518$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $dca0ddb82b882518$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $dca0ddb82b882518$var$getParent(inCapturePhase);
                                reactEventName = $dca0ddb82b882518$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        targetFiber = targetFiber.return;
    }
    return listeners;
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$noop$1() {}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$186 = props[hasSrc];
                if (null != propValue$186) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$186;
                        break;
                    case "type":
                        propValue = propValue$186;
                        break;
                    case "checked":
                        checked = propValue$186;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$186;
                        break;
                    case "value":
                        propKey = propValue$186;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$186;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$186) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$186, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $dca0ddb82b882518$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$186 in props)props.hasOwnProperty(propValue$186) && (hasSrc = props[propValue$186], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$186, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$203 in nextProps){
                var propKey = nextProps[propKey$203];
                lastProp = lastProps[propKey$203];
                if (nextProps.hasOwnProperty(propKey$203) && (null != propKey || null != lastProp)) switch(propKey$203){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$203, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$203 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$203 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$203 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$203, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$203 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$203 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$203, propKey);
            return;
        case "option":
            for(var propKey$219 in lastProps)if (propKey$203 = lastProps[propKey$219], lastProps.hasOwnProperty(propKey$219) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$219)) switch(propKey$219){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$219, null, nextProps, propKey$203);
            }
            for(lastDefaultValue in nextProps)if (propKey$203 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$203 && "function" !== typeof propKey$203 && "symbol" !== typeof propKey$203;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$203, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$224 in lastProps)propKey$203 = lastProps[propKey$224], lastProps.hasOwnProperty(propKey$224) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$224) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$224, null, nextProps, propKey$203);
            for(checked in nextProps)if (propKey$203 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$203 !== propKey && (null != propKey$203 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$203) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$203, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$229 in lastProps)propKey$203 = lastProps[propKey$229], lastProps.hasOwnProperty(propKey$229) && void 0 !== propKey$203 && !nextProps.hasOwnProperty(propKey$229) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$229, void 0, nextProps, propKey$203);
                for(defaultChecked in nextProps)propKey$203 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$203 === propKey || void 0 === propKey$203 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$203, nextProps, propKey);
                return;
            }
    }
    for(var propKey$234 in lastProps)propKey$203 = lastProps[propKey$234], lastProps.hasOwnProperty(propKey$234) && null != propKey$203 && !nextProps.hasOwnProperty(propKey$234) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$234, null, nextProps, propKey$203);
    for(lastProp in nextProps)propKey$203 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$203 === propKey || null == propKey$203 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$203, nextProps, propKey);
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" !== node && "$?" !== node && "$!" !== node || depth++;
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(suspenseInstance);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
function $dca0ddb82b882518$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$242 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$243 = styles$242.get(type);
                resource$243 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$243 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$242.set(type, resource$243), (styles$242 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$242._p && (resource$243.instance = styles$242, resource$243.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$242 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$243.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$243;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$248 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$248) return resource.state.loading |= 4, resource.instance = instance$248, $dca0ddb82b882518$var$markNodeAsHoistable(instance$248), instance$248;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$248 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$248);
            var linkInstance = instance$248;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$248, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$248, props.precedence, hoistableRoot);
            return resource.instance = instance$248;
        case "script":
            instance$248 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$248))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$248)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $dca0ddb82b882518$var$suspendedState = null;
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $dca0ddb82b882518$var$waitForCommitToBeReady() {
    if (null === $dca0ddb82b882518$var$suspendedState) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(475));
    var state = $dca0ddb82b882518$var$suspendedState;
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $dca0ddb82b882518$var$requestUpdateLane(), root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        0 === root.tag && $dca0ddb82b882518$var$flushPassiveEffects();
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686 = $acw62.version;
if ("19.0.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1686, "19.0.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2165 = {
    bundleType: 0,
    version: "19.0.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    findFiberByHostInstance: $dca0ddb82b882518$var$getClosestInstanceFromNode,
    reconcilerVersion: "19.0.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2166 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2166.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2166.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2166.inject($dca0ddb82b882518$var$internals$jscomp$inline_2165), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2166;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(8 === container.nodeType ? container.parentNode : container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    initialChildren.current.lanes = isStrictMode;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, isStrictMode);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.0.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $11c56e2ffb2d6006$export$8352ce38b91d0c62, (v) => $11c56e2ffb2d6006$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $11c56e2ffb2d6006$export$839f9183b0465a69, (v) => $11c56e2ffb2d6006$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $11c56e2ffb2d6006$export$4b844e58a3e414b4, (v) => $11c56e2ffb2d6006$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$8352ce38b91d0c62;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$839f9183b0465a69;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$4b844e58a3e414b4;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback();
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostCallback() {
    $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
}
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$8352ce38b91d0c62 = function() {
    $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback());
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$839f9183b0465a69 = function() {
    return $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$4b844e58a3e414b4 = function() {};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$requestHostCallback()));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.0.0";

});



parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});
parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});



var $589ad10a79d6c579$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"h00hi\",\"index.9513e20a.js\",\"hnlbi\",\"logo.5daeb6bd.png\"]"));

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



parcelRequire("acw62");
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = 'Invariant failed';
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}


function $04e51d94e9f9f85e$export$4c7897fafd92b108(arr) {
    return arr[arr.length - 1];
}
function $04e51d94e9f9f85e$var$isFunction(d) {
    return typeof d === "function";
}
function $04e51d94e9f9f85e$export$7f095f455ad5af3f(updater, previous) {
    if ($04e51d94e9f9f85e$var$isFunction(updater)) return updater(previous);
    return updater;
}
function $04e51d94e9f9f85e$export$357523c63a2253b9(parent, keys) {
    return keys.reduce((obj, key)=>{
        obj[key] = parent[key];
        return obj;
    }, {});
}
function $04e51d94e9f9f85e$export$77a71fc411098696(prev, _next) {
    if (prev === _next) return prev;
    const next = _next;
    const array = $04e51d94e9f9f85e$export$7a8558113332b71e(prev) && $04e51d94e9f9f85e$export$7a8558113332b71e(next);
    if (array || $04e51d94e9f9f85e$export$53b83ca8eaab0383(prev) && $04e51d94e9f9f85e$export$53b83ca8eaab0383(next)) {
        const prevItems = array ? prev : Object.keys(prev);
        const prevSize = prevItems.length;
        const nextItems = array ? next : Object.keys(next);
        const nextSize = nextItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < nextSize; i++){
            const key = array ? i : nextItems[i];
            if ((!array && prevItems.includes(key) || array) && prev[key] === void 0 && next[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $04e51d94e9f9f85e$export$77a71fc411098696(prev[key], next[key]);
                if (copy[key] === prev[key] && prev[key] !== void 0) equalItems++;
            }
        }
        return prevSize === nextSize && equalItems === prevSize ? prev : copy;
    }
    return next;
}
function $04e51d94e9f9f85e$export$53b83ca8eaab0383(o) {
    if (!$04e51d94e9f9f85e$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$04e51d94e9f9f85e$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $04e51d94e9f9f85e$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $04e51d94e9f9f85e$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $04e51d94e9f9f85e$var$getObjectKeys(obj, ignoreUndefined) {
    let keys = Object.keys(obj);
    if (ignoreUndefined) keys = keys.filter((key)=>obj[key] !== void 0);
    return keys;
}
function $04e51d94e9f9f85e$export$9cb4719e2e525b7a(a, b, opts) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if ($04e51d94e9f9f85e$export$53b83ca8eaab0383(a) && $04e51d94e9f9f85e$export$53b83ca8eaab0383(b)) {
        const ignoreUndefined = (opts == null ? void 0 : opts.ignoreUndefined) ?? true;
        const aKeys = $04e51d94e9f9f85e$var$getObjectKeys(a, ignoreUndefined);
        const bKeys = $04e51d94e9f9f85e$var$getObjectKeys(b, ignoreUndefined);
        if (!(opts == null ? void 0 : opts.partial) && aKeys.length !== bKeys.length) return false;
        return bKeys.every((key)=>$04e51d94e9f9f85e$export$9cb4719e2e525b7a(a[key], b[key], opts));
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return !a.some((item, index)=>!$04e51d94e9f9f85e$export$9cb4719e2e525b7a(item, b[index], opts));
    }
    return false;
}
function $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd(onResolve) {
    let resolveLoadPromise;
    let rejectLoadPromise;
    const controlledPromise = new Promise((resolve, reject)=>{
        resolveLoadPromise = resolve;
        rejectLoadPromise = reject;
    });
    controlledPromise.status = "pending";
    controlledPromise.resolve = (value)=>{
        controlledPromise.status = "resolved";
        controlledPromise.value = value;
        resolveLoadPromise(value);
        onResolve == null || onResolve(value);
    };
    controlledPromise.reject = (e)=>{
        controlledPromise.status = "rejected";
        rejectLoadPromise(e);
    };
    return controlledPromise;
}
function $04e51d94e9f9f85e$export$2ae35b2f7ca3bb70(jsonString) {
    return jsonString.replace(/\\/g, "\\\\").replace(/'/g, "\\'").replace(/"/g, '\\"');
}
function $04e51d94e9f9f85e$export$26c89aaec4eb1d2e(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for (const item of keysA){
        if (!Object.prototype.hasOwnProperty.call(objB, item) || !Object.is(objA[item], objB[item])) return false;
    }
    return true;
}
function $04e51d94e9f9f85e$export$bbcd8d1a495e51e2(inputString) {
    const pattern = /%[0-9A-Fa-f]{2}/;
    return pattern.test(inputString);
}


function $355b3a1b8fb8b573$export$86d9a7913e44197e(paths) {
    return $355b3a1b8fb8b573$export$b7c632328822445d(paths.filter((val)=>{
        return val !== void 0;
    }).join("/"));
}
function $355b3a1b8fb8b573$export$b7c632328822445d(path) {
    return path.replace(/\/{2,}/g, "/");
}
function $355b3a1b8fb8b573$export$47150f29cd1fb3ae(path) {
    return path === "/" ? path : path.replace(/^\/{1,}/, "");
}
function $355b3a1b8fb8b573$export$a33f08202c373623(path) {
    return path === "/" ? path : path.replace(/\/{1,}$/, "");
}
function $355b3a1b8fb8b573$export$b86b8b1e0778ce3f(path) {
    return $355b3a1b8fb8b573$export$a33f08202c373623($355b3a1b8fb8b573$export$47150f29cd1fb3ae(path));
}
function $355b3a1b8fb8b573$export$b6d465111d914331(value, basepath) {
    if ((value == null ? void 0 : value.endsWith("/")) && value !== "/" && value !== `${basepath}/`) return value.slice(0, -1);
    return value;
}
function $355b3a1b8fb8b573$export$c2ef510b203b107f(pathName1, pathName2, basepath) {
    return $355b3a1b8fb8b573$export$b6d465111d914331(pathName1, basepath) === $355b3a1b8fb8b573$export$b6d465111d914331(pathName2, basepath);
}
function $355b3a1b8fb8b573$export$b09f2ff0bbcb43c7({ basepath: basepath, base: base, to: to, trailingSlash: trailingSlash = "never", caseSensitive: caseSensitive }) {
    var _a, _b;
    base = $355b3a1b8fb8b573$export$544e093309626785(basepath, base, caseSensitive);
    to = $355b3a1b8fb8b573$export$544e093309626785(basepath, to, caseSensitive);
    let baseSegments = $355b3a1b8fb8b573$export$7fafb205ecc26684(base);
    const toSegments = $355b3a1b8fb8b573$export$7fafb205ecc26684(to);
    if (baseSegments.length > 1 && ((_a = (0, $04e51d94e9f9f85e$export$4c7897fafd92b108)(baseSegments)) == null ? void 0 : _a.value) === "/") baseSegments.pop();
    toSegments.forEach((toSegment, index)=>{
        if (toSegment.value === "/") {
            if (!index) baseSegments = [
                toSegment
            ];
            else if (index === toSegments.length - 1) baseSegments.push(toSegment);
        } else if (toSegment.value === "..") baseSegments.pop();
        else if (toSegment.value === ".") ;
        else baseSegments.push(toSegment);
    });
    if (baseSegments.length > 1) {
        if (((_b = (0, $04e51d94e9f9f85e$export$4c7897fafd92b108)(baseSegments)) == null ? void 0 : _b.value) === "/") {
            if (trailingSlash === "never") baseSegments.pop();
        } else if (trailingSlash === "always") baseSegments.push({
            type: "pathname",
            value: "/"
        });
    }
    const joined = $355b3a1b8fb8b573$export$86d9a7913e44197e([
        basepath,
        ...baseSegments.map((d)=>d.value)
    ]);
    return $355b3a1b8fb8b573$export$b7c632328822445d(joined);
}
function $355b3a1b8fb8b573$export$7fafb205ecc26684(pathname) {
    if (!pathname) return [];
    pathname = $355b3a1b8fb8b573$export$b7c632328822445d(pathname);
    const segments = [];
    if (pathname.slice(0, 1) === "/") {
        pathname = pathname.substring(1);
        segments.push({
            type: "pathname",
            value: "/"
        });
    }
    if (!pathname) return segments;
    const split = pathname.split("/").filter(Boolean);
    segments.push(...split.map((part)=>{
        if (part === "$" || part === "*") return {
            type: "wildcard",
            value: part
        };
        if (part.charAt(0) === "$") return {
            type: "param",
            value: part
        };
        return {
            type: "pathname",
            value: decodeURI(part)
        };
    }));
    if (pathname.slice(-1) === "/") {
        pathname = pathname.substring(1);
        segments.push({
            type: "pathname",
            value: "/"
        });
    }
    return segments;
}
function $355b3a1b8fb8b573$export$8ca4fd5908a217f6({ path: path, params: params, leaveWildcards: leaveWildcards, leaveParams: leaveParams, decodeCharMap: decodeCharMap }) {
    const interpolatedPathSegments = $355b3a1b8fb8b573$export$7fafb205ecc26684(path);
    function encodeParam(key) {
        const value = params[key];
        const isValueString = typeof value === "string";
        if ([
            "*",
            "_splat"
        ].includes(key)) return isValueString ? encodeURI(value) : value;
        else return isValueString ? $355b3a1b8fb8b573$var$encodePathParam(value, decodeCharMap) : value;
    }
    const usedParams = {};
    const interpolatedPath = $355b3a1b8fb8b573$export$86d9a7913e44197e(interpolatedPathSegments.map((segment)=>{
        if (segment.type === "wildcard") {
            usedParams._splat = params._splat;
            const value = encodeParam("_splat");
            if (leaveWildcards) return `${segment.value}${value ?? ""}`;
            return value;
        }
        if (segment.type === "param") {
            const key = segment.value.substring(1);
            usedParams[key] = params[key];
            if (leaveParams) {
                const value = encodeParam(segment.value);
                return `${segment.value}${value ?? ""}`;
            }
            return encodeParam(key) ?? "undefined";
        }
        return segment.value;
    }));
    return {
        usedParams: usedParams,
        interpolatedPath: interpolatedPath
    };
}
function $355b3a1b8fb8b573$var$encodePathParam(value, decodeCharMap) {
    let encoded = encodeURIComponent(value);
    if (decodeCharMap) for (const [encodedChar, char] of decodeCharMap)encoded = encoded.replaceAll(encodedChar, char);
    return encoded;
}
function $355b3a1b8fb8b573$export$b71b01274a8bb9ec(basepath, currentPathname, matchLocation) {
    const pathParams = $355b3a1b8fb8b573$export$75c4533b77b2c7d6(basepath, currentPathname, matchLocation);
    if (matchLocation.to && !pathParams) return;
    return pathParams ?? {};
}
function $355b3a1b8fb8b573$export$544e093309626785(basepath, pathname, caseSensitive = false) {
    const normalizedBasepath = caseSensitive ? basepath : basepath.toLowerCase();
    const normalizedPathname = caseSensitive ? pathname : pathname.toLowerCase();
    switch(true){
        // default behaviour is to serve app from the root - pathname
        // left untouched
        case normalizedBasepath === "/":
            return pathname;
        // shortcut for removing the basepath if it matches the pathname
        case normalizedPathname === normalizedBasepath:
            return "";
        // in case pathname is shorter than basepath - there is
        // nothing to remove
        case pathname.length < basepath.length:
            return pathname;
        // avoid matching partial segments - strict equality handled
        // earlier, otherwise, basepath separated from pathname with
        // separator, therefore lack of separator means partial
        // segment match (`/app` should not match `/application`)
        case normalizedPathname[normalizedBasepath.length] !== "/":
            return pathname;
        // remove the basepath from the pathname if it starts with it
        case normalizedPathname.startsWith(normalizedBasepath):
            return pathname.slice(basepath.length);
        // otherwise, return the pathname as is
        default:
            return pathname;
    }
}
function $355b3a1b8fb8b573$export$75c4533b77b2c7d6(basepath, from, matchLocation) {
    if (basepath !== "/" && !from.startsWith(basepath)) return void 0;
    from = $355b3a1b8fb8b573$export$544e093309626785(basepath, from, matchLocation.caseSensitive);
    const to = $355b3a1b8fb8b573$export$544e093309626785(basepath, `${matchLocation.to ?? "$"}`, matchLocation.caseSensitive);
    const baseSegments = $355b3a1b8fb8b573$export$7fafb205ecc26684(from);
    const routeSegments = $355b3a1b8fb8b573$export$7fafb205ecc26684(to);
    if (!from.startsWith("/")) baseSegments.unshift({
        type: "pathname",
        value: "/"
    });
    if (!to.startsWith("/")) routeSegments.unshift({
        type: "pathname",
        value: "/"
    });
    const params = {};
    const isMatch = (()=>{
        for(let i = 0; i < Math.max(baseSegments.length, routeSegments.length); i++){
            const baseSegment = baseSegments[i];
            const routeSegment = routeSegments[i];
            const isLastBaseSegment = i >= baseSegments.length - 1;
            const isLastRouteSegment = i >= routeSegments.length - 1;
            if (routeSegment) {
                if (routeSegment.type === "wildcard") {
                    const _splat = decodeURI($355b3a1b8fb8b573$export$86d9a7913e44197e(baseSegments.slice(i).map((d)=>d.value)));
                    params["*"] = _splat;
                    params["_splat"] = _splat;
                    return true;
                }
                if (routeSegment.type === "pathname") {
                    if (routeSegment.value === "/" && !(baseSegment == null ? void 0 : baseSegment.value)) return true;
                    if (baseSegment) {
                        if (matchLocation.caseSensitive) {
                            if (routeSegment.value !== baseSegment.value) return false;
                        } else if (routeSegment.value.toLowerCase() !== baseSegment.value.toLowerCase()) return false;
                    }
                }
                if (!baseSegment) return false;
                if (routeSegment.type === "param") {
                    if (baseSegment.value === "/") return false;
                    if (baseSegment.value.charAt(0) !== "$") params[routeSegment.value.substring(1)] = decodeURIComponent(baseSegment.value);
                }
            }
            if (!isLastBaseSegment && isLastRouteSegment) {
                params["**"] = $355b3a1b8fb8b573$export$86d9a7913e44197e(baseSegments.slice(i + 1).map((d)=>d.value));
                return !!matchLocation.fuzzy && (routeSegment == null ? void 0 : routeSegment.value) !== "/";
            }
        }
        return true;
    })();
    return isMatch ? params : void 0;
}

const $00bc6db601cb5ffd$export$463ffa9af37e9ec5 = "__root__";



var $acw62 = parcelRequire("acw62");

var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));



class $a5144f48fa9ca142$export$390f32400eaf98c9 {
    constructor(initialState, options){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = (listener)=>{
            var _a, _b;
            this.listeners.add(listener);
            const unsub = (_b = (_a = this.options) == null ? void 0 : _a.onSubscribe) == null ? void 0 : _b.call(_a, listener, this);
            return ()=>{
                this.listeners.delete(listener);
                unsub == null || unsub();
            };
        };
        this.setState = (updater)=>{
            var _a, _b, _c;
            this.prevState = this.state;
            this.state = ((_a = this.options) == null ? void 0 : _a.updateFn) ? this.options.updateFn(this.prevState)(updater) : updater(this.prevState);
            (_c = (_b = this.options) == null ? void 0 : _b.onUpdate) == null || _c.call(_b);
            (0, $9203abc22ef76827$export$d16108b43947c855)(this);
        };
        this.prevState = initialState;
        this.state = initialState;
        this.options = options;
    }
}



class $42fbfc85bdc4b21b$export$2c3752e51f317165 {
    constructor(options){
        this.listeners = /* @__PURE__ */ new Set();
        this._subscriptions = [];
        this.lastSeenDepValues = [];
        this.getDepVals = ()=>{
            const prevDepVals = [];
            const currDepVals = [];
            for (const dep of this.options.deps){
                prevDepVals.push(dep.prevState);
                currDepVals.push(dep.state);
            }
            this.lastSeenDepValues = currDepVals;
            return {
                prevDepVals: prevDepVals,
                currDepVals: currDepVals,
                prevVal: this.prevState ?? void 0
            };
        };
        this.recompute = ()=>{
            var _a, _b;
            this.prevState = this.state;
            const { prevDepVals: prevDepVals, currDepVals: currDepVals, prevVal: prevVal } = this.getDepVals();
            this.state = this.options.fn({
                prevDepVals: prevDepVals,
                currDepVals: currDepVals,
                prevVal: prevVal
            });
            (_b = (_a = this.options).onUpdate) == null || _b.call(_a);
        };
        this.checkIfRecalculationNeededDeeply = ()=>{
            for (const dep of this.options.deps)if (dep instanceof $42fbfc85bdc4b21b$export$2c3752e51f317165) dep.checkIfRecalculationNeededDeeply();
            let shouldRecompute = false;
            const lastSeenDepValues = this.lastSeenDepValues;
            const { currDepVals: currDepVals } = this.getDepVals();
            for(let i = 0; i < currDepVals.length; i++)if (currDepVals[i] !== lastSeenDepValues[i]) {
                shouldRecompute = true;
                break;
            }
            if (shouldRecompute) this.recompute();
        };
        this.mount = ()=>{
            this.registerOnGraph();
            this.checkIfRecalculationNeededDeeply();
            return ()=>{
                this.unregisterFromGraph();
                for (const cleanup of this._subscriptions)cleanup();
            };
        };
        this.subscribe = (listener)=>{
            var _a, _b;
            this.listeners.add(listener);
            const unsub = (_b = (_a = this.options).onSubscribe) == null ? void 0 : _b.call(_a, listener, this);
            return ()=>{
                this.listeners.delete(listener);
                unsub == null || unsub();
            };
        };
        this.options = options;
        this.state = options.fn({
            prevDepVals: void 0,
            prevVal: void 0,
            currDepVals: this.getDepVals().currDepVals
        });
    }
    registerOnGraph(deps = this.options.deps) {
        for (const dep of deps){
            if (dep instanceof $42fbfc85bdc4b21b$export$2c3752e51f317165) {
                dep.registerOnGraph();
                this.registerOnGraph(dep.options.deps);
            } else if (dep instanceof (0, $a5144f48fa9ca142$export$390f32400eaf98c9)) {
                let relatedLinkedDerivedVals = (0, $9203abc22ef76827$export$9ea173589b25e8f7).get(dep);
                if (!relatedLinkedDerivedVals) {
                    relatedLinkedDerivedVals = /* @__PURE__ */ new Set();
                    (0, $9203abc22ef76827$export$9ea173589b25e8f7).set(dep, relatedLinkedDerivedVals);
                }
                relatedLinkedDerivedVals.add(this);
                let relatedStores = (0, $9203abc22ef76827$export$2c0006798420b80d).get(this);
                if (!relatedStores) {
                    relatedStores = /* @__PURE__ */ new Set();
                    (0, $9203abc22ef76827$export$2c0006798420b80d).set(this, relatedStores);
                }
                relatedStores.add(dep);
            }
        }
    }
    unregisterFromGraph(deps = this.options.deps) {
        for (const dep of deps){
            if (dep instanceof $42fbfc85bdc4b21b$export$2c3752e51f317165) this.unregisterFromGraph(dep.options.deps);
            else if (dep instanceof (0, $a5144f48fa9ca142$export$390f32400eaf98c9)) {
                const relatedLinkedDerivedVals = (0, $9203abc22ef76827$export$9ea173589b25e8f7).get(dep);
                if (relatedLinkedDerivedVals) relatedLinkedDerivedVals.delete(this);
                const relatedStores = (0, $9203abc22ef76827$export$2c0006798420b80d).get(this);
                if (relatedStores) relatedStores.delete(dep);
            }
        }
    }
}


const $9203abc22ef76827$export$9ea173589b25e8f7 = /* @__PURE__ */ new WeakMap();
const $9203abc22ef76827$export$2c0006798420b80d = /* @__PURE__ */ new WeakMap();
const $9203abc22ef76827$export$51a293a41f5b4b6e = {
    current: []
};
let $9203abc22ef76827$var$__isFlushing = false;
let $9203abc22ef76827$var$__batchDepth = 0;
const $9203abc22ef76827$var$__pendingUpdates = /* @__PURE__ */ new Set();
const $9203abc22ef76827$var$__initialBatchValues = /* @__PURE__ */ new Map();
function $9203abc22ef76827$var$__flush_internals(relatedVals) {
    const sorted = Array.from(relatedVals).sort((a, b)=>{
        if (a instanceof (0, $42fbfc85bdc4b21b$export$2c3752e51f317165) && a.options.deps.includes(b)) return 1;
        if (b instanceof (0, $42fbfc85bdc4b21b$export$2c3752e51f317165) && b.options.deps.includes(a)) return -1;
        return 0;
    });
    for (const derived of sorted){
        if ($9203abc22ef76827$export$51a293a41f5b4b6e.current.includes(derived)) continue;
        $9203abc22ef76827$export$51a293a41f5b4b6e.current.push(derived);
        derived.recompute();
        const stores = $9203abc22ef76827$export$2c0006798420b80d.get(derived);
        if (stores) for (const store of stores){
            const relatedLinkedDerivedVals = $9203abc22ef76827$export$9ea173589b25e8f7.get(store);
            if (!relatedLinkedDerivedVals) continue;
            $9203abc22ef76827$var$__flush_internals(relatedLinkedDerivedVals);
        }
    }
}
function $9203abc22ef76827$var$__notifyListeners(store) {
    store.listeners.forEach((listener)=>listener({
            prevVal: store.prevState,
            currentVal: store.state
        }));
}
function $9203abc22ef76827$var$__notifyDerivedListeners(derived) {
    derived.listeners.forEach((listener)=>listener({
            prevVal: derived.prevState,
            currentVal: derived.state
        }));
}
function $9203abc22ef76827$export$d16108b43947c855(store) {
    if ($9203abc22ef76827$var$__batchDepth > 0 && !$9203abc22ef76827$var$__initialBatchValues.has(store)) $9203abc22ef76827$var$__initialBatchValues.set(store, store.prevState);
    $9203abc22ef76827$var$__pendingUpdates.add(store);
    if ($9203abc22ef76827$var$__batchDepth > 0) return;
    if ($9203abc22ef76827$var$__isFlushing) return;
    try {
        $9203abc22ef76827$var$__isFlushing = true;
        while($9203abc22ef76827$var$__pendingUpdates.size > 0){
            const stores = Array.from($9203abc22ef76827$var$__pendingUpdates);
            $9203abc22ef76827$var$__pendingUpdates.clear();
            for (const store2 of stores){
                const prevState = $9203abc22ef76827$var$__initialBatchValues.get(store2) ?? store2.prevState;
                store2.prevState = prevState;
                $9203abc22ef76827$var$__notifyListeners(store2);
            }
            for (const store2 of stores){
                const derivedVals = $9203abc22ef76827$export$9ea173589b25e8f7.get(store2);
                if (!derivedVals) continue;
                $9203abc22ef76827$export$51a293a41f5b4b6e.current.push(store2);
                $9203abc22ef76827$var$__flush_internals(derivedVals);
            }
            for (const store2 of stores){
                const derivedVals = $9203abc22ef76827$export$9ea173589b25e8f7.get(store2);
                if (!derivedVals) continue;
                for (const derived of derivedVals)$9203abc22ef76827$var$__notifyDerivedListeners(derived);
            }
        }
    } finally{
        $9203abc22ef76827$var$__isFlushing = false;
        $9203abc22ef76827$export$51a293a41f5b4b6e.current = [];
        $9203abc22ef76827$var$__initialBatchValues.clear();
    }
}
function $9203abc22ef76827$export$712ea50be43a7858(fn) {
    $9203abc22ef76827$var$__batchDepth++;
    try {
        fn();
    } finally{
        $9203abc22ef76827$var$__batchDepth--;
        if ($9203abc22ef76827$var$__batchDepth === 0) {
            const pendingUpdateToFlush = Array.from($9203abc22ef76827$var$__pendingUpdates)[0];
            if (pendingUpdateToFlush) $9203abc22ef76827$export$d16108b43947c855(pendingUpdateToFlush);
        }
    }
}


function $db9d004627497951$export$6ccbb43953eebf8(store, selector = (d)=>d) {
    const slice = (0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector)(store.subscribe, ()=>store.state, ()=>store.state, selector, $db9d004627497951$export$26c89aaec4eb1d2e);
    return slice;
}
function $db9d004627497951$export$26c89aaec4eb1d2e(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for (const [k, v] of objA){
            if (!objB.has(k) || !Object.is(v, objB.get(k))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for (const v of objA){
            if (!objB.has(v)) return false;
        }
        return true;
    }
    const keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;



var $acw62 = parcelRequire("acw62");
const $3f2225d1bbed6ddd$var$routerContext = $acw62.createContext(null);
function $3f2225d1bbed6ddd$export$65bef39336c189ee() {
    if (typeof document === "undefined") return $3f2225d1bbed6ddd$var$routerContext;
    if (window.__TSR_ROUTER_CONTEXT__) return window.__TSR_ROUTER_CONTEXT__;
    window.__TSR_ROUTER_CONTEXT__ = $3f2225d1bbed6ddd$var$routerContext;
    return $3f2225d1bbed6ddd$var$routerContext;
}


function $593b7c255e59942d$export$9a302a45f65d0572(opts) {
    const value = $acw62.useContext((0, $3f2225d1bbed6ddd$export$65bef39336c189ee)());
    (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(!(((opts == null ? void 0 : opts.warn) ?? true) && !value), "useRouter must be used inside a <RouterProvider> component!");
    return value;
}


function $5e4aaffff2c3630e$export$dbb5ccc270afbbb4(opts) {
    const contextRouter = (0, $593b7c255e59942d$export$9a302a45f65d0572)({
        warn: (opts == null ? void 0 : opts.router) === void 0
    });
    const router = (opts == null ? void 0 : opts.router) || contextRouter;
    const previousResult = (0, $acw62.useRef)(void 0);
    return (0, $db9d004627497951$export$6ccbb43953eebf8)(router.__store, (state)=>{
        if (opts == null ? void 0 : opts.select) {
            if (opts.structuralSharing ?? router.options.defaultStructuralSharing) {
                const newSlice = (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousResult.current, opts.select(state));
                previousResult.current = newSlice;
                return newSlice;
            }
            return opts.select(state);
        }
        return state;
    });
}



var $acw62 = parcelRequire("acw62");
const $bcdbf2acdfde29b9$export$f6b3e78d35813d66 = $acw62.createContext(void 0);
const $bcdbf2acdfde29b9$export$c7522a034e937c0c = $acw62.createContext(void 0);


function $de3e60c6a5d77104$export$6c330e8992e8a295(opts) {
    const nearestMatchId = $acw62.useContext(opts.from ? (0, $bcdbf2acdfde29b9$export$c7522a034e937c0c) : (0, $bcdbf2acdfde29b9$export$f6b3e78d35813d66));
    const matchSelection = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (state)=>{
            const match = state.matches.find((d)=>opts.from ? opts.from === d.routeId : d.id === nearestMatchId);
            (0, $85f606e562c81b96$export$2e2bcd8739ae039)(!((opts.shouldThrow ?? true) && !match), `Could not find ${opts.from ? `an active match from "${opts.from}"` : "a nearest match!"}`);
            if (match === void 0) return void 0;
            return opts.select ? opts.select(match) : match;
        },
        structuralSharing: opts.structuralSharing
    });
    return matchSelection;
}


function $0aead981e3ddc2c7$export$1448a5050d252c4d(opts) {
    return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
        from: opts.from,
        strict: opts.strict,
        structuralSharing: opts.structuralSharing,
        select: (s)=>{
            return opts.select ? opts.select(s.loaderData) : s.loaderData;
        }
    });
}



function $4182cab2867f93dc$export$5b1319df652b0246(opts) {
    const { select: select, ...rest } = opts;
    return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
        ...rest,
        select: (s)=>{
            return select ? select(s.loaderDeps) : s.loaderDeps;
        }
    });
}



function $8b861401cb8bbdf3$export$99eaa27ddbbb95ef(opts) {
    return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
        from: opts.from,
        strict: opts.strict,
        shouldThrow: opts.shouldThrow,
        structuralSharing: opts.structuralSharing,
        select: (match)=>{
            return opts.select ? opts.select(match.params) : match.params;
        }
    });
}



function $40e96617f80eda0b$export$bd221a7c56b93941(opts) {
    return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
        from: opts.from,
        strict: opts.strict,
        shouldThrow: opts.shouldThrow,
        structuralSharing: opts.structuralSharing,
        select: (match)=>{
            return opts.select ? opts.select(match.search) : match.search;
        }
    });
}





var $acw62 = parcelRequire("acw62");
function $145e97952daea58a$export$d924b55053fc70c(props) {
    const errorComponent = props.errorComponent ?? $145e97952daea58a$export$65db35c377fab04b;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($145e97952daea58a$var$CatchBoundaryImpl, {
        getResetKey: props.getResetKey,
        onCatch: props.onCatch,
        children: ({ error: error, reset: reset })=>{
            if (error) return $acw62.createElement(errorComponent, {
                error: error,
                reset: reset
            });
            return props.children;
        }
    });
}
class $145e97952daea58a$var$CatchBoundaryImpl extends $acw62.Component {
    constructor(){
        super(...arguments);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromProps(props) {
        return {
            resetKey: props.getResetKey()
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    reset() {
        this.setState({
            error: null
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.error && prevState.resetKey !== this.state.resetKey) this.reset();
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onCatch) this.props.onCatch(error, errorInfo);
    }
    render() {
        return this.props.children({
            error: this.state.resetKey !== this.props.getResetKey() ? null : this.state.error,
            reset: ()=>{
                this.reset();
            }
        });
    }
}
function $145e97952daea58a$export$65db35c377fab04b({ error: error }) {
    const [show, setShow] = $acw62.useState(false);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            padding: ".5rem",
            maxWidth: "100%"
        },
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem"
                },
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("strong", {
                        style: {
                            fontSize: "1rem"
                        },
                        children: "Something went wrong!"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                        style: {
                            appearance: "none",
                            fontSize: ".6em",
                            border: "1px solid currentColor",
                            padding: ".1rem .2rem",
                            fontWeight: "bold",
                            borderRadius: ".25rem"
                        },
                        onClick: ()=>setShow((d)=>!d),
                        children: show ? "Hide Error" : "Show Error"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    height: ".25rem"
                }
            }),
            show ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("pre", {
                    style: {
                        fontSize: ".7em",
                        border: "1px solid red",
                        borderRadius: ".25rem",
                        padding: ".3rem",
                        color: "red",
                        overflow: "auto"
                    },
                    children: error.message ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("code", {
                        children: error.message
                    }) : null
                })
            }) : null
        ]
    });
}



function $b6f3b75e7e86ba46$export$a33e918cb4258370(options = {}) {
    options.isNotFound = true;
    if (options.throw) throw options;
    return options;
}
function $b6f3b75e7e86ba46$export$5ceecc1876a33e64(obj) {
    return !!(obj == null ? void 0 : obj.isNotFound);
}
function $b6f3b75e7e86ba46$export$5b0f5088d44b945c(props) {
    const resetKey = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>`not-found-${s.location.pathname}-${s.status}`
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $145e97952daea58a$export$d924b55053fc70c), {
        getResetKey: ()=>resetKey,
        onCatch: (error, errorInfo)=>{
            var _a;
            if ($b6f3b75e7e86ba46$export$5ceecc1876a33e64(error)) (_a = props.onCatch) == null || _a.call(props, error, errorInfo);
            else throw error;
        },
        errorComponent: ({ error: error })=>{
            var _a;
            if ($b6f3b75e7e86ba46$export$5ceecc1876a33e64(error)) return (_a = props.fallback) == null ? void 0 : _a.call(props, error);
            else throw error;
        },
        children: props.children
    });
}
function $b6f3b75e7e86ba46$export$8d79a25eb6fbadf1() {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("p", {
        children: "Not Found"
    });
}



var $acw62 = parcelRequire("acw62");

function $5d305f5a992c45af$export$9770f232ac06a008(_defaultOpts) {
    const { navigate: navigate } = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    return $acw62.useCallback((options)=>{
        return navigate({
            ...options
        });
    }, [
        navigate
    ]);
}
function $5d305f5a992c45af$export$444b3ab0cb9aec40(props) {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const previousPropsRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (previousPropsRef.current !== props) {
            router.navigate({
                ...props
            });
            previousPropsRef.current = props;
        }
    }, [
        router,
        props
    ]);
    return null;
}



function $e621c732959f7f46$export$2126b6733cfe90ec(id) {
    return new $e621c732959f7f46$export$18266edfd2f3dc40({
        id: id
    });
}
class $e621c732959f7f46$export$18266edfd2f3dc40 {
    /**
   * @deprecated Use the `getRouteApi` function instead.
   */ constructor({ id: id }){
        this.useMatch = (opts)=>{
            return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
                select: opts == null ? void 0 : opts.select,
                from: this.id,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
                from: this.id,
                select: (d)=>(opts == null ? void 0 : opts.select) ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, $40e96617f80eda0b$export$bd221a7c56b93941)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, $8b861401cb8bbdf3$export$99eaa27ddbbb95ef)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, $4182cab2867f93dc$export$5b1319df652b0246)({
                ...opts,
                from: this.id,
                strict: false
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, $0aead981e3ddc2c7$export$1448a5050d252c4d)({
                ...opts,
                from: this.id,
                strict: false
            });
        };
        this.useNavigate = ()=>{
            return (0, $5d305f5a992c45af$export$9770f232ac06a008)({
                from: this.id
            });
        };
        this.notFound = (opts)=>{
            return (0, $b6f3b75e7e86ba46$export$a33e918cb4258370)({
                routeId: this.id,
                ...opts
            });
        };
        this.id = id;
    }
}
class $e621c732959f7f46$export$e7b0ac011bb776c6 {
    /**
   * @deprecated Use the `createRoute` function instead.
   */ constructor(options){
        this.init = (opts)=>{
            var _a, _b;
            this.originalIndex = opts.originalIndex;
            const options2 = this.options;
            const isRoot = !(options2 == null ? void 0 : options2.path) && !(options2 == null ? void 0 : options2.id);
            this.parentRoute = (_b = (_a = this.options).getParentRoute) == null ? void 0 : _b.call(_a);
            if (isRoot) this._path = (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5);
            else (0, $85f606e562c81b96$export$2e2bcd8739ae039)(this.parentRoute, `Child Route instances must pass a 'getParentRoute: () => ParentRoute' option that returns a Route instance.`);
            let path = isRoot ? (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5) : options2.path;
            if (path && path !== "/") path = (0, $355b3a1b8fb8b573$export$47150f29cd1fb3ae)(path);
            const customId = (options2 == null ? void 0 : options2.id) || path;
            let id = isRoot ? (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5) : (0, $355b3a1b8fb8b573$export$86d9a7913e44197e)([
                this.parentRoute.id === (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5) ? "" : this.parentRoute.id,
                customId
            ]);
            if (path === (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5)) path = "/";
            if (id !== (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5)) id = (0, $355b3a1b8fb8b573$export$86d9a7913e44197e)([
                "/",
                id
            ]);
            const fullPath = id === (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5) ? "/" : (0, $355b3a1b8fb8b573$export$86d9a7913e44197e)([
                this.parentRoute.fullPath,
                path
            ]);
            this._path = path;
            this._id = id;
            this._fullPath = fullPath;
            this._to = fullPath;
            this._ssr = (options2 == null ? void 0 : options2.ssr) ?? opts.defaultSsr ?? true;
        };
        this.updateLoader = (options2)=>{
            Object.assign(this.options, options2);
            return this;
        };
        this.update = (options2)=>{
            Object.assign(this.options, options2);
            return this;
        };
        this.lazy = (lazyFn)=>{
            this.lazyFn = lazyFn;
            return this;
        };
        this.useMatch = (opts)=>{
            return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
                select: opts == null ? void 0 : opts.select,
                from: this.id,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing
            });
        };
        this.useRouteContext = (opts)=>{
            return (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
                ...opts,
                from: this.id,
                select: (d)=>(opts == null ? void 0 : opts.select) ? opts.select(d.context) : d.context
            });
        };
        this.useSearch = (opts)=>{
            return (0, $40e96617f80eda0b$export$bd221a7c56b93941)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useParams = (opts)=>{
            return (0, $8b861401cb8bbdf3$export$99eaa27ddbbb95ef)({
                select: opts == null ? void 0 : opts.select,
                structuralSharing: opts == null ? void 0 : opts.structuralSharing,
                from: this.id
            });
        };
        this.useLoaderDeps = (opts)=>{
            return (0, $4182cab2867f93dc$export$5b1319df652b0246)({
                ...opts,
                from: this.id
            });
        };
        this.useLoaderData = (opts)=>{
            return (0, $0aead981e3ddc2c7$export$1448a5050d252c4d)({
                ...opts,
                from: this.id
            });
        };
        this.useNavigate = ()=>{
            return (0, $5d305f5a992c45af$export$9770f232ac06a008)({
                from: this.id
            });
        };
        this.options = options || {};
        this.isRoot = !(options == null ? void 0 : options.getParentRoute);
        (0, $85f606e562c81b96$export$2e2bcd8739ae039)(!((options == null ? void 0 : options.id) && (options == null ? void 0 : options.path)), `Route cannot have both an 'id' and a 'path' option.`);
        this.$$typeof = Symbol.for("react.memo");
    }
    get to() {
        return this._to;
    }
    get id() {
        return this._id;
    }
    get path() {
        return this._path;
    }
    get fullPath() {
        return this._fullPath;
    }
    get ssr() {
        return this._ssr;
    }
    addChildren(children) {
        return this._addFileChildren(children);
    }
    _addFileChildren(children) {
        if (Array.isArray(children)) this.children = children;
        if (typeof children === "object" && children !== null) this.children = Object.values(children);
        return this;
    }
}
function $e621c732959f7f46$export$544c268deaca2597(options) {
    return new $e621c732959f7f46$export$e7b0ac011bb776c6(options);
}
function $e621c732959f7f46$export$85dd0dd8ccd4f994() {
    return (options)=>{
        return $e621c732959f7f46$export$f20dca7d42ad6c55(options);
    };
}
const $e621c732959f7f46$export$c4c228ca163d4e39 = $e621c732959f7f46$export$85dd0dd8ccd4f994;
class $e621c732959f7f46$export$6bfafc1e0f16edbd extends $e621c732959f7f46$export$e7b0ac011bb776c6 {
    /**
   * @deprecated `RootRoute` is now an internal implementation detail. Use `createRootRoute()` instead.
   */ constructor(options){
        super(options);
    }
    addChildren(children) {
        super.addChildren(children);
        return this;
    }
    _addFileChildren(children) {
        super._addFileChildren(children);
        return this;
    }
    _addFileTypes() {
        return this;
    }
}
function $e621c732959f7f46$export$f20dca7d42ad6c55(options) {
    return new $e621c732959f7f46$export$6bfafc1e0f16edbd(options);
}
function $e621c732959f7f46$export$9b5cbca98b37c390(opts) {
    return opts;
}
class $e621c732959f7f46$export$e389bcff300d6f45 extends $e621c732959f7f46$export$e7b0ac011bb776c6 {
    constructor(options){
        super({
            ...options,
            id: "404"
        });
    }
}

const $dfedaba89c5e8834$var$stateIndexKey = "__TSR_index";
const $dfedaba89c5e8834$var$popStateEvent = "popstate";
const $dfedaba89c5e8834$var$beforeUnloadEvent = "beforeunload";
function $dfedaba89c5e8834$export$4178d7ac16e6cf7c(opts) {
    let location = opts.getLocation();
    const subscribers = /* @__PURE__ */ new Set();
    const notify = (action)=>{
        location = opts.getLocation();
        subscribers.forEach((subscriber)=>subscriber({
                location: location,
                action: action
            }));
    };
    const handleIndexChange = (action)=>{
        if (opts.notifyOnIndexChange ?? true) notify(action);
        else location = opts.getLocation();
    };
    const tryNavigation = async ({ task: task, navigateOpts: navigateOpts, ...actionInfo })=>{
        var _a, _b;
        const ignoreBlocker = (navigateOpts == null ? void 0 : navigateOpts.ignoreBlocker) ?? false;
        if (ignoreBlocker) {
            task();
            return;
        }
        const blockers = ((_a = opts.getBlockers) == null ? void 0 : _a.call(opts)) ?? [];
        const isPushOrReplace = actionInfo.type === "PUSH" || actionInfo.type === "REPLACE";
        if (typeof document !== "undefined" && blockers.length && isPushOrReplace) for (const blocker of blockers){
            const nextLocation = $dfedaba89c5e8834$export$c68fd8c8a50e78e(actionInfo.path, actionInfo.state);
            const isBlocked = await blocker.blockerFn({
                currentLocation: location,
                nextLocation: nextLocation,
                action: actionInfo.type
            });
            if (isBlocked) {
                (_b = opts.onBlocked) == null || _b.call(opts);
                return;
            }
        }
        task();
    };
    return {
        get location () {
            return location;
        },
        get length () {
            return opts.getLength();
        },
        subscribers: subscribers,
        subscribe: (cb)=>{
            subscribers.add(cb);
            return ()=>{
                subscribers.delete(cb);
            };
        },
        push: (path, state, navigateOpts)=>{
            const currentIndex = location.state[$dfedaba89c5e8834$var$stateIndexKey];
            state = $dfedaba89c5e8834$var$assignKeyAndIndex(currentIndex + 1, state);
            tryNavigation({
                task: ()=>{
                    opts.pushState(path, state);
                    notify({
                        type: "PUSH"
                    });
                },
                navigateOpts: navigateOpts,
                type: "PUSH",
                path: path,
                state: state
            });
        },
        replace: (path, state, navigateOpts)=>{
            const currentIndex = location.state[$dfedaba89c5e8834$var$stateIndexKey];
            state = $dfedaba89c5e8834$var$assignKeyAndIndex(currentIndex, state);
            tryNavigation({
                task: ()=>{
                    opts.replaceState(path, state);
                    notify({
                        type: "REPLACE"
                    });
                },
                navigateOpts: navigateOpts,
                type: "REPLACE",
                path: path,
                state: state
            });
        },
        go: (index, navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.go(index);
                    handleIndexChange({
                        type: "GO",
                        index: index
                    });
                },
                navigateOpts: navigateOpts,
                type: "GO"
            });
        },
        back: (navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.back((navigateOpts == null ? void 0 : navigateOpts.ignoreBlocker) ?? false);
                    handleIndexChange({
                        type: "BACK"
                    });
                },
                navigateOpts: navigateOpts,
                type: "BACK"
            });
        },
        forward: (navigateOpts)=>{
            tryNavigation({
                task: ()=>{
                    opts.forward((navigateOpts == null ? void 0 : navigateOpts.ignoreBlocker) ?? false);
                    handleIndexChange({
                        type: "FORWARD"
                    });
                },
                navigateOpts: navigateOpts,
                type: "FORWARD"
            });
        },
        canGoBack: ()=>location.state[$dfedaba89c5e8834$var$stateIndexKey] !== 0,
        createHref: (str)=>opts.createHref(str),
        block: (blocker)=>{
            var _a;
            if (!opts.setBlockers) return ()=>{};
            const blockers = ((_a = opts.getBlockers) == null ? void 0 : _a.call(opts)) ?? [];
            opts.setBlockers([
                ...blockers,
                blocker
            ]);
            return ()=>{
                var _a2, _b;
                const blockers2 = ((_a2 = opts.getBlockers) == null ? void 0 : _a2.call(opts)) ?? [];
                (_b = opts.setBlockers) == null || _b.call(opts, blockers2.filter((b)=>b !== blocker));
            };
        },
        flush: ()=>{
            var _a;
            return (_a = opts.flush) == null ? void 0 : _a.call(opts);
        },
        destroy: ()=>{
            var _a;
            return (_a = opts.destroy) == null ? void 0 : _a.call(opts);
        },
        notify: notify
    };
}
function $dfedaba89c5e8834$var$assignKeyAndIndex(index, state) {
    if (!state) state = {};
    return {
        ...state,
        key: $dfedaba89c5e8834$var$createRandomKey(),
        [$dfedaba89c5e8834$var$stateIndexKey]: index
    };
}
function $dfedaba89c5e8834$export$719fc203c4e16dee(opts) {
    var _a;
    const win = (opts == null ? void 0 : opts.window) ?? (typeof document !== "undefined" ? window : void 0);
    const originalPushState = win.history.pushState;
    const originalReplaceState = win.history.replaceState;
    let blockers = [];
    const _getBlockers = ()=>blockers;
    const _setBlockers = (newBlockers)=>blockers = newBlockers;
    const createHref = (opts == null ? void 0 : opts.createHref) ?? ((path)=>path);
    const parseLocation = (opts == null ? void 0 : opts.parseLocation) ?? (()=>$dfedaba89c5e8834$export$c68fd8c8a50e78e(`${win.location.pathname}${win.location.search}${win.location.hash}`, win.history.state));
    if (!((_a = win.history.state) == null ? void 0 : _a.key)) win.history.replaceState({
        [$dfedaba89c5e8834$var$stateIndexKey]: 0,
        key: $dfedaba89c5e8834$var$createRandomKey()
    }, "");
    let currentLocation = parseLocation();
    let rollbackLocation;
    let nextPopIsGo = false;
    let ignoreNextPop = false;
    let skipBlockerNextPop = false;
    let ignoreNextBeforeUnload = false;
    const getLocation = ()=>currentLocation;
    let next;
    let scheduled;
    const flush = ()=>{
        if (!next) return;
        history._ignoreSubscribers = true;
        (next.isPush ? win.history.pushState : win.history.replaceState)(next.state, "", next.href);
        history._ignoreSubscribers = false;
        next = void 0;
        scheduled = void 0;
        rollbackLocation = void 0;
    };
    const queueHistoryAction = (type, destHref, state)=>{
        const href = createHref(destHref);
        if (!scheduled) rollbackLocation = currentLocation;
        currentLocation = $dfedaba89c5e8834$export$c68fd8c8a50e78e(destHref, state);
        next = {
            href: href,
            state: state,
            isPush: (next == null ? void 0 : next.isPush) || type === "push"
        };
        if (!scheduled) scheduled = Promise.resolve().then(()=>flush());
    };
    const onPushPop = (type)=>{
        currentLocation = parseLocation();
        history.notify({
            type: type
        });
    };
    const onPushPopEvent = async ()=>{
        if (ignoreNextPop) {
            ignoreNextPop = false;
            return;
        }
        const nextLocation = parseLocation();
        const delta = nextLocation.state[$dfedaba89c5e8834$var$stateIndexKey] - currentLocation.state[$dfedaba89c5e8834$var$stateIndexKey];
        const isForward = delta === 1;
        const isBack = delta === -1;
        const isGo = !isForward && !isBack || nextPopIsGo;
        nextPopIsGo = false;
        const action = isGo ? "GO" : isBack ? "BACK" : "FORWARD";
        const notify = isGo ? {
            type: "GO",
            index: delta
        } : {
            type: isBack ? "BACK" : "FORWARD"
        };
        if (skipBlockerNextPop) skipBlockerNextPop = false;
        else {
            const blockers2 = _getBlockers();
            if (typeof document !== "undefined" && blockers2.length) for (const blocker of blockers2){
                const isBlocked = await blocker.blockerFn({
                    currentLocation: currentLocation,
                    nextLocation: nextLocation,
                    action: action
                });
                if (isBlocked) {
                    ignoreNextPop = true;
                    win.history.go(1);
                    history.notify(notify);
                    return;
                }
            }
        }
        currentLocation = parseLocation();
        history.notify(notify);
    };
    const onBeforeUnload = (e)=>{
        if (ignoreNextBeforeUnload) {
            ignoreNextBeforeUnload = false;
            return;
        }
        let shouldBlock = false;
        const blockers2 = _getBlockers();
        if (typeof document !== "undefined" && blockers2.length) for (const blocker of blockers2){
            const shouldHaveBeforeUnload = blocker.enableBeforeUnload ?? true;
            if (shouldHaveBeforeUnload === true) {
                shouldBlock = true;
                break;
            }
            if (typeof shouldHaveBeforeUnload === "function" && shouldHaveBeforeUnload() === true) {
                shouldBlock = true;
                break;
            }
        }
        if (shouldBlock) {
            e.preventDefault();
            return e.returnValue = "";
        }
        return;
    };
    const history = $dfedaba89c5e8834$export$4178d7ac16e6cf7c({
        getLocation: getLocation,
        getLength: ()=>win.history.length,
        pushState: (href, state)=>queueHistoryAction("push", href, state),
        replaceState: (href, state)=>queueHistoryAction("replace", href, state),
        back: (ignoreBlocker)=>{
            if (ignoreBlocker) skipBlockerNextPop = true;
            ignoreNextBeforeUnload = true;
            return win.history.back();
        },
        forward: (ignoreBlocker)=>{
            if (ignoreBlocker) skipBlockerNextPop = true;
            ignoreNextBeforeUnload = true;
            win.history.forward();
        },
        go: (n)=>{
            nextPopIsGo = true;
            win.history.go(n);
        },
        createHref: (href)=>createHref(href),
        flush: flush,
        destroy: ()=>{
            win.history.pushState = originalPushState;
            win.history.replaceState = originalReplaceState;
            win.removeEventListener($dfedaba89c5e8834$var$beforeUnloadEvent, onBeforeUnload, {
                capture: true
            });
            win.removeEventListener($dfedaba89c5e8834$var$popStateEvent, onPushPopEvent);
        },
        onBlocked: ()=>{
            if (rollbackLocation && currentLocation !== rollbackLocation) currentLocation = rollbackLocation;
        },
        getBlockers: _getBlockers,
        setBlockers: _setBlockers,
        notifyOnIndexChange: false
    });
    win.addEventListener($dfedaba89c5e8834$var$beforeUnloadEvent, onBeforeUnload, {
        capture: true
    });
    win.addEventListener($dfedaba89c5e8834$var$popStateEvent, onPushPopEvent);
    win.history.pushState = function(...args) {
        const res = originalPushState.apply(win.history, args);
        if (!history._ignoreSubscribers) onPushPop("PUSH");
        return res;
    };
    win.history.replaceState = function(...args) {
        const res = originalReplaceState.apply(win.history, args);
        if (!history._ignoreSubscribers) onPushPop("REPLACE");
        return res;
    };
    return history;
}
function $dfedaba89c5e8834$export$b71fdd3798280242(opts) {
    const win = (opts == null ? void 0 : opts.window) ?? (typeof document !== "undefined" ? window : void 0);
    return $dfedaba89c5e8834$export$719fc203c4e16dee({
        window: win,
        parseLocation: ()=>{
            const hashHref = win.location.hash.split("#").slice(1).join("#") ?? "/";
            return $dfedaba89c5e8834$export$c68fd8c8a50e78e(hashHref, win.history.state);
        },
        createHref: (href)=>`${win.location.pathname}${win.location.search}#${href}`
    });
}
function $dfedaba89c5e8834$export$2b76ad033c6e6d08(opts = {
    initialEntries: [
        "/"
    ]
}) {
    const entries = opts.initialEntries;
    let index = opts.initialIndex ? Math.min(Math.max(opts.initialIndex, 0), entries.length - 1) : entries.length - 1;
    const states = entries.map((_entry, index2)=>$dfedaba89c5e8834$var$assignKeyAndIndex(index2, void 0));
    const getLocation = ()=>$dfedaba89c5e8834$export$c68fd8c8a50e78e(entries[index], states[index]);
    return $dfedaba89c5e8834$export$4178d7ac16e6cf7c({
        getLocation: getLocation,
        getLength: ()=>entries.length,
        pushState: (path, state)=>{
            if (index < entries.length - 1) {
                entries.splice(index + 1);
                states.splice(index + 1);
            }
            states.push(state);
            entries.push(path);
            index = Math.max(entries.length - 1, 0);
        },
        replaceState: (path, state)=>{
            states[index] = state;
            entries[index] = path;
        },
        back: ()=>{
            index = Math.max(index - 1, 0);
        },
        forward: ()=>{
            index = Math.min(index + 1, entries.length - 1);
        },
        go: (n)=>{
            index = Math.min(Math.max(index + n, 0), entries.length - 1);
        },
        createHref: (path)=>path
    });
}
function $dfedaba89c5e8834$export$c68fd8c8a50e78e(href, state) {
    const hashIndex = href.indexOf("#");
    const searchIndex = href.indexOf("?");
    return {
        href: href,
        pathname: href.substring(0, hashIndex > 0 ? searchIndex > 0 ? Math.min(hashIndex, searchIndex) : hashIndex : searchIndex > 0 ? searchIndex : href.length),
        hash: hashIndex > -1 ? href.substring(hashIndex) : "",
        search: searchIndex > -1 ? href.slice(searchIndex, hashIndex === -1 ? void 0 : hashIndex) : "",
        state: state || {
            [$dfedaba89c5e8834$var$stateIndexKey]: 0,
            key: $dfedaba89c5e8834$var$createRandomKey()
        }
    };
}
function $dfedaba89c5e8834$var$createRandomKey() {
    return (Math.random() + 1).toString(36).substring(7);
}





function $7903562346daa9d8$export$c564cdbbe6da493(obj, pfx) {
    let k, i, tmp, str = "";
    for(k in obj)if ((tmp = obj[k]) !== void 0) {
        if (Array.isArray(tmp)) for(i = 0; i < tmp.length; i++){
            str && (str += "&");
            str += encodeURIComponent(k) + "=" + encodeURIComponent(tmp[i]);
        }
        else {
            str && (str += "&");
            str += encodeURIComponent(k) + "=" + encodeURIComponent(tmp);
        }
    }
    return (pfx || "") + str;
}
function $7903562346daa9d8$var$toValue(mix) {
    if (!mix) return "";
    const str = (0, $04e51d94e9f9f85e$export$bbcd8d1a495e51e2)(mix) ? decodeURIComponent(mix) : decodeURIComponent(encodeURIComponent(mix));
    if (str === "false") return false;
    if (str === "true") return true;
    return +str * 0 === 0 && +str + "" === str ? +str : str;
}
function $7903562346daa9d8$export$2f872c0f2117be69(str, pfx) {
    let tmp, k;
    const out = {}, arr = (pfx ? str.substr(pfx.length) : str).split("&");
    while(tmp = arr.shift()){
        const equalIndex = tmp.indexOf("=");
        if (equalIndex !== -1) {
            k = tmp.slice(0, equalIndex);
            k = decodeURIComponent(k);
            const value = tmp.slice(equalIndex + 1);
            if (out[k] !== void 0) out[k] = [].concat(out[k], $7903562346daa9d8$var$toValue(value));
            else out[k] = $7903562346daa9d8$var$toValue(value);
        } else {
            k = tmp;
            k = decodeURIComponent(k);
            out[k] = "";
        }
    }
    return out;
}


const $44c48fc48d718bd3$export$3d477def621690a6 = $44c48fc48d718bd3$export$d521d019d12eb80f(JSON.parse);
const $44c48fc48d718bd3$export$68863d04f13b25ce = $44c48fc48d718bd3$export$bee16cf4e0c1bf6(JSON.stringify, JSON.parse);
function $44c48fc48d718bd3$export$d521d019d12eb80f(parser) {
    return (searchStr)=>{
        if (searchStr.substring(0, 1) === "?") searchStr = searchStr.substring(1);
        const query = (0, $7903562346daa9d8$export$2f872c0f2117be69)(searchStr);
        for(const key in query){
            const value = query[key];
            if (typeof value === "string") try {
                query[key] = parser(value);
            } catch (err) {}
        }
        return query;
    };
}
function $44c48fc48d718bd3$export$bee16cf4e0c1bf6(stringify, parser) {
    function stringifyValue(val) {
        if (typeof val === "object" && val !== null) try {
            return stringify(val);
        } catch (err) {}
        else if (typeof val === "string" && typeof parser === "function") try {
            parser(val);
            return stringify(val);
        } catch (err) {}
        return val;
    }
    return (search)=>{
        search = {
            ...search
        };
        Object.keys(search).forEach((key)=>{
            const val = search[key];
            if (typeof val === "undefined" || val === void 0) delete search[key];
            else search[key] = stringifyValue(val);
        });
        const searchStr = (0, $7903562346daa9d8$export$c564cdbbe6da493)(search).toString();
        return searchStr ? `?${searchStr}` : "";
    };
}

function $683377acaa6ecdcc$export$ec485df5fdd355c3(err) {
    if (err instanceof Error) {
        const obj = {
            name: err.name,
            message: err.message
        };
        return obj;
    }
    return {
        data: err
    };
}
function $683377acaa6ecdcc$export$6c2b3e1c712e7fa6(routerState) {
    const fromLocation = routerState.resolvedLocation;
    const toLocation = routerState.location;
    const pathChanged = (fromLocation == null ? void 0 : fromLocation.pathname) !== toLocation.pathname;
    const hrefChanged = (fromLocation == null ? void 0 : fromLocation.href) !== toLocation.href;
    const hashChanged = (fromLocation == null ? void 0 : fromLocation.hash) !== toLocation.hash;
    return {
        fromLocation: fromLocation,
        toLocation: toLocation,
        pathChanged: pathChanged,
        hrefChanged: hrefChanged,
        hashChanged: hashChanged
    };
}


function $0102957b4ec7a2a4$export$89e12c5b50f7529d(opts) {
    opts.isRedirect = true;
    opts.statusCode = opts.statusCode || opts.code || 307;
    opts.headers = opts.headers || {};
    if (!opts.reloadDocument) {
        opts.reloadDocument = false;
        try {
            new URL(`${opts.href}`);
            opts.reloadDocument = true;
        } catch  {}
    }
    if (opts.throw) throw opts;
    return opts;
}
function $0102957b4ec7a2a4$export$4cb830d4f7e56898(obj) {
    return !!(obj == null ? void 0 : obj.isRedirect);
}
function $0102957b4ec7a2a4$export$d8d25f72d542813b(obj) {
    return !!(obj == null ? void 0 : obj.isRedirect) && obj.href;
}







var $d71f6ef532c58a41$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $d71f6ef532c58a41$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
'use strict';
const $d71f6ef532c58a41$var$object = {};
const $d71f6ef532c58a41$var$hasOwnProperty = $d71f6ef532c58a41$var$object.hasOwnProperty;
const $d71f6ef532c58a41$var$forOwn = (object, callback)=>{
    for(const key in object)if ($d71f6ef532c58a41$var$hasOwnProperty.call(object, key)) callback(key, object[key]);
};
const $d71f6ef532c58a41$var$extend = (destination, source)=>{
    if (!source) return destination;
    $d71f6ef532c58a41$var$forOwn(source, (key, value)=>{
        destination[key] = value;
    });
    return destination;
};
const $d71f6ef532c58a41$var$forEach = (array, callback)=>{
    const length = array.length;
    let index = -1;
    while(++index < length)callback(array[index]);
};
const $d71f6ef532c58a41$var$fourHexEscape = (hex)=>{
    return '\\u' + ('0000' + hex).slice(-4);
};
const $d71f6ef532c58a41$var$hexadecimal = (code, lowercase)=>{
    let hexadecimal = code.toString(16);
    if (lowercase) return hexadecimal;
    return hexadecimal.toUpperCase();
};
const $d71f6ef532c58a41$var$toString = $d71f6ef532c58a41$var$object.toString;
const $d71f6ef532c58a41$var$isArray = Array.isArray;
const $d71f6ef532c58a41$var$isBuffer = (value)=>{
    return typeof $d71f6ef532c58a41$require$Buffer === 'function' && $d71f6ef532c58a41$require$Buffer.isBuffer(value);
};
const $d71f6ef532c58a41$var$isObject = (value)=>{
    // This is a very simple check, but it’s good enough for what we need.
    return $d71f6ef532c58a41$var$toString.call(value) == '[object Object]';
};
const $d71f6ef532c58a41$var$isString = (value)=>{
    return typeof value == 'string' || $d71f6ef532c58a41$var$toString.call(value) == '[object String]';
};
const $d71f6ef532c58a41$var$isNumber = (value)=>{
    return typeof value == 'number' || $d71f6ef532c58a41$var$toString.call(value) == '[object Number]';
};
const $d71f6ef532c58a41$var$isBigInt = (value)=>{
    return typeof value == 'bigint';
};
const $d71f6ef532c58a41$var$isFunction = (value)=>{
    return typeof value == 'function';
};
const $d71f6ef532c58a41$var$isMap = (value)=>{
    return $d71f6ef532c58a41$var$toString.call(value) == '[object Map]';
};
const $d71f6ef532c58a41$var$isSet = (value)=>{
    return $d71f6ef532c58a41$var$toString.call(value) == '[object Set]';
};
/*--------------------------------------------------------------------------*/ // https://mathiasbynens.be/notes/javascript-escapes#single
const $d71f6ef532c58a41$var$singleEscapes = {
    '\\': '\\\\',
    '\b': '\\b',
    '\f': '\\f',
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t'
};
const $d71f6ef532c58a41$var$regexSingleEscape = /[\\\b\f\n\r\t]/;
const $d71f6ef532c58a41$var$regexDigit = /[0-9]/;
const $d71f6ef532c58a41$var$regexWhitespace = /[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;
const $d71f6ef532c58a41$var$escapeEverythingRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\uD800-\uDFFF])|(['"`])|[^]/g;
const $d71f6ef532c58a41$var$escapeNonAsciiRegex = /([\uD800-\uDBFF][\uDC00-\uDFFF])|([\uD800-\uDFFF])|(['"`])|[^ !#-&\(-\[\]-_a-~]/g;
const $d71f6ef532c58a41$var$jsesc = (argument, options)=>{
    const increaseIndentation = ()=>{
        oldIndent = indent;
        ++options.indentLevel;
        indent = options.indent.repeat(options.indentLevel);
    };
    // Handle options
    const defaults = {
        'escapeEverything': false,
        'minimal': false,
        'isScriptContext': false,
        'quotes': 'single',
        'wrap': false,
        'es6': false,
        'json': false,
        'compact': true,
        'lowercaseHex': false,
        'numbers': 'decimal',
        'indent': '\t',
        'indentLevel': 0,
        '__inline1__': false,
        '__inline2__': false
    };
    const json = options && options.json;
    if (json) {
        defaults.quotes = 'double';
        defaults.wrap = true;
    }
    options = $d71f6ef532c58a41$var$extend(defaults, options);
    if (options.quotes != 'single' && options.quotes != 'double' && options.quotes != 'backtick') options.quotes = 'single';
    const quote = options.quotes == 'double' ? '"' : options.quotes == 'backtick' ? '`' : '\'';
    const compact = options.compact;
    const lowercaseHex = options.lowercaseHex;
    let indent = options.indent.repeat(options.indentLevel);
    let oldIndent = '';
    const inline1 = options.__inline1__;
    const inline2 = options.__inline2__;
    const newLine = compact ? '' : '\n';
    let result;
    let isEmpty = true;
    const useBinNumbers = options.numbers == 'binary';
    const useOctNumbers = options.numbers == 'octal';
    const useDecNumbers = options.numbers == 'decimal';
    const useHexNumbers = options.numbers == 'hexadecimal';
    if (json && argument && $d71f6ef532c58a41$var$isFunction(argument.toJSON)) argument = argument.toJSON();
    if (!$d71f6ef532c58a41$var$isString(argument)) {
        if ($d71f6ef532c58a41$var$isMap(argument)) {
            if (argument.size == 0) return 'new Map()';
            if (!compact) {
                options.__inline1__ = true;
                options.__inline2__ = false;
            }
            return 'new Map(' + $d71f6ef532c58a41$var$jsesc(Array.from(argument), options) + ')';
        }
        if ($d71f6ef532c58a41$var$isSet(argument)) {
            if (argument.size == 0) return 'new Set()';
            return 'new Set(' + $d71f6ef532c58a41$var$jsesc(Array.from(argument), options) + ')';
        }
        if ($d71f6ef532c58a41$var$isBuffer(argument)) {
            if (argument.length == 0) return 'Buffer.from([])';
            return 'Buffer.from(' + $d71f6ef532c58a41$var$jsesc(Array.from(argument), options) + ')';
        }
        if ($d71f6ef532c58a41$var$isArray(argument)) {
            result = [];
            options.wrap = true;
            if (inline1) {
                options.__inline1__ = false;
                options.__inline2__ = true;
            }
            if (!inline2) increaseIndentation();
            $d71f6ef532c58a41$var$forEach(argument, (value)=>{
                isEmpty = false;
                if (inline2) options.__inline2__ = false;
                result.push((compact || inline2 ? '' : indent) + $d71f6ef532c58a41$var$jsesc(value, options));
            });
            if (isEmpty) return '[]';
            if (inline2) return '[' + result.join(', ') + ']';
            return '[' + newLine + result.join(',' + newLine) + newLine + (compact ? '' : oldIndent) + ']';
        } else if ($d71f6ef532c58a41$var$isNumber(argument) || $d71f6ef532c58a41$var$isBigInt(argument)) {
            if (json) // Some number values (e.g. `Infinity`) cannot be represented in JSON.
            // `BigInt` values less than `-Number.MAX_VALUE` or greater than
            // `Number.MAX_VALUE` cannot be represented in JSON so they will become
            // `-Infinity` or `Infinity`, respectively, and then become `null` when
            // stringified.
            return JSON.stringify(Number(argument));
            let result;
            if (useDecNumbers) result = String(argument);
            else if (useHexNumbers) {
                let hexadecimal = argument.toString(16);
                if (!lowercaseHex) hexadecimal = hexadecimal.toUpperCase();
                result = '0x' + hexadecimal;
            } else if (useBinNumbers) result = '0b' + argument.toString(2);
            else if (useOctNumbers) result = '0o' + argument.toString(8);
            if ($d71f6ef532c58a41$var$isBigInt(argument)) return result + 'n';
            return result;
        } else if ($d71f6ef532c58a41$var$isBigInt(argument)) {
            if (json) // `BigInt` values less than `-Number.MAX_VALUE` or greater than
            // `Number.MAX_VALUE` will become `-Infinity` or `Infinity`,
            // respectively, and cannot be represented in JSON.
            return JSON.stringify(Number(argument));
            return argument + 'n';
        } else if (!$d71f6ef532c58a41$var$isObject(argument)) {
            if (json) // For some values (e.g. `undefined`, `function` objects),
            // `JSON.stringify(value)` returns `undefined` (which isn’t valid
            // JSON) instead of `'null'`.
            return JSON.stringify(argument) || 'null';
            return String(argument);
        } else {
            result = [];
            options.wrap = true;
            increaseIndentation();
            $d71f6ef532c58a41$var$forOwn(argument, (key, value)=>{
                isEmpty = false;
                result.push((compact ? '' : indent) + $d71f6ef532c58a41$var$jsesc(key, options) + ':' + (compact ? '' : ' ') + $d71f6ef532c58a41$var$jsesc(value, options));
            });
            if (isEmpty) return '{}';
            return '{' + newLine + result.join(',' + newLine) + newLine + (compact ? '' : oldIndent) + '}';
        }
    }
    const regex = options.escapeEverything ? $d71f6ef532c58a41$var$escapeEverythingRegex : $d71f6ef532c58a41$var$escapeNonAsciiRegex;
    result = argument.replace(regex, (char, pair, lone, quoteChar, index, string)=>{
        if (pair) {
            if (options.minimal) return pair;
            const first = pair.charCodeAt(0);
            const second = pair.charCodeAt(1);
            if (options.es6) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                const codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                const hex = $d71f6ef532c58a41$var$hexadecimal(codePoint, lowercaseHex);
                return '\\u{' + hex + '}';
            }
            return $d71f6ef532c58a41$var$fourHexEscape($d71f6ef532c58a41$var$hexadecimal(first, lowercaseHex)) + $d71f6ef532c58a41$var$fourHexEscape($d71f6ef532c58a41$var$hexadecimal(second, lowercaseHex));
        }
        if (lone) return $d71f6ef532c58a41$var$fourHexEscape($d71f6ef532c58a41$var$hexadecimal(lone.charCodeAt(0), lowercaseHex));
        if (char == '\0' && !json && !$d71f6ef532c58a41$var$regexDigit.test(string.charAt(index + 1))) return '\\0';
        if (quoteChar) {
            if (quoteChar == quote || options.escapeEverything) return '\\' + quoteChar;
            return quoteChar;
        }
        if ($d71f6ef532c58a41$var$regexSingleEscape.test(char)) // no need for a `hasOwnProperty` check here
        return $d71f6ef532c58a41$var$singleEscapes[char];
        if (options.minimal && !$d71f6ef532c58a41$var$regexWhitespace.test(char)) return char;
        const hex = $d71f6ef532c58a41$var$hexadecimal(char.charCodeAt(0), lowercaseHex);
        if (json || hex.length > 2) return $d71f6ef532c58a41$var$fourHexEscape(hex);
        return '\\x' + ('00' + hex).slice(-2);
    });
    if (quote == '`') result = result.replace(/\$\{/g, '\\${');
    if (options.isScriptContext) // https://mathiasbynens.be/notes/etago
    result = result.replace(/<\/(script|style)/gi, '<\\/$1').replace(/<!--/g, json ? '\\u003C!--' : '\\x3C!--');
    if (options.wrap) result = quote + result + quote;
    return result;
};
$d71f6ef532c58a41$var$jsesc.version = '3.0.2';
$d71f6ef532c58a41$exports = $d71f6ef532c58a41$var$jsesc;


function $73176bbf3c96797b$export$22d1cd1301a566d0({ children: children, log: log }) {
    if (typeof document !== "undefined") return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("script", {
        className: "tsr-once",
        dangerouslySetInnerHTML: {
            __html: [
                children,
                "",
                'if (typeof __TSR_SSR__ !== "undefined") __TSR_SSR__.cleanScripts()'
            ].filter(Boolean).join("\n")
        }
    });
}


const $41c66dec330ab2d6$export$7367158f2f597ab1 = "tsr-scroll-restoration-v1_3";
const $41c66dec330ab2d6$var$sessionsStorage = typeof window !== "undefined" && window.sessionStorage;
const $41c66dec330ab2d6$var$throttle = (fn, wait)=>{
    let timeout;
    return (...args)=>{
        if (!timeout) timeout = setTimeout(()=>{
            fn(...args);
            timeout = null;
        }, wait);
    };
};
const $41c66dec330ab2d6$export$a8cd1437a65580ab = $41c66dec330ab2d6$var$sessionsStorage ? (()=>{
    const state = JSON.parse(window.sessionStorage.getItem($41c66dec330ab2d6$export$7367158f2f597ab1) || "null") || {};
    return {
        state: state,
        // This setter is simply to make sure that we set the sessionStorage right
        // after the state is updated. It doesn't necessarily need to be a functional
        // update.
        set: (updater)=>($41c66dec330ab2d6$export$a8cd1437a65580ab.state = (0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(updater, $41c66dec330ab2d6$export$a8cd1437a65580ab.state) || $41c66dec330ab2d6$export$a8cd1437a65580ab.state, window.sessionStorage.setItem($41c66dec330ab2d6$export$7367158f2f597ab1, JSON.stringify($41c66dec330ab2d6$export$a8cd1437a65580ab.state)))
    };
})() : void 0;
const $41c66dec330ab2d6$export$4d80c2f2d33fa119 = (location)=>{
    return location.state.key || location.href;
};
function $41c66dec330ab2d6$export$ebca8b3cdefcf4e2(el) {
    const path = [];
    let parent;
    while(parent = el.parentNode){
        path.unshift(`${el.tagName}:nth-child(${[].indexOf.call(parent.children, el) + 1})`);
        el = parent;
    }
    return `${path.join(" > ")}`.toLowerCase();
}
let $41c66dec330ab2d6$var$ignoreScroll = false;
function $41c66dec330ab2d6$export$1ae751dc1db106fa(storageKey2, key, behavior, shouldScrollRestoration, scrollToTopSelectors) {
    var _a;
    let byKey;
    try {
        byKey = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
    } catch (error) {
        console.error(error);
        return;
    }
    const resolvedKey = key || ((_a = window.history.state) == null ? void 0 : _a.key);
    const elementEntries = byKey[resolvedKey];
    $41c66dec330ab2d6$var$ignoreScroll = true;
    (()=>{
        if (shouldScrollRestoration && elementEntries) {
            for(const elementSelector in elementEntries){
                const entry = elementEntries[elementSelector];
                if (elementSelector === "window") window.scrollTo({
                    top: entry.scrollY,
                    left: entry.scrollX,
                    behavior: behavior
                });
                else if (elementSelector) {
                    const element = document.querySelector(elementSelector);
                    if (element) {
                        element.scrollLeft = entry.scrollX;
                        element.scrollTop = entry.scrollY;
                    }
                }
            }
            return;
        }
        const hash = window.location.hash.split("#")[1];
        if (hash) {
            const hashScrollIntoViewOptions = (window.history.state || {}).__hashScrollIntoViewOptions ?? true;
            if (hashScrollIntoViewOptions) {
                const el = document.getElementById(hash);
                if (el) el.scrollIntoView(hashScrollIntoViewOptions);
            }
            return;
        }
        [
            "window",
            ...(scrollToTopSelectors == null ? void 0 : scrollToTopSelectors.filter((d)=>d !== "window")) ?? []
        ].forEach((selector)=>{
            const element = selector === "window" ? window : document.querySelector(selector);
            if (element) element.scrollTo({
                top: 0,
                left: 0,
                behavior: behavior
            });
        });
    })();
    $41c66dec330ab2d6$var$ignoreScroll = false;
}
function $41c66dec330ab2d6$export$7d29344e455b77d5(router, force) {
    const shouldScrollRestoration = force ?? router.options.scrollRestoration ?? false;
    if (shouldScrollRestoration) router.isScrollRestoring = true;
    if (typeof document === "undefined" || router.isScrollRestorationSetup) return;
    router.isScrollRestorationSetup = true;
    $41c66dec330ab2d6$var$ignoreScroll = false;
    const getKey = router.options.getScrollRestorationKey || $41c66dec330ab2d6$export$4d80c2f2d33fa119;
    window.history.scrollRestoration = "manual";
    const onScroll = (event)=>{
        if ($41c66dec330ab2d6$var$ignoreScroll || !router.isScrollRestoring) return;
        let elementSelector = "";
        if (event.target === document || event.target === window) elementSelector = "window";
        else {
            const attrId = event.target.getAttribute("data-scroll-restoration-id");
            if (attrId) elementSelector = `[data-scroll-restoration-id="${attrId}"]`;
            else elementSelector = $41c66dec330ab2d6$export$ebca8b3cdefcf4e2(event.target);
        }
        const restoreKey = getKey(router.state.location);
        $41c66dec330ab2d6$export$a8cd1437a65580ab.set((state)=>{
            const keyEntry = state[restoreKey] = state[restoreKey] || {};
            const elementEntry = keyEntry[elementSelector] = keyEntry[elementSelector] || {};
            if (elementSelector === "window") {
                elementEntry.scrollX = window.scrollX || 0;
                elementEntry.scrollY = window.scrollY || 0;
            } else if (elementSelector) {
                const element = document.querySelector(elementSelector);
                if (element) {
                    elementEntry.scrollX = element.scrollLeft || 0;
                    elementEntry.scrollY = element.scrollTop || 0;
                }
            }
            return state;
        });
    };
    if (typeof document !== "undefined") document.addEventListener("scroll", $41c66dec330ab2d6$var$throttle(onScroll, 100), true);
    router.subscribe("onRendered", (event)=>{
        const cacheKey = getKey(event.toLocation);
        if (!router.resetNextScroll) {
            router.resetNextScroll = true;
            return;
        }
        $41c66dec330ab2d6$export$1ae751dc1db106fa($41c66dec330ab2d6$export$7367158f2f597ab1, cacheKey, router.options.scrollRestorationBehavior, router.isScrollRestoring, router.options.scrollToTopSelectors);
        if (router.isScrollRestoring) $41c66dec330ab2d6$export$a8cd1437a65580ab.set((state)=>{
            state[cacheKey] = state[cacheKey] || {};
            return state;
        });
    });
}
function $41c66dec330ab2d6$export$11aac1aab828f1fa() {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const getKey = router.options.getScrollRestorationKey || $41c66dec330ab2d6$export$4d80c2f2d33fa119;
    const userKey = getKey(router.latestLocation);
    const resolvedKey = userKey !== $41c66dec330ab2d6$export$4d80c2f2d33fa119(router.latestLocation) ? userKey : null;
    if (!router.isScrollRestoring || !router.isServer) return null;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $73176bbf3c96797b$export$22d1cd1301a566d0), {
        children: `(${$41c66dec330ab2d6$export$1ae751dc1db106fa.toString()})(${JSON.stringify($41c66dec330ab2d6$export$7367158f2f597ab1)},${JSON.stringify(resolvedKey)}, undefined, true)`,
        log: false
    });
}


const $ab96d7f38df4df97$export$741158c5c07285bb = [
    "component",
    "errorComponent",
    "pendingComponent",
    "notFoundComponent"
];
function $ab96d7f38df4df97$var$routeNeedsPreload(route) {
    var _a;
    for (const componentType of $ab96d7f38df4df97$export$741158c5c07285bb){
        if ((_a = route.options[componentType]) == null ? void 0 : _a.preload) return true;
    }
    return false;
}
function $ab96d7f38df4df97$var$validateSearch(validateSearch2, input) {
    if (validateSearch2 == null) return {};
    if ("~standard" in validateSearch2) {
        const result = validateSearch2["~standard"].validate(input);
        if (result instanceof Promise) throw new $ab96d7f38df4df97$export$ca74fadaf06bf7e1("Async validation not supported");
        if (result.issues) throw new $ab96d7f38df4df97$export$ca74fadaf06bf7e1(JSON.stringify(result.issues, void 0, 2), {
            cause: result
        });
        return result.value;
    }
    if ("parse" in validateSearch2) return validateSearch2.parse(input);
    if (typeof validateSearch2 === "function") return validateSearch2(input);
    return {};
}
function $ab96d7f38df4df97$export$baddd0131ee8c05b(options) {
    return new $ab96d7f38df4df97$export$55185c17a0fcbe46(options);
}
class $ab96d7f38df4df97$export$55185c17a0fcbe46 {
    /**
   * @deprecated Use the `createRouter` function instead
   */ constructor(options){
        this.tempLocationKey = `${Math.round(Math.random() * 1e7)}`;
        this.resetNextScroll = true;
        this.shouldViewTransition = void 0;
        this.isViewTransitionTypesSupported = void 0;
        this.subscribers = /* @__PURE__ */ new Set();
        this.isScrollRestoring = false;
        this.isScrollRestorationSetup = false;
        this.startReactTransition = (fn)=>fn();
        this.update = (newOptions)=>{
            var _a;
            if (newOptions.notFoundRoute) console.warn("The notFoundRoute API is deprecated and will be removed in the next major version. See https://tanstack.com/router/v1/docs/framework/react/guide/not-found-errors#migrating-from-notfoundroute for more info.");
            const previousOptions = this.options;
            this.options = {
                ...this.options,
                ...newOptions
            };
            this.isServer = this.options.isServer ?? typeof document === "undefined";
            this.pathParamsDecodeCharMap = this.options.pathParamsAllowedCharacters ? new Map(this.options.pathParamsAllowedCharacters.map((char)=>[
                    encodeURIComponent(char),
                    char
                ])) : void 0;
            if (!this.basepath || newOptions.basepath && newOptions.basepath !== previousOptions.basepath) {
                if (newOptions.basepath === void 0 || newOptions.basepath === "" || newOptions.basepath === "/") this.basepath = "/";
                else this.basepath = `/${(0, $355b3a1b8fb8b573$export$b86b8b1e0778ce3f)(newOptions.basepath)}`;
            }
            if (// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            !this.history || this.options.history && this.options.history !== this.history) {
                this.history = this.options.history ?? (this.isServer ? (0, $dfedaba89c5e8834$export$2b76ad033c6e6d08)({
                    initialEntries: [
                        this.basepath || "/"
                    ]
                }) : (0, $dfedaba89c5e8834$export$719fc203c4e16dee)());
                this.latestLocation = this.parseLocation();
            }
            if (this.options.routeTree !== this.routeTree) {
                this.routeTree = this.options.routeTree;
                this.buildRouteTree();
            }
            if (!this.__store) {
                this.__store = new (0, $a5144f48fa9ca142$export$390f32400eaf98c9)($ab96d7f38df4df97$export$baa2404bdcb7f08c(this.latestLocation), {
                    onUpdate: ()=>{
                        this.__store.state = {
                            ...this.state,
                            cachedMatches: this.state.cachedMatches.filter((d)=>![
                                    "redirected"
                                ].includes(d.status))
                        };
                    }
                });
                (0, $41c66dec330ab2d6$export$7d29344e455b77d5)(this);
            }
            if (typeof window !== "undefined" && "CSS" in window && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            typeof ((_a = window.CSS) == null ? void 0 : _a.supports) === "function") this.isViewTransitionTypesSupported = window.CSS.supports("selector(:active-view-transition-type(a)");
        };
        this.buildRouteTree = ()=>{
            this.routesById = {};
            this.routesByPath = {};
            const notFoundRoute = this.options.notFoundRoute;
            if (notFoundRoute) {
                notFoundRoute.init({
                    originalIndex: 99999999999,
                    defaultSsr: this.options.defaultSsr
                });
                this.routesById[notFoundRoute.id] = notFoundRoute;
            }
            const recurseRoutes = (childRoutes)=>{
                childRoutes.forEach((childRoute, i)=>{
                    childRoute.init({
                        originalIndex: i,
                        defaultSsr: this.options.defaultSsr
                    });
                    const existingRoute = this.routesById[childRoute.id];
                    (0, $85f606e562c81b96$export$2e2bcd8739ae039)(!existingRoute, `Duplicate routes found with id: ${String(childRoute.id)}`);
                    this.routesById[childRoute.id] = childRoute;
                    if (!childRoute.isRoot && childRoute.path) {
                        const trimmedFullPath = (0, $355b3a1b8fb8b573$export$a33f08202c373623)(childRoute.fullPath);
                        if (!this.routesByPath[trimmedFullPath] || childRoute.fullPath.endsWith("/")) this.routesByPath[trimmedFullPath] = childRoute;
                    }
                    const children = childRoute.children;
                    if (children == null ? void 0 : children.length) recurseRoutes(children);
                });
            };
            recurseRoutes([
                this.routeTree
            ]);
            const scoredRoutes = [];
            const routes = Object.values(this.routesById);
            routes.forEach((d, i)=>{
                var _a;
                if (d.isRoot || !d.path) return;
                const trimmed = (0, $355b3a1b8fb8b573$export$47150f29cd1fb3ae)(d.fullPath);
                const parsed = (0, $355b3a1b8fb8b573$export$7fafb205ecc26684)(trimmed);
                while(parsed.length > 1 && ((_a = parsed[0]) == null ? void 0 : _a.value) === "/")parsed.shift();
                const scores = parsed.map((segment)=>{
                    if (segment.value === "/") return 0.75;
                    if (segment.type === "param") return 0.5;
                    if (segment.type === "wildcard") return 0.25;
                    return 1;
                });
                scoredRoutes.push({
                    child: d,
                    trimmed: trimmed,
                    parsed: parsed,
                    index: i,
                    scores: scores
                });
            });
            this.flatRoutes = scoredRoutes.sort((a, b)=>{
                const minLength = Math.min(a.scores.length, b.scores.length);
                for(let i = 0; i < minLength; i++){
                    if (a.scores[i] !== b.scores[i]) return b.scores[i] - a.scores[i];
                }
                if (a.scores.length !== b.scores.length) return b.scores.length - a.scores.length;
                for(let i = 0; i < minLength; i++){
                    if (a.parsed[i].value !== b.parsed[i].value) return a.parsed[i].value > b.parsed[i].value ? 1 : -1;
                }
                return a.index - b.index;
            }).map((d, i)=>{
                d.child.rank = i;
                return d.child;
            });
        };
        this.subscribe = (eventType, fn)=>{
            const listener = {
                eventType: eventType,
                fn: fn
            };
            this.subscribers.add(listener);
            return ()=>{
                this.subscribers.delete(listener);
            };
        };
        this.emit = (routerEvent)=>{
            this.subscribers.forEach((listener)=>{
                if (listener.eventType === routerEvent.type) listener.fn(routerEvent);
            });
        };
        this.parseLocation = (previousLocation, locationToParse)=>{
            const parse = ({ pathname: pathname, search: search, hash: hash, state: state })=>{
                const parsedSearch = this.options.parseSearch(search);
                const searchStr = this.options.stringifySearch(parsedSearch);
                return {
                    pathname: pathname,
                    searchStr: searchStr,
                    search: (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousLocation == null ? void 0 : previousLocation.search, parsedSearch),
                    hash: hash.split("#").reverse()[0] ?? "",
                    href: `${pathname}${searchStr}${hash}`,
                    state: (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousLocation == null ? void 0 : previousLocation.state, state)
                };
            };
            const location = parse(locationToParse ?? this.history.location);
            const { __tempLocation: __tempLocation, __tempKey: __tempKey } = location.state;
            if (__tempLocation && (!__tempKey || __tempKey === this.tempLocationKey)) {
                const parsedTempLocation = parse(__tempLocation);
                parsedTempLocation.state.key = location.state.key;
                delete parsedTempLocation.state.__tempLocation;
                return {
                    ...parsedTempLocation,
                    maskedLocation: location
                };
            }
            return location;
        };
        this.resolvePathWithBase = (from, path)=>{
            const resolvedPath = (0, $355b3a1b8fb8b573$export$b09f2ff0bbcb43c7)({
                basepath: this.basepath,
                base: from,
                to: (0, $355b3a1b8fb8b573$export$b7c632328822445d)(path),
                trailingSlash: this.options.trailingSlash,
                caseSensitive: this.options.caseSensitive
            });
            return resolvedPath;
        };
        this.getMatchedRoutes = (next, dest)=>{
            let routeParams = {};
            const trimmedPath = (0, $355b3a1b8fb8b573$export$a33f08202c373623)(next.pathname);
            const getMatchedParams = (route)=>{
                const result = (0, $355b3a1b8fb8b573$export$b71b01274a8bb9ec)(this.basepath, trimmedPath, {
                    to: route.fullPath,
                    caseSensitive: route.options.caseSensitive ?? this.options.caseSensitive,
                    fuzzy: true
                });
                return result;
            };
            let foundRoute = (dest == null ? void 0 : dest.to) !== void 0 ? this.routesByPath[dest.to] : void 0;
            if (foundRoute) routeParams = getMatchedParams(foundRoute);
            else foundRoute = this.flatRoutes.find((route)=>{
                const matchedParams = getMatchedParams(route);
                if (matchedParams) {
                    routeParams = matchedParams;
                    return true;
                }
                return false;
            });
            let routeCursor = foundRoute || this.routesById[0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5];
            const matchedRoutes = [
                routeCursor
            ];
            while(routeCursor.parentRoute){
                routeCursor = routeCursor.parentRoute;
                matchedRoutes.unshift(routeCursor);
            }
            return {
                matchedRoutes: matchedRoutes,
                routeParams: routeParams,
                foundRoute: foundRoute
            };
        };
        this.cancelMatch = (id)=>{
            const match = this.getMatch(id);
            if (!match) return;
            match.abortController.abort();
            clearTimeout(match.pendingTimeout);
        };
        this.cancelMatches = ()=>{
            var _a;
            (_a = this.state.pendingMatches) == null || _a.forEach((match)=>{
                this.cancelMatch(match.id);
            });
        };
        this.buildLocation = (opts)=>{
            const build = (dest = {}, matchedRoutesResult)=>{
                var _a, _b, _c, _d, _e, _f;
                const fromMatches = dest._fromLocation ? this.matchRoutes(dest._fromLocation, {
                    _buildLocation: true
                }) : this.state.matches;
                const fromMatch = dest.from != null ? fromMatches.find((d)=>(0, $355b3a1b8fb8b573$export$b71b01274a8bb9ec)(this.basepath, (0, $355b3a1b8fb8b573$export$a33f08202c373623)(d.pathname), {
                        to: dest.from,
                        caseSensitive: false,
                        fuzzy: false
                    })) : void 0;
                const fromPath = (fromMatch == null ? void 0 : fromMatch.pathname) || this.latestLocation.pathname;
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(dest.from == null || fromMatch != null, "Could not find match for from: " + dest.from);
                const fromSearch = ((_a = this.state.pendingMatches) == null ? void 0 : _a.length) ? (_b = (0, $04e51d94e9f9f85e$export$4c7897fafd92b108)(this.state.pendingMatches)) == null ? void 0 : _b.search : ((_c = (0, $04e51d94e9f9f85e$export$4c7897fafd92b108)(fromMatches)) == null ? void 0 : _c.search) || this.latestLocation.search;
                const stayingMatches = matchedRoutesResult == null ? void 0 : matchedRoutesResult.matchedRoutes.filter((d)=>fromMatches.find((e)=>e.routeId === d.id));
                let pathname;
                if (dest.to) {
                    const resolvePathTo = (fromMatch == null ? void 0 : fromMatch.fullPath) || this.latestLocation.pathname;
                    pathname = this.resolvePathWithBase(resolvePathTo, `${dest.to}`);
                } else {
                    const fromRouteByFromPathRouteId = this.routesById[(_d = stayingMatches == null ? void 0 : stayingMatches.find((route)=>{
                        const interpolatedPath = (0, $355b3a1b8fb8b573$export$8ca4fd5908a217f6)({
                            path: route.fullPath,
                            params: (matchedRoutesResult == null ? void 0 : matchedRoutesResult.routeParams) ?? {},
                            decodeCharMap: this.pathParamsDecodeCharMap
                        }).interpolatedPath;
                        const pathname2 = (0, $355b3a1b8fb8b573$export$86d9a7913e44197e)([
                            this.basepath,
                            interpolatedPath
                        ]);
                        return pathname2 === fromPath;
                    })) == null ? void 0 : _d.id];
                    pathname = this.resolvePathWithBase(fromPath, (fromRouteByFromPathRouteId == null ? void 0 : fromRouteByFromPathRouteId.to) ?? fromPath);
                }
                const prevParams = {
                    ...(_e = (0, $04e51d94e9f9f85e$export$4c7897fafd92b108)(fromMatches)) == null ? void 0 : _e.params
                };
                let nextParams = (dest.params ?? true) === true ? prevParams : {
                    ...prevParams,
                    ...(0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(dest.params, prevParams)
                };
                if (Object.keys(nextParams).length > 0) matchedRoutesResult == null || matchedRoutesResult.matchedRoutes.map((route)=>{
                    var _a2;
                    return ((_a2 = route.options.params) == null ? void 0 : _a2.stringify) ?? route.options.stringifyParams;
                }).filter(Boolean).forEach((fn)=>{
                    nextParams = {
                        ...nextParams,
                        ...fn(nextParams)
                    };
                });
                pathname = (0, $355b3a1b8fb8b573$export$8ca4fd5908a217f6)({
                    path: pathname,
                    params: nextParams ?? {},
                    leaveWildcards: false,
                    leaveParams: opts.leaveParams,
                    decodeCharMap: this.pathParamsDecodeCharMap
                }).interpolatedPath;
                let search = fromSearch;
                if (opts._includeValidateSearch && ((_f = this.options.search) == null ? void 0 : _f.strict)) {
                    let validatedSearch = {};
                    matchedRoutesResult == null || matchedRoutesResult.matchedRoutes.forEach((route)=>{
                        try {
                            if (route.options.validateSearch) validatedSearch = {
                                ...validatedSearch,
                                ...$ab96d7f38df4df97$var$validateSearch(route.options.validateSearch, {
                                    ...validatedSearch,
                                    ...search
                                }) ?? {}
                            };
                        } catch  {}
                    });
                    search = validatedSearch;
                }
                const applyMiddlewares = (search2)=>{
                    const allMiddlewares = (matchedRoutesResult == null ? void 0 : matchedRoutesResult.matchedRoutes.reduce((acc, route)=>{
                        var _a2;
                        const middlewares = [];
                        if ("search" in route.options) {
                            if ((_a2 = route.options.search) == null ? void 0 : _a2.middlewares) middlewares.push(...route.options.search.middlewares);
                        } else if (route.options.preSearchFilters || route.options.postSearchFilters) {
                            const legacyMiddleware = ({ search: search3, next: next })=>{
                                let nextSearch = search3;
                                if ("preSearchFilters" in route.options && route.options.preSearchFilters) nextSearch = route.options.preSearchFilters.reduce((prev, next2)=>next2(prev), search3);
                                const result = next(nextSearch);
                                if ("postSearchFilters" in route.options && route.options.postSearchFilters) return route.options.postSearchFilters.reduce((prev, next2)=>next2(prev), result);
                                return result;
                            };
                            middlewares.push(legacyMiddleware);
                        }
                        if (opts._includeValidateSearch && route.options.validateSearch) {
                            const validate = ({ search: search3, next: next })=>{
                                const result = next(search3);
                                try {
                                    const validatedSearch = {
                                        ...result,
                                        ...$ab96d7f38df4df97$var$validateSearch(route.options.validateSearch, result) ?? {}
                                    };
                                    return validatedSearch;
                                } catch  {
                                    return result;
                                }
                            };
                            middlewares.push(validate);
                        }
                        return acc.concat(middlewares);
                    }, [])) ?? [];
                    const final = ({ search: search3 })=>{
                        if (!dest.search) return {};
                        if (dest.search === true) return search3;
                        return (0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(dest.search, search3);
                    };
                    allMiddlewares.push(final);
                    const applyNext = (index, currentSearch)=>{
                        if (index >= allMiddlewares.length) return currentSearch;
                        const middleware = allMiddlewares[index];
                        const next = (newSearch)=>{
                            return applyNext(index + 1, newSearch);
                        };
                        return middleware({
                            search: currentSearch,
                            next: next
                        });
                    };
                    return applyNext(0, search2);
                };
                search = applyMiddlewares(search);
                search = (0, $04e51d94e9f9f85e$export$77a71fc411098696)(fromSearch, search);
                const searchStr = this.options.stringifySearch(search);
                const hash = dest.hash === true ? this.latestLocation.hash : dest.hash ? (0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(dest.hash, this.latestLocation.hash) : void 0;
                const hashStr = hash ? `#${hash}` : "";
                let nextState = dest.state === true ? this.latestLocation.state : dest.state ? (0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(dest.state, this.latestLocation.state) : {};
                nextState = (0, $04e51d94e9f9f85e$export$77a71fc411098696)(this.latestLocation.state, nextState);
                return {
                    pathname: pathname,
                    search: search,
                    searchStr: searchStr,
                    state: nextState,
                    hash: hash ?? "",
                    href: `${pathname}${searchStr}${hashStr}`,
                    unmaskOnReload: dest.unmaskOnReload
                };
            };
            const buildWithMatches = (dest = {}, maskedDest)=>{
                var _a;
                const next = build(dest);
                let maskedNext = maskedDest ? build(maskedDest) : void 0;
                if (!maskedNext) {
                    let params = {};
                    const foundMask = (_a = this.options.routeMasks) == null ? void 0 : _a.find((d)=>{
                        const match = (0, $355b3a1b8fb8b573$export$b71b01274a8bb9ec)(this.basepath, next.pathname, {
                            to: d.from,
                            caseSensitive: false,
                            fuzzy: false
                        });
                        if (match) {
                            params = match;
                            return true;
                        }
                        return false;
                    });
                    if (foundMask) {
                        const { from: _from, ...maskProps } = foundMask;
                        maskedDest = {
                            ...(0, $04e51d94e9f9f85e$export$357523c63a2253b9)(opts, [
                                "from"
                            ]),
                            ...maskProps,
                            params: params
                        };
                        maskedNext = build(maskedDest);
                    }
                }
                const nextMatches = this.getMatchedRoutes(next, dest);
                const final = build(dest, nextMatches);
                if (maskedNext) {
                    const maskedMatches = this.getMatchedRoutes(maskedNext, maskedDest);
                    const maskedFinal = build(maskedDest, maskedMatches);
                    final.maskedLocation = maskedFinal;
                }
                return final;
            };
            if (opts.mask) return buildWithMatches(opts, {
                ...(0, $04e51d94e9f9f85e$export$357523c63a2253b9)(opts, [
                    "from"
                ]),
                ...opts.mask
            });
            return buildWithMatches(opts);
        };
        this.commitLocation = ({ viewTransition: viewTransition, ignoreBlocker: ignoreBlocker, ...next })=>{
            const isSameState = ()=>{
                const ignoredProps = [
                    "key",
                    "__TSR_index",
                    "__hashScrollIntoViewOptions"
                ];
                ignoredProps.forEach((prop)=>{
                    next.state[prop] = this.latestLocation.state[prop];
                });
                const isEqual = (0, $04e51d94e9f9f85e$export$9cb4719e2e525b7a)(next.state, this.latestLocation.state);
                ignoredProps.forEach((prop)=>{
                    delete next.state[prop];
                });
                return isEqual;
            };
            const isSameUrl = this.latestLocation.href === next.href;
            const previousCommitPromise = this.commitLocationPromise;
            this.commitLocationPromise = (0, $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd)(()=>{
                previousCommitPromise == null || previousCommitPromise.resolve();
            });
            if (isSameUrl && isSameState()) this.load();
            else {
                let { maskedLocation: maskedLocation, hashScrollIntoView: hashScrollIntoView, ...nextHistory } = next;
                if (maskedLocation) {
                    nextHistory = {
                        ...maskedLocation,
                        state: {
                            ...maskedLocation.state,
                            __tempKey: void 0,
                            __tempLocation: {
                                ...nextHistory,
                                search: nextHistory.searchStr,
                                state: {
                                    ...nextHistory.state,
                                    __tempKey: void 0,
                                    __tempLocation: void 0,
                                    key: void 0
                                }
                            }
                        }
                    };
                    if (nextHistory.unmaskOnReload ?? this.options.unmaskOnReload ?? false) nextHistory.state.__tempKey = this.tempLocationKey;
                }
                nextHistory.state.__hashScrollIntoViewOptions = hashScrollIntoView ?? this.options.defaultHashScrollIntoView ?? true;
                this.shouldViewTransition = viewTransition;
                this.history[next.replace ? "replace" : "push"](nextHistory.href, nextHistory.state, {
                    ignoreBlocker: ignoreBlocker
                });
            }
            this.resetNextScroll = next.resetScroll ?? true;
            if (!this.history.subscribers.size) this.load();
            return this.commitLocationPromise;
        };
        this.buildAndCommitLocation = ({ replace: replace, resetScroll: resetScroll, hashScrollIntoView: hashScrollIntoView, viewTransition: viewTransition, ignoreBlocker: ignoreBlocker, href: href, ...rest } = {})=>{
            if (href) {
                const currentIndex = this.history.location.state.__TSR_index;
                const parsed = (0, $dfedaba89c5e8834$export$c68fd8c8a50e78e)(href, {
                    __TSR_index: replace ? currentIndex : currentIndex + 1
                });
                rest.to = parsed.pathname;
                rest.search = this.options.parseSearch(parsed.search);
                rest.hash = parsed.hash.slice(1);
            }
            const location = this.buildLocation({
                ...rest,
                _includeValidateSearch: true
            });
            return this.commitLocation({
                ...location,
                viewTransition: viewTransition,
                replace: replace,
                resetScroll: resetScroll,
                hashScrollIntoView: hashScrollIntoView,
                ignoreBlocker: ignoreBlocker
            });
        };
        this.navigate = ({ to: to, reloadDocument: reloadDocument, href: href, ...rest })=>{
            if (reloadDocument) {
                if (!href) {
                    const location = this.buildLocation({
                        to: to,
                        ...rest
                    });
                    href = this.history.createHref(location.href);
                }
                if (rest.replace) window.location.replace(href);
                else window.location.href = href;
                return;
            }
            return this.buildAndCommitLocation({
                ...rest,
                href: href,
                to: to
            });
        };
        this.load = async (opts)=>{
            this.latestLocation = this.parseLocation(this.latestLocation);
            let redirect;
            let notFound;
            let loadPromise;
            loadPromise = new Promise((resolve)=>{
                this.startReactTransition(async ()=>{
                    var _a;
                    try {
                        const next = this.latestLocation;
                        const prevLocation = this.state.resolvedLocation;
                        this.cancelMatches();
                        let pendingMatches;
                        (0, $9203abc22ef76827$export$712ea50be43a7858)(()=>{
                            pendingMatches = this.matchRoutes(next);
                            this.__store.setState((s)=>({
                                    ...s,
                                    status: "pending",
                                    isLoading: true,
                                    location: next,
                                    pendingMatches: pendingMatches,
                                    // If a cached moved to pendingMatches, remove it from cachedMatches
                                    cachedMatches: s.cachedMatches.filter((d)=>{
                                        return !pendingMatches.find((e)=>e.id === d.id);
                                    })
                                }));
                        });
                        if (!this.state.redirect) this.emit({
                            type: "onBeforeNavigate",
                            ...(0, $683377acaa6ecdcc$export$6c2b3e1c712e7fa6)({
                                resolvedLocation: prevLocation,
                                location: next
                            })
                        });
                        this.emit({
                            type: "onBeforeLoad",
                            ...(0, $683377acaa6ecdcc$export$6c2b3e1c712e7fa6)({
                                resolvedLocation: prevLocation,
                                location: next
                            })
                        });
                        await this.loadMatches({
                            sync: opts == null ? void 0 : opts.sync,
                            matches: pendingMatches,
                            location: next,
                            // eslint-disable-next-line @typescript-eslint/require-await
                            onReady: async ()=>{
                                this.startViewTransition(async ()=>{
                                    let exitingMatches;
                                    let enteringMatches;
                                    let stayingMatches;
                                    (0, $9203abc22ef76827$export$712ea50be43a7858)(()=>{
                                        this.__store.setState((s)=>{
                                            const previousMatches = s.matches;
                                            const newMatches = s.pendingMatches || s.matches;
                                            exitingMatches = previousMatches.filter((match)=>!newMatches.find((d)=>d.id === match.id));
                                            enteringMatches = newMatches.filter((match)=>!previousMatches.find((d)=>d.id === match.id));
                                            stayingMatches = previousMatches.filter((match)=>newMatches.find((d)=>d.id === match.id));
                                            return {
                                                ...s,
                                                isLoading: false,
                                                loadedAt: Date.now(),
                                                matches: newMatches,
                                                pendingMatches: void 0,
                                                cachedMatches: [
                                                    ...s.cachedMatches,
                                                    ...exitingMatches.filter((d)=>d.status !== "error")
                                                ]
                                            };
                                        });
                                        this.clearExpiredCache();
                                    });
                                    [
                                        [
                                            exitingMatches,
                                            "onLeave"
                                        ],
                                        [
                                            enteringMatches,
                                            "onEnter"
                                        ],
                                        [
                                            stayingMatches,
                                            "onStay"
                                        ]
                                    ].forEach(([matches, hook])=>{
                                        matches.forEach((match)=>{
                                            var _a2, _b;
                                            (_b = (_a2 = this.looseRoutesById[match.routeId].options)[hook]) == null || _b.call(_a2, match);
                                        });
                                    });
                                });
                            }
                        });
                    } catch (err) {
                        if ((0, $0102957b4ec7a2a4$export$d8d25f72d542813b)(err)) {
                            redirect = err;
                            if (!this.isServer) this.navigate({
                                ...redirect,
                                replace: true,
                                ignoreBlocker: true
                            });
                        } else if ((0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err)) notFound = err;
                        this.__store.setState((s)=>({
                                ...s,
                                statusCode: redirect ? redirect.statusCode : notFound ? 404 : s.matches.some((d)=>d.status === "error") ? 500 : 200,
                                redirect: redirect
                            }));
                    }
                    if (this.latestLoadPromise === loadPromise) {
                        (_a = this.commitLocationPromise) == null || _a.resolve();
                        this.latestLoadPromise = void 0;
                        this.commitLocationPromise = void 0;
                    }
                    resolve();
                });
            });
            this.latestLoadPromise = loadPromise;
            await loadPromise;
            while(this.latestLoadPromise && loadPromise !== this.latestLoadPromise)await this.latestLoadPromise;
            if (this.hasNotFoundMatch()) this.__store.setState((s)=>({
                    ...s,
                    statusCode: 404
                }));
        };
        this.startViewTransition = (fn)=>{
            const shouldViewTransition = this.shouldViewTransition ?? this.options.defaultViewTransition;
            delete this.shouldViewTransition;
            if (shouldViewTransition && typeof document !== "undefined" && "startViewTransition" in document && typeof document.startViewTransition === "function") {
                let startViewTransitionParams;
                if (typeof shouldViewTransition === "object" && this.isViewTransitionTypesSupported) startViewTransitionParams = {
                    update: fn,
                    types: shouldViewTransition.types
                };
                else startViewTransitionParams = fn;
                document.startViewTransition(startViewTransitionParams);
            } else fn();
        };
        this.updateMatch = (id, updater)=>{
            var _a;
            let updated;
            const isPending = (_a = this.state.pendingMatches) == null ? void 0 : _a.find((d)=>d.id === id);
            const isMatched = this.state.matches.find((d)=>d.id === id);
            const isCached = this.state.cachedMatches.find((d)=>d.id === id);
            const matchesKey = isPending ? "pendingMatches" : isMatched ? "matches" : isCached ? "cachedMatches" : "";
            if (matchesKey) this.__store.setState((s)=>{
                var _a2;
                return {
                    ...s,
                    [matchesKey]: (_a2 = s[matchesKey]) == null ? void 0 : _a2.map((d)=>d.id === id ? updated = updater(d) : d)
                };
            });
            return updated;
        };
        this.getMatch = (matchId)=>{
            return [
                ...this.state.cachedMatches,
                ...this.state.pendingMatches ?? [],
                ...this.state.matches
            ].find((d)=>d.id === matchId);
        };
        this.loadMatches = async ({ location: location, matches: matches, preload: allPreload, onReady: onReady, updateMatch: updateMatch = this.updateMatch, sync: sync })=>{
            let firstBadMatchIndex;
            let rendered = false;
            const triggerOnReady = async ()=>{
                if (!rendered) {
                    rendered = true;
                    await (onReady == null ? void 0 : onReady());
                }
            };
            const resolvePreload = (matchId)=>{
                return !!(allPreload && !this.state.matches.find((d)=>d.id === matchId));
            };
            if (!this.isServer && !this.state.matches.length) triggerOnReady();
            const handleRedirectAndNotFound = (match, err)=>{
                var _a, _b, _c, _d;
                if ((0, $0102957b4ec7a2a4$export$d8d25f72d542813b)(err)) {
                    if (!err.reloadDocument) throw err;
                }
                if ((0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(err) || (0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err)) {
                    updateMatch(match.id, (prev)=>({
                            ...prev,
                            status: (0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(err) ? "redirected" : (0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err) ? "notFound" : "error",
                            isFetching: false,
                            error: err,
                            beforeLoadPromise: void 0,
                            loaderPromise: void 0
                        }));
                    if (!err.routeId) err.routeId = match.routeId;
                    (_a = match.beforeLoadPromise) == null || _a.resolve();
                    (_b = match.loaderPromise) == null || _b.resolve();
                    (_c = match.loadPromise) == null || _c.resolve();
                    if ((0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(err)) {
                        rendered = true;
                        err = this.resolveRedirect({
                            ...err,
                            _fromLocation: location
                        });
                        throw err;
                    } else if ((0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err)) {
                        this._handleNotFound(matches, err, {
                            updateMatch: updateMatch
                        });
                        (_d = this.serverSsr) == null || _d.onMatchSettled({
                            router: this,
                            match: this.getMatch(match.id)
                        });
                        throw err;
                    }
                }
            };
            try {
                await new Promise((resolveAll, rejectAll)=>{
                    (async ()=>{
                        var _a, _b, _c;
                        try {
                            const handleSerialError = (index, err, routerCode)=>{
                                var _a2, _b2;
                                const { id: matchId, routeId: routeId } = matches[index];
                                const route = this.looseRoutesById[routeId];
                                if (err instanceof Promise) throw err;
                                err.routerCode = routerCode;
                                firstBadMatchIndex = firstBadMatchIndex ?? index;
                                handleRedirectAndNotFound(this.getMatch(matchId), err);
                                try {
                                    (_b2 = (_a2 = route.options).onError) == null || _b2.call(_a2, err);
                                } catch (errorHandlerErr) {
                                    err = errorHandlerErr;
                                    handleRedirectAndNotFound(this.getMatch(matchId), err);
                                }
                                updateMatch(matchId, (prev)=>{
                                    var _a3, _b3;
                                    (_a3 = prev.beforeLoadPromise) == null || _a3.resolve();
                                    (_b3 = prev.loadPromise) == null || _b3.resolve();
                                    return {
                                        ...prev,
                                        error: err,
                                        status: "error",
                                        isFetching: false,
                                        updatedAt: Date.now(),
                                        abortController: new AbortController(),
                                        beforeLoadPromise: void 0
                                    };
                                });
                            };
                            for (const [index, { id: matchId, routeId: routeId }] of matches.entries()){
                                const existingMatch = this.getMatch(matchId);
                                const parentMatchId = (_a = matches[index - 1]) == null ? void 0 : _a.id;
                                const route = this.looseRoutesById[routeId];
                                const pendingMs = route.options.pendingMs ?? this.options.defaultPendingMs;
                                const shouldPending = !!(onReady && !this.isServer && !resolvePreload(matchId) && (route.options.loader || route.options.beforeLoad) && typeof pendingMs === "number" && pendingMs !== Infinity && (route.options.pendingComponent ?? this.options.defaultPendingComponent));
                                let executeBeforeLoad = true;
                                if (// If we are in the middle of a load, either of these will be present
                                // (not to be confused with `loadPromise`, which is always defined)
                                existingMatch.beforeLoadPromise || existingMatch.loaderPromise) {
                                    if (shouldPending) setTimeout(()=>{
                                        try {
                                            triggerOnReady();
                                        } catch  {}
                                    }, pendingMs);
                                    await existingMatch.beforeLoadPromise;
                                    executeBeforeLoad = this.getMatch(matchId).status !== "success";
                                }
                                if (executeBeforeLoad) {
                                    try {
                                        updateMatch(matchId, (prev)=>({
                                                ...prev,
                                                loadPromise: (0, $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd)(()=>{
                                                    var _a2;
                                                    (_a2 = prev.loadPromise) == null || _a2.resolve();
                                                }),
                                                beforeLoadPromise: (0, $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd)()
                                            }));
                                        const abortController = new AbortController();
                                        let pendingTimeout;
                                        if (shouldPending) pendingTimeout = setTimeout(()=>{
                                            try {
                                                triggerOnReady();
                                            } catch  {}
                                        }, pendingMs);
                                        const { paramsError: paramsError, searchError: searchError } = this.getMatch(matchId);
                                        if (paramsError) handleSerialError(index, paramsError, "PARSE_PARAMS");
                                        if (searchError) handleSerialError(index, searchError, "VALIDATE_SEARCH");
                                        const getParentMatchContext = ()=>parentMatchId ? this.getMatch(parentMatchId).context : this.options.context ?? {};
                                        updateMatch(matchId, (prev)=>({
                                                ...prev,
                                                isFetching: "beforeLoad",
                                                fetchCount: prev.fetchCount + 1,
                                                abortController: abortController,
                                                pendingTimeout: pendingTimeout,
                                                context: {
                                                    ...getParentMatchContext(),
                                                    ...prev.__routeContext
                                                }
                                            }));
                                        const { search: search, params: params, context: context, cause: cause } = this.getMatch(matchId);
                                        const preload = resolvePreload(matchId);
                                        const beforeLoadFnContext = {
                                            search: search,
                                            abortController: abortController,
                                            params: params,
                                            preload: preload,
                                            context: context,
                                            location: location,
                                            navigate: (opts)=>this.navigate({
                                                    ...opts,
                                                    _fromLocation: location
                                                }),
                                            buildLocation: this.buildLocation,
                                            cause: preload ? "preload" : cause,
                                            matches: matches
                                        };
                                        const beforeLoadContext = await ((_c = (_b = route.options).beforeLoad) == null ? void 0 : _c.call(_b, beforeLoadFnContext)) ?? {};
                                        if ((0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(beforeLoadContext) || (0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(beforeLoadContext)) handleSerialError(index, beforeLoadContext, "BEFORE_LOAD");
                                        updateMatch(matchId, (prev)=>{
                                            return {
                                                ...prev,
                                                __beforeLoadContext: beforeLoadContext,
                                                context: {
                                                    ...getParentMatchContext(),
                                                    ...prev.__routeContext,
                                                    ...beforeLoadContext
                                                },
                                                abortController: abortController
                                            };
                                        });
                                    } catch (err) {
                                        handleSerialError(index, err, "BEFORE_LOAD");
                                    }
                                    updateMatch(matchId, (prev)=>{
                                        var _a2;
                                        (_a2 = prev.beforeLoadPromise) == null || _a2.resolve();
                                        return {
                                            ...prev,
                                            beforeLoadPromise: void 0,
                                            isFetching: false
                                        };
                                    });
                                }
                            }
                            const validResolvedMatches = matches.slice(0, firstBadMatchIndex);
                            const matchPromises = [];
                            validResolvedMatches.forEach(({ id: matchId, routeId: routeId }, index)=>{
                                matchPromises.push((async ()=>{
                                    const { loaderPromise: prevLoaderPromise } = this.getMatch(matchId);
                                    let loaderShouldRunAsync = false;
                                    let loaderIsRunningAsync = false;
                                    if (prevLoaderPromise) {
                                        await prevLoaderPromise;
                                        const match = this.getMatch(matchId);
                                        if (match.error) handleRedirectAndNotFound(match, match.error);
                                    } else {
                                        const parentMatchPromise = matchPromises[index - 1];
                                        const route = this.looseRoutesById[routeId];
                                        const getLoaderContext = ()=>{
                                            const { params: params, loaderDeps: loaderDeps, abortController: abortController, context: context, cause: cause } = this.getMatch(matchId);
                                            const preload2 = resolvePreload(matchId);
                                            return {
                                                params: params,
                                                deps: loaderDeps,
                                                preload: !!preload2,
                                                parentMatchPromise: parentMatchPromise,
                                                abortController: abortController,
                                                context: context,
                                                location: location,
                                                navigate: (opts)=>this.navigate({
                                                        ...opts,
                                                        _fromLocation: location
                                                    }),
                                                cause: preload2 ? "preload" : cause,
                                                route: route
                                            };
                                        };
                                        const age = Date.now() - this.getMatch(matchId).updatedAt;
                                        const preload = resolvePreload(matchId);
                                        const staleAge = preload ? route.options.preloadStaleTime ?? this.options.defaultPreloadStaleTime ?? 3e4 : route.options.staleTime ?? this.options.defaultStaleTime ?? 0;
                                        const shouldReloadOption = route.options.shouldReload;
                                        const shouldReload = typeof shouldReloadOption === "function" ? shouldReloadOption(getLoaderContext()) : shouldReloadOption;
                                        updateMatch(matchId, (prev)=>({
                                                ...prev,
                                                loaderPromise: (0, $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd)(),
                                                preload: !!preload && !this.state.matches.find((d)=>d.id === matchId)
                                            }));
                                        const runLoader = async ()=>{
                                            var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k;
                                            try {
                                                const potentialPendingMinPromise = async ()=>{
                                                    const latestMatch = this.getMatch(matchId);
                                                    if (latestMatch.minPendingPromise) await latestMatch.minPendingPromise;
                                                };
                                                try {
                                                    this.loadRouteChunk(route);
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            isFetching: "loader"
                                                        }));
                                                    const loaderData = await ((_b2 = (_a2 = route.options).loader) == null ? void 0 : _b2.call(_a2, getLoaderContext()));
                                                    handleRedirectAndNotFound(this.getMatch(matchId), loaderData);
                                                    await route._lazyPromise;
                                                    await potentialPendingMinPromise();
                                                    const assetContext = {
                                                        matches: matches,
                                                        match: this.getMatch(matchId),
                                                        params: this.getMatch(matchId).params,
                                                        loaderData: loaderData
                                                    };
                                                    const headFnContent = (_d = (_c2 = route.options).head) == null ? void 0 : _d.call(_c2, assetContext);
                                                    const meta = headFnContent == null ? void 0 : headFnContent.meta;
                                                    const links = headFnContent == null ? void 0 : headFnContent.links;
                                                    const headScripts = headFnContent == null ? void 0 : headFnContent.scripts;
                                                    const scripts = (_f = (_e = route.options).scripts) == null ? void 0 : _f.call(_e, assetContext);
                                                    const headers = (_h = (_g = route.options).headers) == null ? void 0 : _h.call(_g, {
                                                        loaderData: loaderData
                                                    });
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            error: void 0,
                                                            status: "success",
                                                            isFetching: false,
                                                            updatedAt: Date.now(),
                                                            loaderData: loaderData,
                                                            meta: meta,
                                                            links: links,
                                                            headScripts: headScripts,
                                                            headers: headers,
                                                            scripts: scripts
                                                        }));
                                                } catch (e) {
                                                    let error = e;
                                                    await potentialPendingMinPromise();
                                                    handleRedirectAndNotFound(this.getMatch(matchId), e);
                                                    try {
                                                        (_j = (_i = route.options).onError) == null || _j.call(_i, e);
                                                    } catch (onErrorError) {
                                                        error = onErrorError;
                                                        handleRedirectAndNotFound(this.getMatch(matchId), onErrorError);
                                                    }
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            error: error,
                                                            status: "error",
                                                            isFetching: false
                                                        }));
                                                }
                                                (_k = this.serverSsr) == null || _k.onMatchSettled({
                                                    router: this,
                                                    match: this.getMatch(matchId)
                                                });
                                                await route._componentsPromise;
                                            } catch (err) {
                                                updateMatch(matchId, (prev)=>({
                                                        ...prev,
                                                        loaderPromise: void 0
                                                    }));
                                                handleRedirectAndNotFound(this.getMatch(matchId), err);
                                            }
                                        };
                                        const { status: status, invalid: invalid } = this.getMatch(matchId);
                                        loaderShouldRunAsync = status === "success" && (invalid || (shouldReload ?? age > staleAge));
                                        if (preload && route.options.preload === false) ;
                                        else if (loaderShouldRunAsync && !sync) {
                                            loaderIsRunningAsync = true;
                                            (async ()=>{
                                                try {
                                                    await runLoader();
                                                    const { loaderPromise: loaderPromise, loadPromise: loadPromise } = this.getMatch(matchId);
                                                    loaderPromise == null || loaderPromise.resolve();
                                                    loadPromise == null || loadPromise.resolve();
                                                    updateMatch(matchId, (prev)=>({
                                                            ...prev,
                                                            loaderPromise: void 0
                                                        }));
                                                } catch (err) {
                                                    if ((0, $0102957b4ec7a2a4$export$d8d25f72d542813b)(err)) await this.navigate(err);
                                                }
                                            })();
                                        } else if (status !== "success" || loaderShouldRunAsync && sync) await runLoader();
                                    }
                                    if (!loaderIsRunningAsync) {
                                        const { loaderPromise: loaderPromise, loadPromise: loadPromise } = this.getMatch(matchId);
                                        loaderPromise == null || loaderPromise.resolve();
                                        loadPromise == null || loadPromise.resolve();
                                    }
                                    updateMatch(matchId, (prev)=>({
                                            ...prev,
                                            isFetching: loaderIsRunningAsync ? prev.isFetching : false,
                                            loaderPromise: loaderIsRunningAsync ? prev.loaderPromise : void 0,
                                            invalid: false
                                        }));
                                    return this.getMatch(matchId);
                                })());
                            });
                            await Promise.all(matchPromises);
                            resolveAll();
                        } catch (err) {
                            rejectAll(err);
                        }
                    })();
                });
                await triggerOnReady();
            } catch (err) {
                if ((0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(err) || (0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err)) {
                    if ((0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err) && !allPreload) await triggerOnReady();
                    throw err;
                }
            }
            return matches;
        };
        this.invalidate = (opts)=>{
            const invalidate = (d)=>{
                var _a;
                if (((_a = opts == null ? void 0 : opts.filter) == null ? void 0 : _a.call(opts, d)) ?? true) return {
                    ...d,
                    invalid: true,
                    ...d.status === "error" ? {
                        status: "pending",
                        error: void 0
                    } : {}
                };
                return d;
            };
            this.__store.setState((s)=>{
                var _a;
                return {
                    ...s,
                    matches: s.matches.map(invalidate),
                    cachedMatches: s.cachedMatches.map(invalidate),
                    pendingMatches: (_a = s.pendingMatches) == null ? void 0 : _a.map(invalidate)
                };
            });
            return this.load({
                sync: opts == null ? void 0 : opts.sync
            });
        };
        this.resolveRedirect = (err)=>{
            const redirect = err;
            if (!redirect.href) redirect.href = this.buildLocation(redirect).href;
            return redirect;
        };
        this.clearCache = (opts)=>{
            const filter = opts == null ? void 0 : opts.filter;
            if (filter !== void 0) this.__store.setState((s)=>{
                return {
                    ...s,
                    cachedMatches: s.cachedMatches.filter((m)=>!filter(m))
                };
            });
            else this.__store.setState((s)=>{
                return {
                    ...s,
                    cachedMatches: []
                };
            });
        };
        this.clearExpiredCache = ()=>{
            const filter = (d)=>{
                const route = this.looseRoutesById[d.routeId];
                if (!route.options.loader) return true;
                const gcTime = (d.preload ? route.options.preloadGcTime ?? this.options.defaultPreloadGcTime : route.options.gcTime ?? this.options.defaultGcTime) ?? 300000;
                return !(d.status !== "error" && Date.now() - d.updatedAt < gcTime);
            };
            this.clearCache({
                filter: filter
            });
        };
        this.loadRouteChunk = (route)=>{
            if (route._lazyPromise === void 0) {
                if (route.lazyFn) route._lazyPromise = route.lazyFn().then((lazyRoute)=>{
                    const { id: _id, ...options2 } = lazyRoute.options;
                    Object.assign(route.options, options2);
                });
                else route._lazyPromise = Promise.resolve();
            }
            if (route._componentsPromise === void 0) route._componentsPromise = route._lazyPromise.then(()=>Promise.all($ab96d7f38df4df97$export$741158c5c07285bb.map(async (type)=>{
                    const component = route.options[type];
                    if (component == null ? void 0 : component.preload) await component.preload();
                })));
            return route._componentsPromise;
        };
        this.preloadRoute = async (opts)=>{
            const next = this.buildLocation(opts);
            let matches = this.matchRoutes(next, {
                throwOnError: true,
                preload: true,
                dest: opts
            });
            const activeMatchIds = new Set([
                ...this.state.matches,
                ...this.state.pendingMatches ?? []
            ].map((d)=>d.id));
            const loadedMatchIds = /* @__PURE__ */ new Set([
                ...activeMatchIds,
                ...this.state.cachedMatches.map((d)=>d.id)
            ]);
            (0, $9203abc22ef76827$export$712ea50be43a7858)(()=>{
                matches.forEach((match)=>{
                    if (!loadedMatchIds.has(match.id)) this.__store.setState((s)=>({
                            ...s,
                            cachedMatches: [
                                ...s.cachedMatches,
                                match
                            ]
                        }));
                });
            });
            try {
                matches = await this.loadMatches({
                    matches: matches,
                    location: next,
                    preload: true,
                    updateMatch: (id, updater)=>{
                        if (activeMatchIds.has(id)) matches = matches.map((d)=>d.id === id ? updater(d) : d);
                        else this.updateMatch(id, updater);
                    }
                });
                return matches;
            } catch (err) {
                if ((0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(err)) {
                    if (err.reloadDocument) return void 0;
                    return await this.preloadRoute({
                        ...err,
                        _fromLocation: next
                    });
                }
                if (!(0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(err)) console.error(err);
                return void 0;
            }
        };
        this.matchRoute = (location, opts)=>{
            const matchLocation = {
                ...location,
                to: location.to ? this.resolvePathWithBase(location.from || "", location.to) : void 0,
                params: location.params || {},
                leaveParams: true
            };
            const next = this.buildLocation(matchLocation);
            if ((opts == null ? void 0 : opts.pending) && this.state.status !== "pending") return false;
            const pending = (opts == null ? void 0 : opts.pending) === void 0 ? !this.state.isLoading : opts.pending;
            const baseLocation = pending ? this.latestLocation : this.state.resolvedLocation || this.state.location;
            const match = (0, $355b3a1b8fb8b573$export$b71b01274a8bb9ec)(this.basepath, baseLocation.pathname, {
                ...opts,
                to: next.pathname
            });
            if (!match) return false;
            if (location.params) {
                if (!(0, $04e51d94e9f9f85e$export$9cb4719e2e525b7a)(match, location.params, {
                    partial: true
                })) return false;
            }
            if (match && ((opts == null ? void 0 : opts.includeSearch) ?? true)) return (0, $04e51d94e9f9f85e$export$9cb4719e2e525b7a)(baseLocation.search, next.search, {
                partial: true
            }) ? match : false;
            return match;
        };
        this._handleNotFound = (matches, err, { updateMatch: updateMatch = this.updateMatch } = {})=>{
            const matchesByRouteId = Object.fromEntries(matches.map((match2)=>[
                    match2.routeId,
                    match2
                ]));
            let routeCursor = (err.global ? this.looseRoutesById[0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5] : this.looseRoutesById[err.routeId]) || this.looseRoutesById[0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5];
            while(!routeCursor.options.notFoundComponent && !this.options.defaultNotFoundComponent && routeCursor.id !== (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5)){
                routeCursor = routeCursor.parentRoute;
                (0, $85f606e562c81b96$export$2e2bcd8739ae039)(routeCursor, "Found invalid route tree while trying to find not-found handler.");
            }
            const match = matchesByRouteId[routeCursor.id];
            (0, $85f606e562c81b96$export$2e2bcd8739ae039)(match, "Could not find match for route: " + routeCursor.id);
            updateMatch(match.id, (prev)=>({
                    ...prev,
                    status: "notFound",
                    error: err,
                    isFetching: false
                }));
            if (err.routerCode === "BEFORE_LOAD" && routeCursor.parentRoute) {
                err.routeId = routeCursor.parentRoute.id;
                this._handleNotFound(matches, err, {
                    updateMatch: updateMatch
                });
            }
        };
        this.hasNotFoundMatch = ()=>{
            return this.__store.state.matches.some((d)=>d.status === "notFound" || d.globalNotFound);
        };
        this.update({
            defaultPreloadDelay: 50,
            defaultPendingMs: 1e3,
            defaultPendingMinMs: 500,
            context: void 0,
            ...options,
            caseSensitive: options.caseSensitive ?? false,
            notFoundMode: options.notFoundMode ?? "fuzzy",
            stringifySearch: options.stringifySearch ?? (0, $44c48fc48d718bd3$export$68863d04f13b25ce),
            parseSearch: options.parseSearch ?? (0, $44c48fc48d718bd3$export$3d477def621690a6)
        });
        if (typeof document !== "undefined") window.__TSR_ROUTER__ = this;
    }
    get state() {
        return this.__store.state;
    }
    get looseRoutesById() {
        return this.routesById;
    }
    matchRoutes(pathnameOrNext, locationSearchOrOpts, opts) {
        if (typeof pathnameOrNext === "string") return this.matchRoutesInternal({
            pathname: pathnameOrNext,
            search: locationSearchOrOpts
        }, opts);
        else return this.matchRoutesInternal(pathnameOrNext, locationSearchOrOpts);
    }
    matchRoutesInternal(next, opts) {
        const { foundRoute: foundRoute, matchedRoutes: matchedRoutes, routeParams: routeParams } = this.getMatchedRoutes(next, opts == null ? void 0 : opts.dest);
        let isGlobalNotFound = false;
        if (// If we found a route, and it's not an index route and we have left over path
        foundRoute ? foundRoute.path !== "/" && routeParams["**"] : // Or if we didn't find a route and we have left over path
        (0, $355b3a1b8fb8b573$export$a33f08202c373623)(next.pathname)) {
            if (this.options.notFoundRoute) matchedRoutes.push(this.options.notFoundRoute);
            else isGlobalNotFound = true;
        }
        const globalNotFoundRouteId = (()=>{
            if (!isGlobalNotFound) return void 0;
            if (this.options.notFoundMode !== "root") for(let i = matchedRoutes.length - 1; i >= 0; i--){
                const route = matchedRoutes[i];
                if (route.children) return route.id;
            }
            return 0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5;
        })();
        const parseErrors = matchedRoutes.map((route)=>{
            var _a;
            let parsedParamsError;
            const parseParams = ((_a = route.options.params) == null ? void 0 : _a.parse) ?? route.options.parseParams;
            if (parseParams) try {
                const parsedParams = parseParams(routeParams);
                Object.assign(routeParams, parsedParams);
            } catch (err) {
                parsedParamsError = new $ab96d7f38df4df97$export$d54ad939fce4f123(err.message, {
                    cause: err
                });
                if (opts == null ? void 0 : opts.throwOnError) throw parsedParamsError;
                return parsedParamsError;
            }
            return;
        });
        const matches = [];
        const getParentContext = (parentMatch)=>{
            const parentMatchId = parentMatch == null ? void 0 : parentMatch.id;
            const parentContext = !parentMatchId ? this.options.context ?? {} : parentMatch.context ?? this.options.context ?? {};
            return parentContext;
        };
        matchedRoutes.forEach((route, index)=>{
            var _a, _b;
            const parentMatch = matches[index - 1];
            const [preMatchSearch, strictMatchSearch, searchError] = (()=>{
                const parentSearch = (parentMatch == null ? void 0 : parentMatch.search) ?? next.search;
                const parentStrictSearch = (parentMatch == null ? void 0 : parentMatch._strictSearch) ?? {};
                try {
                    const strictSearch = $ab96d7f38df4df97$var$validateSearch(route.options.validateSearch, {
                        ...parentSearch
                    }) ?? {};
                    return [
                        {
                            ...parentSearch,
                            ...strictSearch
                        },
                        {
                            ...parentStrictSearch,
                            ...strictSearch
                        },
                        void 0
                    ];
                } catch (err) {
                    let searchParamError = err;
                    if (!(err instanceof $ab96d7f38df4df97$export$ca74fadaf06bf7e1)) searchParamError = new $ab96d7f38df4df97$export$ca74fadaf06bf7e1(err.message, {
                        cause: err
                    });
                    if (opts == null ? void 0 : opts.throwOnError) throw searchParamError;
                    return [
                        parentSearch,
                        {},
                        searchParamError
                    ];
                }
            })();
            const loaderDeps = ((_b = (_a = route.options).loaderDeps) == null ? void 0 : _b.call(_a, {
                search: preMatchSearch
            })) ?? "";
            const loaderDepsHash = loaderDeps ? JSON.stringify(loaderDeps) : "";
            const { usedParams: usedParams, interpolatedPath: interpolatedPath } = (0, $355b3a1b8fb8b573$export$8ca4fd5908a217f6)({
                path: route.fullPath,
                params: routeParams,
                decodeCharMap: this.pathParamsDecodeCharMap
            });
            const matchId = (0, $355b3a1b8fb8b573$export$8ca4fd5908a217f6)({
                path: route.id,
                params: routeParams,
                leaveWildcards: true,
                decodeCharMap: this.pathParamsDecodeCharMap
            }).interpolatedPath + loaderDepsHash;
            const existingMatch = this.getMatch(matchId);
            const previousMatch = this.state.matches.find((d)=>d.routeId === route.id);
            const cause = previousMatch ? "stay" : "enter";
            let match;
            if (existingMatch) match = {
                ...existingMatch,
                cause: cause,
                params: previousMatch ? (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousMatch.params, routeParams) : routeParams,
                _strictParams: usedParams,
                search: previousMatch ? (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousMatch.search, preMatchSearch) : (0, $04e51d94e9f9f85e$export$77a71fc411098696)(existingMatch.search, preMatchSearch),
                _strictSearch: strictMatchSearch
            };
            else {
                const status = route.options.loader || route.options.beforeLoad || route.lazyFn || $ab96d7f38df4df97$var$routeNeedsPreload(route) ? "pending" : "success";
                match = {
                    id: matchId,
                    index: index,
                    routeId: route.id,
                    params: previousMatch ? (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousMatch.params, routeParams) : routeParams,
                    _strictParams: usedParams,
                    pathname: (0, $355b3a1b8fb8b573$export$86d9a7913e44197e)([
                        this.basepath,
                        interpolatedPath
                    ]),
                    updatedAt: Date.now(),
                    search: previousMatch ? (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousMatch.search, preMatchSearch) : preMatchSearch,
                    _strictSearch: strictMatchSearch,
                    searchError: void 0,
                    status: status,
                    isFetching: false,
                    error: void 0,
                    paramsError: parseErrors[index],
                    __routeContext: {},
                    __beforeLoadContext: {},
                    context: {},
                    abortController: new AbortController(),
                    fetchCount: 0,
                    cause: cause,
                    loaderDeps: previousMatch ? (0, $04e51d94e9f9f85e$export$77a71fc411098696)(previousMatch.loaderDeps, loaderDeps) : loaderDeps,
                    invalid: false,
                    preload: false,
                    links: void 0,
                    scripts: void 0,
                    headScripts: void 0,
                    meta: void 0,
                    staticData: route.options.staticData || {},
                    loadPromise: (0, $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd)(),
                    fullPath: route.fullPath
                };
            }
            if (!(opts == null ? void 0 : opts.preload)) match.globalNotFound = globalNotFoundRouteId === route.id;
            match.searchError = searchError;
            const parentContext = getParentContext(parentMatch);
            match.context = {
                ...parentContext,
                ...match.__routeContext,
                ...match.__beforeLoadContext
            };
            matches.push(match);
        });
        matches.forEach((match, index)=>{
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const route = this.looseRoutesById[match.routeId];
            const existingMatch = this.getMatch(match.id);
            if (!existingMatch && (opts == null ? void 0 : opts._buildLocation) !== true) {
                const parentMatch = matches[index - 1];
                const parentContext = getParentContext(parentMatch);
                const contextFnContext = {
                    deps: match.loaderDeps,
                    params: match.params,
                    context: parentContext,
                    location: next,
                    navigate: (opts2)=>this.navigate({
                            ...opts2,
                            _fromLocation: next
                        }),
                    buildLocation: this.buildLocation,
                    cause: match.cause,
                    abortController: match.abortController,
                    preload: !!match.preload,
                    matches: matches
                };
                match.__routeContext = ((_b = (_a = route.options).context) == null ? void 0 : _b.call(_a, contextFnContext)) ?? {};
                match.context = {
                    ...parentContext,
                    ...match.__routeContext,
                    ...match.__beforeLoadContext
                };
            }
            if (match.status === "success") {
                match.headers = (_d = (_c = route.options).headers) == null ? void 0 : _d.call(_c, {
                    loaderData: match.loaderData
                });
                const assetContext = {
                    matches: matches,
                    match: match,
                    params: match.params,
                    loaderData: match.loaderData
                };
                const headFnContent = (_f = (_e = route.options).head) == null ? void 0 : _f.call(_e, assetContext);
                match.links = headFnContent == null ? void 0 : headFnContent.links;
                match.headScripts = headFnContent == null ? void 0 : headFnContent.scripts;
                match.meta = headFnContent == null ? void 0 : headFnContent.meta;
                match.scripts = (_h = (_g = route.options).scripts) == null ? void 0 : _h.call(_g, assetContext);
            }
        });
        return matches;
    }
}
function $ab96d7f38df4df97$export$5dc1db391e531241(fn, key) {
    return async (...args)=>{
        const imported = await fn();
        return imported[key || "default"](...args);
    };
}
class $ab96d7f38df4df97$export$ca74fadaf06bf7e1 extends Error {
}
class $ab96d7f38df4df97$export$d54ad939fce4f123 extends Error {
}
function $ab96d7f38df4df97$export$baa2404bdcb7f08c(location) {
    return {
        loadedAt: 0,
        isLoading: false,
        isTransitioning: false,
        status: "idle",
        resolvedLocation: void 0,
        location: location,
        matches: [],
        pendingMatches: [],
        cachedMatches: [],
        statusCode: 200
    };
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
const $f35037490a5c55c9$export$fe194d064ae6fae0 = "Error preloading route! \u261D\uFE0F";





var $acw62 = parcelRequire("acw62");
function $30d238b521d6ee2e$export$1a8b1350915fe2e0(fn) {
    const fnRef = $acw62.useRef(fn);
    fnRef.current = fn;
    const ref = $acw62.useRef((...args)=>fnRef.current(...args));
    return ref.current;
}
const $30d238b521d6ee2e$export$e5c5a5f917a5871c = typeof window !== "undefined" ? $acw62.useLayoutEffect : $acw62.useEffect;
function $30d238b521d6ee2e$export$5cae361ad82dce8b(value) {
    const ref = $acw62.useRef({
        value: value,
        prev: null
    });
    const current = ref.current.value;
    if (value !== current) ref.current = {
        value: value,
        prev: current
    };
    return ref.current.prev;
}
function $30d238b521d6ee2e$export$a7395f9832c00176(ref, callback, intersectionObserverOptions = {}, options = {}) {
    const isIntersectionObserverAvailable = $acw62.useRef(typeof IntersectionObserver === "function");
    const observerRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (!ref.current || !isIntersectionObserverAvailable.current || options.disabled) return;
        observerRef.current = new IntersectionObserver(([entry])=>{
            callback(entry);
        }, intersectionObserverOptions);
        observerRef.current.observe(ref.current);
        return ()=>{
            var _a;
            (_a = observerRef.current) == null || _a.disconnect();
        };
    }, [
        callback,
        intersectionObserverOptions,
        options.disabled,
        ref
    ]);
    return observerRef.current;
}
function $30d238b521d6ee2e$export$61dc559f8a0b9bcf(ref) {
    const innerRef = $acw62.useRef(null);
    $acw62.useImperativeHandle(ref, ()=>innerRef.current, []);
    return innerRef;
}



function $15b3b5f25f2a096d$export$7e924b3091a3bd18(options, forwardedRef) {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const [isTransitioning, setIsTransitioning] = $acw62.useState(false);
    const hasRenderFetched = $acw62.useRef(false);
    const innerRef = (0, $30d238b521d6ee2e$export$61dc559f8a0b9bcf)(forwardedRef);
    const { activeProps: // custom props
    activeProps = ()=>({
            className: "active"
        }), inactiveProps: inactiveProps = ()=>({}), activeOptions: activeOptions, to: to, preload: userPreload, preloadDelay: userPreloadDelay, hashScrollIntoView: hashScrollIntoView, replace: replace, startTransition: startTransition, resetScroll: resetScroll, viewTransition: viewTransition, children: // element props
    children, target: target, disabled: disabled, style: style, className: className, onClick: onClick, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart, ignoreBlocker: ignoreBlocker, ...rest } = options;
    const { // prevent these from being returned
    params: _params, search: _search, hash: _hash, state: _state, mask: _mask, reloadDocument: _reloadDocument, ...propsSafeToSpread } = rest;
    const type = $acw62.useMemo(()=>{
        try {
            new URL(`${to}`);
            return "external";
        } catch  {}
        return "internal";
    }, [
        to
    ]);
    const currentSearch = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>s.location.search,
        structuralSharing: true
    });
    const parentRouteId = (0, $de3e60c6a5d77104$export$6c330e8992e8a295)({
        strict: false,
        select: (s)=>s.pathname
    });
    options = {
        from: parentRouteId,
        ...options
    };
    const next = $acw62.useMemo(()=>router.buildLocation(options), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        router,
        options,
        currentSearch
    ]);
    const preload = $acw62.useMemo(()=>{
        if (options.reloadDocument) return false;
        return userPreload ?? router.options.defaultPreload;
    }, [
        router.options.defaultPreload,
        userPreload,
        options.reloadDocument
    ]);
    const preloadDelay = userPreloadDelay ?? router.options.defaultPreloadDelay ?? 0;
    const isActive = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            if (activeOptions == null ? void 0 : activeOptions.exact) {
                const testExact = (0, $355b3a1b8fb8b573$export$c2ef510b203b107f)(s.location.pathname, next.pathname, router.basepath);
                if (!testExact) return false;
            } else {
                const currentPathSplit = (0, $355b3a1b8fb8b573$export$b6d465111d914331)(s.location.pathname, router.basepath).split("/");
                const nextPathSplit = (0, $355b3a1b8fb8b573$export$b6d465111d914331)(next.pathname, router.basepath).split("/");
                const pathIsFuzzyEqual = nextPathSplit.every((d, i)=>d === currentPathSplit[i]);
                if (!pathIsFuzzyEqual) return false;
            }
            if ((activeOptions == null ? void 0 : activeOptions.includeSearch) ?? true) {
                const searchTest = (0, $04e51d94e9f9f85e$export$9cb4719e2e525b7a)(s.location.search, next.search, {
                    partial: !(activeOptions == null ? void 0 : activeOptions.exact),
                    ignoreUndefined: !(activeOptions == null ? void 0 : activeOptions.explicitUndefined)
                });
                if (!searchTest) return false;
            }
            if (activeOptions == null ? void 0 : activeOptions.includeHash) return s.location.hash === next.hash;
            return true;
        }
    });
    const doPreload = $acw62.useCallback(()=>{
        router.preloadRoute(options).catch((err)=>{
            console.warn(err);
            console.warn((0, $f35037490a5c55c9$export$fe194d064ae6fae0));
        });
    }, [
        options,
        router
    ]);
    const preloadViewportIoCallback = $acw62.useCallback((entry)=>{
        if (entry == null ? void 0 : entry.isIntersecting) doPreload();
    }, [
        doPreload
    ]);
    (0, $30d238b521d6ee2e$export$a7395f9832c00176)(innerRef, preloadViewportIoCallback, {
        rootMargin: "100px"
    }, {
        disabled: !!disabled || !(preload === "viewport")
    });
    (0, $30d238b521d6ee2e$export$e5c5a5f917a5871c)(()=>{
        if (hasRenderFetched.current) return;
        if (!disabled && preload === "render") {
            doPreload();
            hasRenderFetched.current = true;
        }
    }, [
        disabled,
        doPreload,
        preload
    ]);
    if (type === "external") return {
        ...propsSafeToSpread,
        ref: innerRef,
        type: type,
        href: to,
        ...children && {
            children: children
        },
        ...target && {
            target: target
        },
        ...disabled && {
            disabled: disabled
        },
        ...style && {
            style: style
        },
        ...className && {
            className: className
        },
        ...onClick && {
            onClick: onClick
        },
        ...onFocus && {
            onFocus: onFocus
        },
        ...onMouseEnter && {
            onMouseEnter: onMouseEnter
        },
        ...onMouseLeave && {
            onMouseLeave: onMouseLeave
        },
        ...onTouchStart && {
            onTouchStart: onTouchStart
        }
    };
    const handleClick = (e)=>{
        if (!disabled && !$15b3b5f25f2a096d$var$isCtrlEvent(e) && !e.defaultPrevented && (!target || target === "_self") && e.button === 0) {
            e.preventDefault();
            (0, $1u0KT.flushSync)(()=>{
                setIsTransitioning(true);
            });
            const unsub = router.subscribe("onResolved", ()=>{
                unsub();
                setIsTransitioning(false);
            });
            return router.navigate({
                ...options,
                replace: replace,
                resetScroll: resetScroll,
                hashScrollIntoView: hashScrollIntoView,
                startTransition: startTransition,
                viewTransition: viewTransition,
                ignoreBlocker: ignoreBlocker
            });
        }
    };
    const handleFocus = (_)=>{
        if (disabled) return;
        if (preload) doPreload();
    };
    const handleTouchStart = handleFocus;
    const handleEnter = (e)=>{
        if (disabled) return;
        const eventTarget = e.target || {};
        if (preload) {
            if (eventTarget.preloadTimeout) return;
            eventTarget.preloadTimeout = setTimeout(()=>{
                eventTarget.preloadTimeout = null;
                doPreload();
            }, preloadDelay);
        }
    };
    const handleLeave = (e)=>{
        if (disabled) return;
        const eventTarget = e.target || {};
        if (eventTarget.preloadTimeout) {
            clearTimeout(eventTarget.preloadTimeout);
            eventTarget.preloadTimeout = null;
        }
    };
    const composeHandlers = (handlers)=>(e)=>{
            var _a;
            (_a = e.persist) == null || _a.call(e);
            handlers.filter(Boolean).forEach((handler)=>{
                if (e.defaultPrevented) return;
                handler(e);
            });
        };
    const resolvedActiveProps = isActive ? (0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(activeProps, {}) ?? {} : {};
    const resolvedInactiveProps = isActive ? {} : (0, $04e51d94e9f9f85e$export$7f095f455ad5af3f)(inactiveProps, {});
    const resolvedClassName = [
        className,
        resolvedActiveProps.className,
        resolvedInactiveProps.className
    ].filter(Boolean).join(" ");
    const resolvedStyle = {
        ...style,
        ...resolvedActiveProps.style,
        ...resolvedInactiveProps.style
    };
    return {
        ...propsSafeToSpread,
        ...resolvedActiveProps,
        ...resolvedInactiveProps,
        href: disabled ? void 0 : next.maskedLocation ? router.history.createHref(next.maskedLocation.href) : router.history.createHref(next.href),
        ref: innerRef,
        onClick: composeHandlers([
            onClick,
            handleClick
        ]),
        onFocus: composeHandlers([
            onFocus,
            handleFocus
        ]),
        onMouseEnter: composeHandlers([
            onMouseEnter,
            handleEnter
        ]),
        onMouseLeave: composeHandlers([
            onMouseLeave,
            handleLeave
        ]),
        onTouchStart: composeHandlers([
            onTouchStart,
            handleTouchStart
        ]),
        disabled: !!disabled,
        target: target,
        ...Object.keys(resolvedStyle).length && {
            style: resolvedStyle
        },
        ...resolvedClassName && {
            className: resolvedClassName
        },
        ...disabled && {
            role: "link",
            "aria-disabled": true
        },
        ...isActive && {
            "data-status": "active",
            "aria-current": "page"
        },
        ...isTransitioning && {
            "data-transitioning": "transitioning"
        }
    };
}
function $15b3b5f25f2a096d$export$cdda5b1be25f9499(Comp) {
    return $acw62.forwardRef(function CreatedLink(props, ref) {
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($15b3b5f25f2a096d$export$a6c7ac8248d6e38a, {
            ...props,
            _asChild: Comp,
            ref: ref
        });
    });
}
const $15b3b5f25f2a096d$export$a6c7ac8248d6e38a = $acw62.forwardRef((props, ref)=>{
    const { _asChild: _asChild, ...rest } = props;
    const { type: _type, ref: innerRef, ...linkProps } = $15b3b5f25f2a096d$export$7e924b3091a3bd18(rest, ref);
    const children = typeof rest.children === "function" ? rest.children({
        isActive: linkProps["data-status"] === "active"
    }) : rest.children;
    if (typeof _asChild === "undefined") delete linkProps.disabled;
    return $acw62.createElement(_asChild ? _asChild : "a", {
        ...linkProps,
        ref: innerRef
    }, children);
});
function $15b3b5f25f2a096d$var$isCtrlEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
const $15b3b5f25f2a096d$export$e59c53748bd0ed3d = (options)=>{
    return options;
};



var $acw62 = parcelRequire("acw62");










function $9c9e90a165af06cf$export$c5d4c6a51def1c34(props) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: props.children
    });
}





function $061633c33a3822f5$export$a1a97285826ef395(router, route, data) {
    if (!route.options.notFoundComponent) {
        if (router.options.defaultNotFoundComponent) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(router.options.defaultNotFoundComponent, {
            data: data
        });
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $b6f3b75e7e86ba46$export$8d79a25eb6fbadf1), {});
    }
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(route.options.notFoundComponent, {
        data: data
    });
}



const $9af09e1809bab698$export$f421feb8fad20413 = $acw62.memo(function MatchImpl({ matchId: matchId }) {
    var _a, _b;
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const routeId = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            var _a2;
            return (_a2 = s.matches.find((d)=>d.id === matchId)) == null ? void 0 : _a2.routeId;
        }
    });
    (0, $85f606e562c81b96$export$2e2bcd8739ae039)(routeId, `Could not find routeId for matchId "${matchId}". Please file an issue!`);
    const route = router.routesById[routeId];
    const PendingComponent = route.options.pendingComponent ?? router.options.defaultPendingComponent;
    const pendingElement = PendingComponent ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(PendingComponent, {}) : null;
    const routeErrorComponent = route.options.errorComponent ?? router.options.defaultErrorComponent;
    const routeOnCatch = route.options.onCatch ?? router.options.defaultOnCatch;
    const routeNotFoundComponent = route.isRoot ? // If it's the root route, use the globalNotFound option, with fallback to the notFoundRoute's component
    route.options.notFoundComponent ?? ((_a = router.options.notFoundRoute) == null ? void 0 : _a.options.component) : route.options.notFoundComponent;
    const ResolvedSuspenseBoundary = // If we're on the root route, allow forcefully wrapping in suspense
    (!route.isRoot || route.options.wrapInSuspense) && (route.options.wrapInSuspense ?? PendingComponent ?? ((_b = route.options.errorComponent) == null ? void 0 : _b.preload)) ? $acw62.Suspense : (0, $9c9e90a165af06cf$export$c5d4c6a51def1c34);
    const ResolvedCatchBoundary = routeErrorComponent ? (0, $145e97952daea58a$export$d924b55053fc70c) : (0, $9c9e90a165af06cf$export$c5d4c6a51def1c34);
    const ResolvedNotFoundBoundary = routeNotFoundComponent ? (0, $b6f3b75e7e86ba46$export$5b0f5088d44b945c) : (0, $9c9e90a165af06cf$export$c5d4c6a51def1c34);
    const resetKey = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>s.loadedAt
    });
    const parentRouteId = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            var _a2;
            const index = s.matches.findIndex((d)=>d.id === matchId);
            return (_a2 = s.matches[index - 1]) == null ? void 0 : _a2.routeId;
        }
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bcdbf2acdfde29b9$export$f6b3e78d35813d66).Provider, {
                value: matchId,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ResolvedSuspenseBoundary, {
                    fallback: pendingElement,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ResolvedCatchBoundary, {
                        getResetKey: ()=>resetKey,
                        errorComponent: routeErrorComponent || (0, $145e97952daea58a$export$65db35c377fab04b),
                        onCatch: (error, errorInfo)=>{
                            if ((0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(error)) throw error;
                            (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(false, `Error in route match: ${matchId}`);
                            routeOnCatch == null || routeOnCatch(error, errorInfo);
                        },
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(ResolvedNotFoundBoundary, {
                            fallback: (error)=>{
                                if (!routeNotFoundComponent || error.routeId && error.routeId !== routeId || !error.routeId && !route.isRoot) throw error;
                                return $acw62.createElement(routeNotFoundComponent, error);
                            },
                            children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9af09e1809bab698$export$443bf6e486eb935a, {
                                matchId: matchId
                            })
                        })
                    })
                })
            }),
            parentRouteId === (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5) && router.options.scrollRestoration ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9af09e1809bab698$var$OnRendered, {}),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $41c66dec330ab2d6$export$11aac1aab828f1fa), {})
                ]
            }) : null
        ]
    });
});
function $9af09e1809bab698$var$OnRendered() {
    var _a;
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const prevLocationRef = $acw62.useRef(void 0);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("script", {
        suppressHydrationWarning: true,
        ref: (el)=>{
            if (el) router.emit({
                type: "onRendered",
                ...(0, $683377acaa6ecdcc$export$6c2b3e1c712e7fa6)(router.state)
            });
            else prevLocationRef.current = router.state.resolvedLocation;
        }
    }, (_a = router.state.resolvedLocation) == null ? void 0 : _a.state.key);
}
const $9af09e1809bab698$export$443bf6e486eb935a = $acw62.memo(function MatchInnerImpl({ matchId: matchId }) {
    var _a, _b, _c;
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const { match: match, key: key, routeId: routeId } = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            const matchIndex = s.matches.findIndex((d)=>d.id === matchId);
            const match2 = s.matches[matchIndex];
            const routeId2 = match2.routeId;
            const remountFn = router.routesById[routeId2].options.remountDeps ?? router.options.defaultRemountDeps;
            const remountDeps = remountFn == null ? void 0 : remountFn({
                routeId: routeId2,
                loaderDeps: match2.loaderDeps,
                params: match2._strictParams,
                search: match2._strictSearch
            });
            const key2 = remountDeps ? JSON.stringify(remountDeps) : void 0;
            return {
                key: key2,
                routeId: routeId2,
                match: (0, $04e51d94e9f9f85e$export$357523c63a2253b9)(match2, [
                    "id",
                    "status",
                    "error"
                ])
            };
        },
        structuralSharing: true
    });
    const route = router.routesById[routeId];
    const out = $acw62.useMemo(()=>{
        const Comp = route.options.component ?? router.options.defaultComponent;
        if (Comp) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(Comp, {}, key);
        return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9af09e1809bab698$export$910ae8079b2c2852, {});
    }, [
        key,
        route.options.component,
        router.options.defaultComponent
    ]);
    const RouteErrorComponent = (route.options.errorComponent ?? router.options.defaultErrorComponent) || (0, $145e97952daea58a$export$65db35c377fab04b);
    if (match.status === "notFound") {
        (0, $85f606e562c81b96$export$2e2bcd8739ae039)((0, $b6f3b75e7e86ba46$export$5ceecc1876a33e64)(match.error), "Expected a notFound error");
        return (0, $061633c33a3822f5$export$a1a97285826ef395)(router, route, match.error);
    }
    if (match.status === "redirected") {
        (0, $85f606e562c81b96$export$2e2bcd8739ae039)((0, $0102957b4ec7a2a4$export$4cb830d4f7e56898)(match.error), "Expected a redirect error");
        throw (_a = router.getMatch(match.id)) == null ? void 0 : _a.loadPromise;
    }
    if (match.status === "error") {
        if (router.isServer) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(RouteErrorComponent, {
            error: match.error,
            reset: void 0,
            info: {
                componentStack: ""
            }
        });
        throw match.error;
    }
    if (match.status === "pending") {
        const pendingMinMs = route.options.pendingMinMs ?? router.options.defaultPendingMinMs;
        if (pendingMinMs && !((_b = router.getMatch(match.id)) == null ? void 0 : _b.minPendingPromise)) {
            if (!router.isServer) {
                const minPendingPromise = (0, $04e51d94e9f9f85e$export$3a6d79ef8ea1e9fd)();
                Promise.resolve().then(()=>{
                    router.updateMatch(match.id, (prev)=>({
                            ...prev,
                            minPendingPromise: minPendingPromise
                        }));
                });
                setTimeout(()=>{
                    minPendingPromise.resolve();
                    router.updateMatch(match.id, (prev)=>({
                            ...prev,
                            minPendingPromise: void 0
                        }));
                }, pendingMinMs);
            }
        }
        throw (_c = router.getMatch(match.id)) == null ? void 0 : _c.loadPromise;
    }
    return out;
});
const $9af09e1809bab698$export$910ae8079b2c2852 = $acw62.memo(function OutletImpl() {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const matchId = $acw62.useContext((0, $bcdbf2acdfde29b9$export$f6b3e78d35813d66));
    const routeId = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            var _a;
            return (_a = s.matches.find((d)=>d.id === matchId)) == null ? void 0 : _a.routeId;
        }
    });
    const route = router.routesById[routeId];
    const parentGlobalNotFound = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            const matches = s.matches;
            const parentMatch = matches.find((d)=>d.id === matchId);
            (0, $85f606e562c81b96$export$2e2bcd8739ae039)(parentMatch, `Could not find parent match for matchId "${matchId}"`);
            return parentMatch.globalNotFound;
        }
    });
    const childMatchId = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            var _a;
            const matches = s.matches;
            const index = matches.findIndex((d)=>d.id === matchId);
            return (_a = matches[index + 1]) == null ? void 0 : _a.id;
        }
    });
    if (parentGlobalNotFound) return (0, $061633c33a3822f5$export$a1a97285826ef395)(router, route, void 0);
    if (!childMatchId) return null;
    const nextMatch = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9af09e1809bab698$export$f421feb8fad20413, {
        matchId: childMatchId
    });
    const pendingElement = router.options.defaultPendingComponent ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(router.options.defaultPendingComponent, {}) : null;
    if (matchId === (0, $00bc6db601cb5ffd$export$463ffa9af37e9ec5)) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($acw62.Suspense, {
        fallback: pendingElement,
        children: nextMatch
    });
    return nextMatch;
});




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");




function $374ad16b7b2e9f60$export$935eb9f0b5d28fbb() {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const mountLoadForRouter = $acw62.useRef({
        router: router,
        mounted: false
    });
    const isLoading = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: ({ isLoading: isLoading2 })=>isLoading2
    });
    const [isTransitioning, setIsTransitioning] = $acw62.useState(false);
    const hasPendingMatches = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>s.matches.some((d)=>d.status === "pending"),
        structuralSharing: true
    });
    const previousIsLoading = (0, $30d238b521d6ee2e$export$5cae361ad82dce8b)(isLoading);
    const isAnyPending = isLoading || isTransitioning || hasPendingMatches;
    const previousIsAnyPending = (0, $30d238b521d6ee2e$export$5cae361ad82dce8b)(isAnyPending);
    const isPagePending = isLoading || hasPendingMatches;
    const previousIsPagePending = (0, $30d238b521d6ee2e$export$5cae361ad82dce8b)(isPagePending);
    if (!router.isServer) router.startReactTransition = (fn)=>{
        setIsTransitioning(true);
        $acw62.startTransition(()=>{
            fn();
            setIsTransitioning(false);
        });
    };
    $acw62.useEffect(()=>{
        const unsub = router.history.subscribe(router.load);
        const nextLocation = router.buildLocation({
            to: router.latestLocation.pathname,
            search: true,
            params: true,
            hash: true,
            state: true,
            _includeValidateSearch: true
        });
        if ((0, $355b3a1b8fb8b573$export$a33f08202c373623)(router.latestLocation.href) !== (0, $355b3a1b8fb8b573$export$a33f08202c373623)(nextLocation.href)) router.commitLocation({
            ...nextLocation,
            replace: true
        });
        return ()=>{
            unsub();
        };
    }, [
        router,
        router.history
    ]);
    (0, $30d238b521d6ee2e$export$e5c5a5f917a5871c)(()=>{
        if (typeof window !== "undefined" && router.clientSsr || mountLoadForRouter.current.router === router && mountLoadForRouter.current.mounted) return;
        mountLoadForRouter.current = {
            router: router,
            mounted: true
        };
        const tryLoad = async ()=>{
            try {
                await router.load();
            } catch (err) {
                console.error(err);
            }
        };
        tryLoad();
    }, [
        router
    ]);
    (0, $30d238b521d6ee2e$export$e5c5a5f917a5871c)(()=>{
        if (previousIsLoading && !isLoading) router.emit({
            type: "onLoad",
            // When the new URL has committed, when the new matches have been loaded into state.matches
            ...(0, $683377acaa6ecdcc$export$6c2b3e1c712e7fa6)(router.state)
        });
    }, [
        previousIsLoading,
        router,
        isLoading
    ]);
    (0, $30d238b521d6ee2e$export$e5c5a5f917a5871c)(()=>{
        if (previousIsPagePending && !isPagePending) router.emit({
            type: "onBeforeRouteMount",
            ...(0, $683377acaa6ecdcc$export$6c2b3e1c712e7fa6)(router.state)
        });
    }, [
        isPagePending,
        previousIsPagePending,
        router
    ]);
    (0, $30d238b521d6ee2e$export$e5c5a5f917a5871c)(()=>{
        if (previousIsAnyPending && !isAnyPending) {
            router.emit({
                type: "onResolved",
                ...(0, $683377acaa6ecdcc$export$6c2b3e1c712e7fa6)(router.state)
            });
            router.__store.setState((s)=>({
                    ...s,
                    status: "idle",
                    resolvedLocation: s.location
                }));
        }
    }, [
        isAnyPending,
        previousIsAnyPending,
        router
    ]);
    return null;
}





function $79e24057cb9ad4b1$export$6479cfcac2b87c0() {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    const pendingElement = router.options.defaultPendingComponent ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(router.options.defaultPendingComponent, {}) : null;
    const ResolvedSuspense = router.isServer || typeof document !== "undefined" && router.clientSsr ? (0, $9c9e90a165af06cf$export$c5d4c6a51def1c34) : $acw62.Suspense;
    const inner = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)(ResolvedSuspense, {
        fallback: pendingElement,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $374ad16b7b2e9f60$export$935eb9f0b5d28fbb), {}),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($79e24057cb9ad4b1$var$MatchesInner, {})
        ]
    });
    return router.options.InnerWrap ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(router.options.InnerWrap, {
        children: inner
    }) : inner;
}
function $79e24057cb9ad4b1$var$MatchesInner() {
    const matchId = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            var _a;
            return (_a = s.matches[0]) == null ? void 0 : _a.id;
        }
    });
    const resetKey = (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>s.loadedAt
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $bcdbf2acdfde29b9$export$f6b3e78d35813d66).Provider, {
        value: matchId,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $145e97952daea58a$export$d924b55053fc70c), {
            getResetKey: ()=>resetKey,
            errorComponent: (0, $145e97952daea58a$export$65db35c377fab04b),
            onCatch: (error)=>{
                (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(false, `The following error wasn't caught by any route! At the very least, consider setting an 'errorComponent' in your RootRoute!`);
                (0, $72f8309e8b4c5d38$export$2e2bcd8739ae039)(false, error.message || error.toString());
            },
            children: matchId ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9af09e1809bab698$export$f421feb8fad20413), {
                matchId: matchId
            }) : null
        })
    });
}
function $79e24057cb9ad4b1$export$d2ec911fa7f74821() {
    const router = (0, $593b7c255e59942d$export$9a302a45f65d0572)();
    (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (s)=>{
            var _a;
            return [
                s.location.href,
                (_a = s.resolvedLocation) == null ? void 0 : _a.href,
                s.status
            ];
        },
        structuralSharing: true
    });
    return $acw62.useCallback((opts)=>{
        const { pending: pending, caseSensitive: caseSensitive, fuzzy: fuzzy, includeSearch: includeSearch, ...rest } = opts;
        return router.matchRoute(rest, {
            pending: pending,
            caseSensitive: caseSensitive,
            fuzzy: fuzzy,
            includeSearch: includeSearch
        });
    }, [
        router
    ]);
}
function $79e24057cb9ad4b1$export$d5ee5e80e8c60ef6(props) {
    const matchRoute = $79e24057cb9ad4b1$export$d2ec911fa7f74821();
    const params = matchRoute(props);
    if (typeof props.children === "function") return props.children(params);
    return params ? props.children : null;
}
function $79e24057cb9ad4b1$export$2378eb7f5ff86053(opts) {
    return (0, $5e4aaffff2c3630e$export$dbb5ccc270afbbb4)({
        select: (state)=>{
            const matches = state.matches;
            return (opts == null ? void 0 : opts.select) ? opts.select(matches) : matches;
        },
        structuralSharing: opts == null ? void 0 : opts.structuralSharing
    });
}
function $79e24057cb9ad4b1$export$d7cb33aa1707a132(opts) {
    const contextMatchId = $acw62.useContext((0, $bcdbf2acdfde29b9$export$f6b3e78d35813d66));
    return $79e24057cb9ad4b1$export$2378eb7f5ff86053({
        select: (matches)=>{
            matches = matches.slice(0, matches.findIndex((d)=>d.id === contextMatchId));
            return (opts == null ? void 0 : opts.select) ? opts.select(matches) : matches;
        },
        structuralSharing: opts == null ? void 0 : opts.structuralSharing
    });
}
function $79e24057cb9ad4b1$export$e015d889658554d8(opts) {
    const contextMatchId = $acw62.useContext((0, $bcdbf2acdfde29b9$export$f6b3e78d35813d66));
    return $79e24057cb9ad4b1$export$2378eb7f5ff86053({
        select: (matches)=>{
            matches = matches.slice(matches.findIndex((d)=>d.id === contextMatchId) + 1);
            return (opts == null ? void 0 : opts.select) ? opts.select(matches) : matches;
        },
        structuralSharing: opts == null ? void 0 : opts.structuralSharing
    });
}



function $e3a97195fa5ff954$export$b8d3e69d4b3eff04({ router: router, children: children, ...rest }) {
    router.update({
        ...router.options,
        ...rest,
        context: {
            ...router.options.context,
            ...rest.context
        }
    });
    const routerContext = (0, $3f2225d1bbed6ddd$export$65bef39336c189ee)();
    const provider = /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(routerContext.Provider, {
        value: router,
        children: children
    });
    if (router.options.Wrap) return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(router.options.Wrap, {
        children: provider
    });
    return provider;
}
function $e3a97195fa5ff954$export$323e4fc2fa4753fb({ router: router, ...rest }) {
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($e3a97195fa5ff954$export$b8d3e69d4b3eff04, {
        router: router,
        ...rest,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $79e24057cb9ad4b1$export$6479cfcac2b87c0), {})
    });
}




var $acw62 = parcelRequire("acw62");
var $340986ac0d7e4aac$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $340986ac0d7e4aac$export$18a094aefa070634 = (obj, member, getter)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $340986ac0d7e4aac$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $340986ac0d7e4aac$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $340986ac0d7e4aac$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $340986ac0d7e4aac$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $340986ac0d7e4aac$export$18a094aefa070634(obj, member, getter);
        }
    });
var $340986ac0d7e4aac$export$fa92d15b718fce20 = (obj, member, method)=>{
    $340986ac0d7e4aac$var$__accessCheck(obj, member, "access private method");
    return method;
};




// src/subscribable.ts
var $46c0846a49a6d58e$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



// src/utils.ts
var $002159551d1c4551$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $002159551d1c4551$export$8793edee2d425525() {}
function $002159551d1c4551$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $002159551d1c4551$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $002159551d1c4551$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $002159551d1c4551$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $002159551d1c4551$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $002159551d1c4551$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $002159551d1c4551$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($002159551d1c4551$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $002159551d1c4551$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$002159551d1c4551$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $002159551d1c4551$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $002159551d1c4551$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $002159551d1c4551$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$002159551d1c4551$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $002159551d1c4551$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$002159551d1c4551$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $002159551d1c4551$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $002159551d1c4551$export$7a8558113332b71e(a) && $002159551d1c4551$export$7a8558113332b71e(b);
    if (array || $002159551d1c4551$export$53b83ca8eaab0383(a) && $002159551d1c4551$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $002159551d1c4551$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $002159551d1c4551$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $002159551d1c4551$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $002159551d1c4551$export$53b83ca8eaab0383(o) {
    if (!$002159551d1c4551$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$002159551d1c4551$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $002159551d1c4551$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $002159551d1c4551$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $002159551d1c4551$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $002159551d1c4551$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $002159551d1c4551$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $002159551d1c4551$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $002159551d1c4551$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $002159551d1c4551$export$1aa5a89531b7670d = Symbol();
function $002159551d1c4551$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $002159551d1c4551$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}


var $1d15693d13279fb4$var$_focused, $1d15693d13279fb4$var$_cleanup, $1d15693d13279fb4$var$_setup;
var $1d15693d13279fb4$export$86f1af424b2ca4de = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1d15693d13279fb4$var$_focused, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1d15693d13279fb4$var$_setup, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, (onFocus)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) this.setEventListener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_setup, setup);
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_cleanup)) == null || _a.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) !== focused;
        if (changed) {
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1d15693d13279fb4$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused) === "boolean") return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1d15693d13279fb4$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$1d15693d13279fb4$var$_focused = new WeakMap();
$1d15693d13279fb4$var$_cleanup = new WeakMap();
$1d15693d13279fb4$var$_setup = new WeakMap();
var $1d15693d13279fb4$export$6bf54661be5b02cf = new $1d15693d13279fb4$export$86f1af424b2ca4de();



// src/notifyManager.ts
function $798266f99c432533$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $798266f99c432533$export$520687f44db6e1ab = $798266f99c432533$export$316a8efd03cd1458();










var $9606ae1cfceeea19$var$_online, $9606ae1cfceeea19$var$_cleanup, $9606ae1cfceeea19$var$_setup;
var $9606ae1cfceeea19$export$58774fb55d5ff7fc = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_online, true);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9606ae1cfceeea19$var$_setup, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, (onOnline)=>{
            if (!(0, $002159551d1c4551$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) this.setEventListener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_setup, setup);
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_cleanup)) == null || _a.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online) !== online;
        if (changed) {
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9606ae1cfceeea19$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9606ae1cfceeea19$var$_online);
    }
};
$9606ae1cfceeea19$var$_online = new WeakMap();
$9606ae1cfceeea19$var$_cleanup = new WeakMap();
$9606ae1cfceeea19$var$_setup = new WeakMap();
var $9606ae1cfceeea19$export$b113e788b2dd3fdc = new $9606ae1cfceeea19$export$58774fb55d5ff7fc();



// src/thenable.ts
function $5a619d4c2df9bf12$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}



function $e19f6352d48643a1$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $e19f6352d48643a1$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline() : true;
}
var $e19f6352d48643a1$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $e19f6352d48643a1$export$986cc6445c1d323(value) {
    return value instanceof $e19f6352d48643a1$export$a8430ed4188f35a9;
}
function $e19f6352d48643a1$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    const thenable = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)();
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $e19f6352d48643a1$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$e19f6352d48643a1$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $e19f6352d48643a1$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $002159551d1c4551$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}




var $1cb0c2534af8594c$var$_gcTimeout;
var $1cb0c2534af8594c$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $002159551d1c4551$export$e539f754e934e270)(this.gcTime)) (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $002159551d1c4551$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout)) {
            clearTimeout((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $1cb0c2534af8594c$var$_gcTimeout));
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $1cb0c2534af8594c$var$_gcTimeout, void 0);
        }
    }
};
$1cb0c2534af8594c$var$_gcTimeout = new WeakMap();


var $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$_revertState, $9dc680c629ca4c63$var$_cache, $9dc680c629ca4c63$var$_client, $9dc680c629ca4c63$var$_retryer, $9dc680c629ca4c63$var$_defaultOptions, $9dc680c629ca4c63$var$_abortSignalConsumed, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn;
var $9dc680c629ca4c63$export$62297b13309008b2 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_dispatch);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_initialState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_revertState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_cache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_client, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_retryer, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_defaultOptions, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_client, config.client);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_cache, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_initialState, $9dc680c629ca4c63$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $002159551d1c4551$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $002159551d1c4551$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $002159551d1c4551$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                    if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_abortSignalConsumed)) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer)) {
                (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).continueRetry();
                return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(this.options, fetchOptions);
            const queryFnContext = {
                client: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client),
                queryKey: this.queryKey,
                meta: this.meta
            };
            addSignalProperty(queryFnContext);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            client: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_client),
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_a = this.options.behavior) == null || _a.onFetch(context, this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_b = context.fetchOptions) == null ? void 0 : _b.meta)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_c = context.fetchOptions) == null ? void 0 : _c.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d;
            if (!((0, $e19f6352d48643a1$export$986cc6445c1d323)(error) && error.silent)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $e19f6352d48643a1$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d = (_c2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _d.call(_c2, this.state.data, error, this);
            }
            this.scheduleGc();
        };
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $9dc680c629ca4c63$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d;
                if (data === void 0) {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                try {
                    this.setData(data);
                } catch (error) {
                    onError(error);
                    return;
                }
                (_b2 = (_a2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d = (_c2 = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).config).onSettled) == null || _d.call(_c2, data, this.state.error, this);
                this.scheduleGc();
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $9dc680c629ca4c63$var$_dispatch, $9dc680c629ca4c63$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_retryer).start();
    }
};
$9dc680c629ca4c63$var$_initialState = new WeakMap();
$9dc680c629ca4c63$var$_revertState = new WeakMap();
$9dc680c629ca4c63$var$_cache = new WeakMap();
$9dc680c629ca4c63$var$_client = new WeakMap();
$9dc680c629ca4c63$var$_retryer = new WeakMap();
$9dc680c629ca4c63$var$_defaultOptions = new WeakMap();
$9dc680c629ca4c63$var$_abortSignalConsumed = new WeakMap();
$9dc680c629ca4c63$var$_dispatch = new WeakSet();
$9dc680c629ca4c63$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$9dc680c629ca4c63$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $e19f6352d48643a1$export$986cc6445c1d323)(error) && error.revert && (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_revertState)) return {
                    ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $9dc680c629ca4c63$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $9dc680c629ca4c63$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $e19f6352d48643a1$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $9dc680c629ca4c63$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}





var $3aefa839a50a34b3$var$_client, $3aefa839a50a34b3$var$_currentQuery, $3aefa839a50a34b3$var$_currentQueryInitialState, $3aefa839a50a34b3$var$_currentResult, $3aefa839a50a34b3$var$_currentResultState, $3aefa839a50a34b3$var$_currentResultOptions, $3aefa839a50a34b3$var$_currentThenable, $3aefa839a50a34b3$var$_selectError, $3aefa839a50a34b3$var$_selectFn, $3aefa839a50a34b3$var$_selectResult, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, $3aefa839a50a34b3$var$_staleTimeoutId, $3aefa839a50a34b3$var$_refetchIntervalId, $3aefa839a50a34b3$var$_currentRefetchInterval, $3aefa839a50a34b3$var$_trackedProps, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn, $3aefa839a50a34b3$var$_notify, $3aefa839a50a34b3$var$notify_fn;
var $3aefa839a50a34b3$export$a06cf8c0066f0d4c = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_executeFetch);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateStaleTimeout);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_computeRefetchInterval);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateRefetchInterval);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateTimers);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_clearStaleTimeout);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_clearRefetchInterval);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_updateQuery);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_notify);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_client, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQuery, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResult, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultState, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentResultOptions, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentThenable, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectError, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectFn, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $3aefa839a50a34b3$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_client, client);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
        if (!this.options.experimental_prefetchInRender) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).addObserver(this);
            if ($3aefa839a50a34b3$var$shouldFetchOnMount((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $3aefa839a50a34b3$var$shouldFetchOn((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        this.options = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $3aefa839a50a34b3$var$shouldFetchOptionally((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)))) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery) !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) !== (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) || nextRefetchInterval !== (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval))) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), options);
        const result = this.createResult(query, options);
        if ($3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, result);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
            (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackProp(key);
                    onPropTracked == null || onPropTracked(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    trackProp(key) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).defaultQueryOptions(options);
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const prevResultState = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState);
        const prevResultOptions = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $3aefa839a50a34b3$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $9dc680c629ca4c63$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        if (options.select && newState.data !== void 0) {
            if (prevResult && newState.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectFn)) data = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            else try {
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectFn, options.select);
                data = options.select(newState.data);
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectResult, data);
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
            } catch (selectError) {
                (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, selectError);
            }
        } else data = newState.data;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && placeholderData !== void 0) try {
                    placeholderData = options.select(placeholderData);
                    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, null);
                } catch (selectError) {
                    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_selectError, selectError);
                }
            }
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $002159551d1c4551$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError)) {
            error = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectError);
            data = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $3aefa839a50a34b3$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable)
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentThenable, nextResult.promise = (0, $5a619d4c2df9bf12$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult);
        const nextResult = this.createResult((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery), this.options);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultState, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).state);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResultOptions, this.options);
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResultState).data !== void 0) (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_lastQueryWithDefinedData, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
        if ((0, $002159551d1c4551$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_notify, $3aefa839a50a34b3$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateTimers, $3aefa839a50a34b3$var$updateTimers_fn).call(this);
    }
};
$3aefa839a50a34b3$var$_client = new WeakMap();
$3aefa839a50a34b3$var$_currentQuery = new WeakMap();
$3aefa839a50a34b3$var$_currentQueryInitialState = new WeakMap();
$3aefa839a50a34b3$var$_currentResult = new WeakMap();
$3aefa839a50a34b3$var$_currentResultState = new WeakMap();
$3aefa839a50a34b3$var$_currentResultOptions = new WeakMap();
$3aefa839a50a34b3$var$_currentThenable = new WeakMap();
$3aefa839a50a34b3$var$_selectError = new WeakMap();
$3aefa839a50a34b3$var$_selectFn = new WeakMap();
$3aefa839a50a34b3$var$_selectResult = new WeakMap();
$3aefa839a50a34b3$var$_lastQueryWithDefinedData = new WeakMap();
$3aefa839a50a34b3$var$_staleTimeoutId = new WeakMap();
$3aefa839a50a34b3$var$_refetchIntervalId = new WeakMap();
$3aefa839a50a34b3$var$_currentRefetchInterval = new WeakMap();
$3aefa839a50a34b3$var$_trackedProps = new WeakMap();
$3aefa839a50a34b3$var$_executeFetch = new WeakSet();
$3aefa839a50a34b3$var$executeFetch_fn = function(fetchOptions) {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateQuery, $3aefa839a50a34b3$var$updateQuery_fn).call(this);
    let promise = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
    return promise;
};
$3aefa839a50a34b3$var$_updateStaleTimeout = new WeakSet();
$3aefa839a50a34b3$var$updateStaleTimeout_fn = function() {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearStaleTimeout, $3aefa839a50a34b3$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $002159551d1c4551$export$cb3145f011bda3ac)(this.options.staleTime, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery));
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale || !(0, $002159551d1c4551$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $002159551d1c4551$export$811b83d62bcf47f0)((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$3aefa839a50a34b3$var$_computeRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$3aefa839a50a34b3$var$_updateRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_clearRefetchInterval, $3aefa839a50a34b3$var$clearRefetchInterval_fn).call(this);
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentRefetchInterval, nextInterval);
    if ((0, $002159551d1c4551$export$6acf61af03e62db) || (0, $002159551d1c4551$export$8c88ee6f2357230d)(this.options.enabled, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) === false || !(0, $002159551d1c4551$export$e539f754e934e270)((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)) || (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval) === 0) return;
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $1d15693d13279fb4$export$6bf54661be5b02cf).isFocused()) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_executeFetch, $3aefa839a50a34b3$var$executeFetch_fn).call(this);
    }, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentRefetchInterval)));
};
$3aefa839a50a34b3$var$_updateTimers = new WeakSet();
$3aefa839a50a34b3$var$updateTimers_fn = function() {
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateStaleTimeout, $3aefa839a50a34b3$var$updateStaleTimeout_fn).call(this);
    (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_updateRefetchInterval, $3aefa839a50a34b3$var$updateRefetchInterval_fn).call(this, (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $3aefa839a50a34b3$var$_computeRefetchInterval, $3aefa839a50a34b3$var$computeRefetchInterval_fn).call(this));
};
$3aefa839a50a34b3$var$_clearStaleTimeout = new WeakSet();
$3aefa839a50a34b3$var$clearStaleTimeout_fn = function() {
    if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId)) {
        clearTimeout((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_staleTimeoutId));
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_staleTimeoutId, void 0);
    }
};
$3aefa839a50a34b3$var$_clearRefetchInterval = new WeakSet();
$3aefa839a50a34b3$var$clearRefetchInterval_fn = function() {
    if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId)) {
        clearInterval((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_refetchIntervalId));
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_refetchIntervalId, void 0);
    }
};
$3aefa839a50a34b3$var$_updateQuery = new WeakSet();
$3aefa839a50a34b3$var$updateQuery_fn = function() {
    const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client), this.options);
    if (query === (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery)) return;
    const prevQuery = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery);
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQuery, query);
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $3aefa839a50a34b3$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$3aefa839a50a34b3$var$_notify = new WeakSet();
$3aefa839a50a34b3$var$notify_fn = function(notifyOptions) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentResult));
        });
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_client).getQueryCache().notify({
            query: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $3aefa839a50a34b3$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $3aefa839a50a34b3$var$shouldFetchOnMount(query, options) {
    return $3aefa839a50a34b3$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $3aefa839a50a34b3$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $3aefa839a50a34b3$var$shouldFetchOn(query, options, field) {
    if ((0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $3aefa839a50a34b3$var$isStale(query, options);
    }
    return false;
}
function $3aefa839a50a34b3$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $002159551d1c4551$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $3aefa839a50a34b3$var$isStale(query, options);
}
function $3aefa839a50a34b3$var$isStale(query, options) {
    return (0, $002159551d1c4551$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $3aefa839a50a34b3$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

"use client";
var $aeeeb04cd6721116$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $aeeeb04cd6721116$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($aeeeb04cd6721116$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $aeeeb04cd6721116$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($aeeeb04cd6721116$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
function $9f918c9537253956$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $9f918c9537253956$var$QueryErrorResetBoundaryContext = $acw62.createContext($9f918c9537253956$var$createValue());
var $9f918c9537253956$export$50dfac555130cafd = ()=>$acw62.useContext($9f918c9537253956$var$QueryErrorResetBoundaryContext);
var $9f918c9537253956$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$9f918c9537253956$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($9f918c9537253956$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");
// src/utils.ts
function $a478358a8235bfab$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $a478358a8235bfab$export$8793edee2d425525() {}


"use client";
var $00f18dc4257f8dfa$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $00f18dc4257f8dfa$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $00f18dc4257f8dfa$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $a478358a8235bfab$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $acw62 = parcelRequire("acw62");
"use client";
var $8a077a20b7040cef$var$IsRestoringContext = $acw62.createContext(false);
var $8a077a20b7040cef$export$4da0178d6b5f553 = ()=>$acw62.useContext($8a077a20b7040cef$var$IsRestoringContext);
var $8a077a20b7040cef$export$593807d4e94f9621 = $8a077a20b7040cef$var$IsRestoringContext.Provider;


// src/suspense.ts
var $6de503da57e511b5$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $6de503da57e511b5$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    const originalStaleTime = defaultedOptions.staleTime;
    if (defaultedOptions.suspense) {
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>Math.max(originalStaleTime(...args), 1e3) : Math.max(originalStaleTime ?? 1e3, 1e3);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, 1e3);
    }
};
var $6de503da57e511b5$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $6de503da57e511b5$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $6de503da57e511b5$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });



"use client";
function $1fa9088b80b7d036$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $8a077a20b7040cef$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $9f918c9537253956$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $6de503da57e511b5$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $00f18dc4257f8dfa$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $00f18dc4257f8dfa$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $a478358a8235bfab$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $6de503da57e511b5$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $00f18dc4257f8dfa$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $002159551d1c4551$export$6acf61af03e62db) && (0, $6de503da57e511b5$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $6de503da57e511b5$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $a478358a8235bfab$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $82072f1c97bcdd9c$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $1fa9088b80b7d036$export$fff0865807e996c5)(options, (0, $3aefa839a50a34b3$export$a06cf8c0066f0d4c), queryClient);
}


function $d767740973bc6396$export$811e4ddfc1fd2bac() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'tracks'
        ],
        queryFn: ()=>fetch('/api/tracks').then((res)=>res.json())
    });
}



parcelRequire("acw62");
function $2db7412aaa803911$export$5a58787633b0b5d8({ value: value, onChange: onChange, placeholder: placeholder = 'Search...' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex w-full items-stretch",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "flex-1 relative z-10",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: " overflow-hidden rounded-l-full bg-white border-2 border-transparent transition-all duration-150 focus-within:border-[#9596B8] focus-within:ring-3 focus-within:ring-[#cacadb]/75 ",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                            type: "text",
                            placeholder: placeholder,
                            value: value,
                            onChange: (e)=>onChange(e.target.value),
                            className: " w-full px-6 py-4 text-gray-700 placeholder-gray-400 bg-white border-0 rounded-l-full outline-none focus:outline-none focus:ring-0 "
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    type: "button",
                    className: "shrink-0 -ml-2 rounded-r-full bg-[#CD1520] px-6 py-4 text-white",
                    "aria-label": "Search",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                        viewBox: "0 0 21 21",
                        className: "h-6 w-6",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            fill: "none",
                            fillRule: "evenodd",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M19 19l-5-5",
                                    strokeLinecap: "square"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                    cx: "8.5",
                                    cy: "8.5",
                                    r: "7.5"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}




var $acw62 = parcelRequire("acw62");

function $61da2392401c22a9$export$fe391351ad96431d() {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'settings'
        ],
        queryFn: ()=>fetch('/api/settings').then((res)=>res.json()),
        staleTime: Infinity
    });
}


const $90af5cb3a0fd300a$var$RESET_EVENT = 'songrequests:reset';
const $90af5cb3a0fd300a$var$REQUESTED_EVENT = 'songrequests:requested';
function $90af5cb3a0fd300a$export$e42608234e0cc529({ track: track }) {
    const [showConfirm, setShowConfirm] = (0, $acw62.useState)(false);
    const [requesterName, setRequesterName] = (0, $acw62.useState)('');
    const [message, setMessage] = (0, $acw62.useState)('');
    const [isRequested, setIsRequested] = (0, $acw62.useState)(false);
    const [requestTime, setRequestTime] = (0, $acw62.useState)(null);
    const [errorMessage, setErrorMessage] = (0, $acw62.useState)(null);
    const { data: settings } = (0, $61da2392401c22a9$export$fe391351ad96431d)();
    const commentsEnabled = settings?.enableRequestComments ?? false;
    const parts = (track.artistTitle || '').includes(' - ') ? track.artistTitle.split(' - ', 2) : [
        '',
        track.artistTitle || ''
    ];
    const artist = parts[0];
    const song = parts[1];
    (0, $acw62.useEffect)(()=>{
        if (!isRequested) return;
        const timer = setTimeout(()=>setIsRequested(false), 6000);
        return ()=>clearTimeout(timer);
    }, [
        isRequested
    ]);
    const openConfirm = ()=>{
        setRequesterName('');
        setMessage('');
        setErrorMessage(null);
        setShowConfirm(true);
    };
    const closeConfirm = (0, $acw62.useCallback)(()=>{
        setRequesterName('');
        setMessage('');
        setErrorMessage(null);
        setShowConfirm(false);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onReset = ()=>closeConfirm();
        window.addEventListener($90af5cb3a0fd300a$var$RESET_EVENT, onReset);
        return ()=>window.removeEventListener($90af5cb3a0fd300a$var$RESET_EVENT, onReset);
    }, [
        closeConfirm
    ]);
    const handleSubmit = (e)=>{
        e.preventDefault();
        setErrorMessage(null);
        fetch('/api/requestTrack', {
            method: 'POST',
            body: JSON.stringify({
                trackGuid: track.guid,
                requestedBy: (requesterName || '').trim() || 'Anonymous',
                ...commentsEnabled ? {
                    message: (message || '').trim() || undefined
                } : {}
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(async (response)=>{
            if (response.ok) {
                setIsRequested(true);
                setRequestTime(new Date());
                closeConfirm();
                window.dispatchEvent(new Event($90af5cb3a0fd300a$var$REQUESTED_EVENT));
                return;
            }
            let data = null;
            try {
                data = await response.json();
            } catch  {
                data = null;
            }
            if (response.status === 409) setErrorMessage(data && data.message || 'This song has already been requested recently.');
            else if (response.status === 400) setErrorMessage(data && data.message || 'Invalid request parameters.');
            else setErrorMessage(data && data.message || 'An error occurred while requesting the song');
        }).catch(()=>setErrorMessage('Network error. Please try again.'));
    };
    const getTimeSinceRequest = ()=>{
        if (!requestTime) return '';
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - requestTime.getTime()) / 1000);
        if (diffInSeconds < 60) return 'Playing soon...';
        const minutes = Math.floor(diffInSeconds / 60);
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                onClick: openConfirm,
                className: `bg-white rounded-lg shadow-md p-3 lg:p-4 hover:shadow-lg transition-shadow duration-200 cursor-pointer 
          ${isRequested ? 'border-2 border-green-500' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "text-base lg:text-lg font-semibold text-[#292d6e]",
                        children: track.artistTitle
                    }),
                    isRequested && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mt-2 text-sm text-green-600 flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                className: "h-4 w-4 mr-1",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M5 13l4 4L19 7"
                                })
                            }),
                            "Requested! ",
                            getTimeSinceRequest()
                        ]
                    })
                ]
            }),
            showConfirm && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
                onClick: closeConfirm,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "bg-white rounded-lg p-6 max-w-md w-full mx-4",
                    onClick: (e)=>e.stopPropagation(),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                            className: "text-xl font-semibold text-gray-900 mb-4",
                            children: errorMessage ? 'Song Request' : 'Confirm Song Request'
                        }),
                        !errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-6 space-y-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-lg lg:text-xl text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-gray-800",
                                            children: "Song:"
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-normal text-gray-700",
                                            children: song
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "text-lg lg:text-xl text-gray-900",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-semibold text-gray-800",
                                            children: "Artist:"
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "font-normal text-gray-700",
                                            children: artist
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                            className: "text-gray-600 mb-4",
                            children: [
                                "Unable to request: ",
                                track.artistTitle
                            ]
                        }),
                        errorMessage && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-4 p-3 bg-red-100 text-red-700 rounded-md",
                            children: errorMessage
                        }),
                        !errorMessage ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: handleSubmit,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "requesterName",
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Your Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                            type: "text",
                                            id: "requesterName",
                                            name: "requesterName",
                                            autoFocus: true,
                                            value: requesterName,
                                            onChange: (e)=>setRequesterName(e.target.value),
                                            placeholder: "Enter your name (optional)",
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        })
                                    ]
                                }),
                                commentsEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                            htmlFor: "message",
                                            className: "block text-sm font-medium text-gray-700 mb-1",
                                            children: "Your Comment"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                            id: "message",
                                            name: "message",
                                            rows: 3,
                                            value: message,
                                            onChange: (e)=>setMessage(e.target.value),
                                            maxLength: settings?.maxMessageLength,
                                            placeholder: "Add a note (optional)",
                                            className: "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            className: "mt-1 text-xs text-gray-500 text-right",
                                            children: [
                                                message.length,
                                                "/",
                                                settings?.maxMessageLength || 150
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "flex justify-end space-x-3",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "button",
                                            onClick: closeConfirm,
                                            className: "px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors cursor-pointer",
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                            type: "submit",
                                            className: "px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors cursor-pointer",
                                            children: "Request Song"
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex justify-center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                autoFocus: true,
                                type: "button",
                                onClick: closeConfirm,
                                className: "px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors cursor-pointer",
                                children: "Close"
                            })
                        })
                    ]
                })
            })
        ]
    });
}


const $7e865508b8b721dd$var$AFTER_REQUEST_MS = 6000;
const $7e865508b8b721dd$var$RESET_EVENT = 'songrequests:reset';
const $7e865508b8b721dd$var$REQUESTED_EVENT = 'songrequests:requested';
function $7e865508b8b721dd$export$8931430458a8a419() {
    const { data: tracks } = (0, $d767740973bc6396$export$811e4ddfc1fd2bac)();
    const [searchTerm, setSearchTerm] = (0, $acw62.useState)('');
    const searchTermRef = (0, $acw62.useRef)(searchTerm);
    (0, $acw62.useEffect)(()=>{
        searchTermRef.current = searchTerm;
    }, [
        searchTerm
    ]);
    (0, $acw62.useEffect)(()=>{
        let afterRequestTimer;
        let afterRequestArmed = false;
        const resetToBeginningIfNeeded = ()=>{
            const y = window.scrollY || document.documentElement.scrollTop || 0;
            const term = searchTermRef.current;
            const hasSearch = !!term && term.trim() !== '';
            const isScrolled = y > 0;
            window.dispatchEvent(new Event($7e865508b8b721dd$var$RESET_EVENT));
            if (!hasSearch && !isScrolled) return;
            if (hasSearch) setSearchTerm('');
            if (isScrolled) window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        };
        const onRequested = ()=>{
            afterRequestArmed = true;
            if (afterRequestTimer) window.clearTimeout(afterRequestTimer);
            afterRequestTimer = window.setTimeout(()=>{
                if (!afterRequestArmed) return;
                resetToBeginningIfNeeded();
            }, $7e865508b8b721dd$var$AFTER_REQUEST_MS);
        };
        window.addEventListener($7e865508b8b721dd$var$REQUESTED_EVENT, onRequested);
        return ()=>{
            if (afterRequestTimer) window.clearTimeout(afterRequestTimer);
            window.removeEventListener($7e865508b8b721dd$var$REQUESTED_EVENT, onRequested);
        };
    }, []);
    const filteredTracks = tracks?.filter((track)=>track.artistTitle.toLowerCase().includes(searchTerm.toLowerCase()));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full max-w-4xl p-6 space-y-4 relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("center", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                    className: "text-2xl lg:text-3xl font-bold text-white mb-6",
                    children: "Make Your Request..."
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2db7412aaa803911$export$5a58787633b0b5d8), {
                value: searchTerm,
                onChange: setSearchTerm,
                placeholder: "Search tracks..."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
                children: filteredTracks?.map((track)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $90af5cb3a0fd300a$export$e42608234e0cc529), {
                        track: track
                    }, track.guid))
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





var $96f19558542b246f$var$_observers, $96f19558542b246f$var$_mutationCache, $96f19558542b246f$var$_retryer, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn;
var $96f19558542b246f$export$17b8b19c814bcf56 = class extends (0, $1cb0c2534af8594c$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_dispatch);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_observers, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_mutationCache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $96f19558542b246f$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_mutationCache, config.mutationCache);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, []);
        this.state = config.state || $96f19558542b246f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).includes(observer)) {
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_observers, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $96f19558542b246f$var$_retryer, (0, $e19f6352d48643a1$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).canStart();
        try {
            if (!restored) {
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_retryer).start();
            await ((_f = (_e = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $96f19558542b246f$var$_dispatch, $96f19558542b246f$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).runNext(this);
        }
    }
};
$96f19558542b246f$var$_observers = new WeakMap();
$96f19558542b246f$var$_mutationCache = new WeakMap();
$96f19558542b246f$var$_retryer = new WeakMap();
$96f19558542b246f$var$_dispatch = new WeakSet();
$96f19558542b246f$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $96f19558542b246f$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $96f19558542b246f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}





var $8ecfcf98cb47c0ad$var$_client, $8ecfcf98cb47c0ad$var$_currentResult, $8ecfcf98cb47c0ad$var$_currentMutation, $8ecfcf98cb47c0ad$var$_mutateOptions, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn;
var $8ecfcf98cb47c0ad$export$d3c1860ee66f291a = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_updateResult);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_notify);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_client, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentResult, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).defaultMutationOptions(options);
        if (!(0, $002159551d1c4551$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $002159551d1c4551$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $002159551d1c4551$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, void 0);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_updateResult, $8ecfcf98cb47c0ad$var$updateResult_fn).call(this);
        (0, $340986ac0d7e4aac$export$fa92d15b718fce20)(this, $8ecfcf98cb47c0ad$var$_notify, $8ecfcf98cb47c0ad$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_mutateOptions, options);
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentMutation, (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client).getMutationCache().build((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_client), this.options));
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).addObserver(this);
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation).execute(variables);
    }
};
$8ecfcf98cb47c0ad$var$_client = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentResult = new WeakMap();
$8ecfcf98cb47c0ad$var$_currentMutation = new WeakMap();
$8ecfcf98cb47c0ad$var$_mutateOptions = new WeakMap();
$8ecfcf98cb47c0ad$var$_updateResult = new WeakSet();
$8ecfcf98cb47c0ad$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $96f19558542b246f$export$a1659b54bac3252a)();
    (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $8ecfcf98cb47c0ad$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$8ecfcf98cb47c0ad$var$_notify = new WeakSet();
$8ecfcf98cb47c0ad$var$notify_fn = function(action) {
    (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).variables;
            const context = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $8ecfcf98cb47c0ad$var$_currentResult));
        });
    });
};




"use client";
function $417dffbfea982a4c$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $8ecfcf98cb47c0ad$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $798266f99c432533$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $a478358a8235bfab$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $a478358a8235bfab$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}


function $c542b3771c297a95$export$a09b04fe9d144313(token, onAuthError) {
    return (0, $82072f1c97bcdd9c$export$dd0a697e1782aedd)({
        queryKey: [
            'requests',
            token
        ],
        queryFn: async ()=>{
            const headers = {};
            if (token) headers.Authorization = `Bearer ${token}`;
            const response = await fetch('/api/requests', {
                headers: headers
            });
            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    // Token expired or invalid, trigger logout
                    if (onAuthError) onAuthError();
                    throw new Error('Authentication failed');
                }
                throw new Error('Failed to fetch requests');
            }
            return response.json();
        },
        retry: false,
        enabled: !!token
    });
}
function $c542b3771c297a95$export$c19a09325c0942c8(token, onAuthError) {
    const queryClient = (0, $aeeeb04cd6721116$export$22e77b9572c4fded)();
    return (0, $417dffbfea982a4c$export$609860bf8b0084c)({
        mutationFn: async (requestId)=>{
            const headers = {
                'Content-Type': 'application/json'
            };
            if (token) headers.Authorization = `Bearer ${token}`;
            const response = await fetch(`/api/requests/${requestId}`, {
                method: 'DELETE',
                headers: headers
            });
            if (!response.ok) {
                if (response.status === 401 || response.status === 403) {
                    // Token expired or invalid, trigger logout
                    if (onAuthError) onAuthError();
                    throw new Error('Authentication failed');
                }
                throw new Error('Failed to delete request');
            }
            return response.json();
        },
        onSuccess: ()=>{
            // Invalidate and refetch the requests query
            queryClient.invalidateQueries({
                queryKey: [
                    'requests',
                    token
                ]
            });
        }
    });
}


function $1e59c051c6e223fd$var$DeleteConfirmation({ requestId: requestId, trackName: trackName, onCancel: onCancel, onConfirm: onConfirm, isPending: isPending }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "bg-white rounded-lg p-6 max-w-md w-full mx-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                    className: "text-xl font-semibold text-white mb-4",
                    children: "Confirm Delete Request"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-gray-600 mb-6",
                    children: [
                        'Are you sure you want to delete the request for "',
                        trackName,
                        '"?'
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex justify-end space-x-3",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onCancel,
                            className: "px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors cursor-pointer",
                            disabled: isPending,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: onConfirm,
                            className: "px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors cursor-pointer",
                            disabled: isPending,
                            children: isPending ? 'Deleting...' : 'Delete Request'
                        })
                    ]
                })
            ]
        })
    });
}
function $1e59c051c6e223fd$export$b6157acb76836c1e({ token: token, onLogout: onLogout }) {
    const navigate = (0, $5d305f5a992c45af$export$9770f232ac06a008)();
    const { data: requests, isLoading: requestsLoading, error: requestsError } = (0, $c542b3771c297a95$export$a09b04fe9d144313)(token, onLogout);
    const { data: tracks, isLoading: tracksLoading } = (0, $d767740973bc6396$export$811e4ddfc1fd2bac)();
    const deleteRequestMutation = (0, $c542b3771c297a95$export$c19a09325c0942c8)(token, onLogout);
    const [requestToDelete, setRequestToDelete] = (0, $acw62.useState)(null);
    // Function to lookup track name by GUID
    const getTrackName = (trackGuid)=>{
        const track = tracks?.find((t)=>t.guid === trackGuid);
        return track ? track.artistTitle : 'Unknown Track';
    };
    const handleDeleteRequest = (requestId)=>{
        setRequestToDelete(requestId);
    };
    const confirmDelete = ()=>{
        if (requestToDelete) {
            deleteRequestMutation.mutate(requestToDelete);
            // We'll close the dialog when the mutation succeeds
            if (!deleteRequestMutation.isPending) setRequestToDelete(null);
        }
    };
    const cancelDelete = ()=>{
        setRequestToDelete(null);
    };
    if (requestsLoading || tracksLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex justify-center items-center p-8",
        children: "Loading..."
    });
    if (requestsError) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full max-w-6xl p-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4",
                children: "Error loading requests. Please try again."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: ()=>navigate({
                        to: '/admin'
                    }),
                className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
                children: "Retry"
            })
        ]
    });
    // Find the request to delete to get its track name
    const requestToDeleteObject = requestToDelete ? requests?.find((r)=>r.id === requestToDelete) : null;
    const trackNameToDelete = requestToDeleteObject ? getTrackName(requestToDeleteObject.trackGuid) : '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full max-w-6xl p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex justify-between items-center mb-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                className: "text-3xl font-bold text-white",
                                children: "Song Requests Admin"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onLogout,
                                className: "px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition-colors cursor-pointer",
                                children: "Logout"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overflow-x-auto bg-white rounded-lg shadow",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("table", {
                            className: "min-w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("thead", {
                                    className: "bg-gray-100",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-3 px-4 text-left text-xs font-medium text-[#292d6e] uppercase tracking-wider",
                                                children: "Song"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-3 px-4 text-left text-xs font-medium text-[#292d6e] uppercase tracking-wider",
                                                children: "Requested By"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-3 px-4 text-left text-xs font-medium text-[#292d6e] uppercase tracking-wider",
                                                children: "Requested Time"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-3 px-4 text-left text-xs font-medium text-[#292d6e] uppercase tracking-wider",
                                                children: "IP Address"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-3 px-4 text-left text-xs font-medium text-[#292d6e] uppercase tracking-wider",
                                                children: "Processed Time"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("th", {
                                                className: "py-3 px-4 text-left text-xs font-medium text-[#292d6e] uppercase tracking-wider",
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tbody", {
                                    className: "divide-y divide-gray-200",
                                    children: requests?.length ? requests.sort((a, b)=>new Date(b.requestedAt).getTime() - new Date(a.requestedAt).getTime()).map((request)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("tr", {
                                            className: "hover:bg-gray-50",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-4 px-4 whitespace-nowrap align-top",
                                                    children: getTrackName(request.trackGuid)
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-4 px-4 whitespace-nowrap align-top",
                                                    children: request.requestedBy
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-4 px-4 whitespace-nowrap align-top",
                                                    children: new Date(request.requestedAt).toLocaleString()
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-4 px-4 whitespace-nowrap align-top",
                                                    children: request.ipAddress || 'Unknown'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-4 px-4 whitespace-nowrap align-top",
                                                    children: request.processedAt ? new Date(request.processedAt).toLocaleString() : 'Not processed'
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                                    className: "py-4 px-4 whitespace-nowrap align-top",
                                                    children: !request.processedAt && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>handleDeleteRequest(request.id),
                                                        className: "px-3 py-1 bg-red-500 text-white text-sm rounded hover:bg-red-600 transition-colors cursor-pointer",
                                                        children: "Delete"
                                                    })
                                                })
                                            ]
                                        }, request.id)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("tr", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("td", {
                                            colSpan: 6,
                                            className: "py-4 px-4 text-center text-gray-500",
                                            children: "No requests yet"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            requestToDelete && requestToDeleteObject && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1e59c051c6e223fd$var$DeleteConfirmation, {
                requestId: requestToDelete,
                trackName: trackNameToDelete,
                onCancel: cancelDelete,
                onConfirm: confirmDelete,
                isPending: deleteRequestMutation.isPending
            })
        ]
    });
}



parcelRequire("acw62");
function $01d63b147b2fbfdf$export$b67224528f094be9({ error: error, password: password, isLoading: isLoading, onPasswordChange: onPasswordChange, onSubmit: onSubmit }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "w-full max-w-md p-6 mx-auto",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-3xl font-bold text-white mb-6 text-center",
                children: "Admin Login"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "bg-white rounded-lg shadow-md p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: onSubmit,
                    children: [
                        error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "mb-4",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                    className: "block text-gray-700 text-sm font-bold mb-2",
                                    htmlFor: "password",
                                    children: "Password"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    id: "password",
                                    type: "password",
                                    autoFocus: true,
                                    value: password,
                                    onChange: (e)=>onPasswordChange(e.target.value),
                                    className: "shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "flex items-center justify-between",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "submit",
                                className: `bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`,
                                disabled: isLoading,
                                children: isLoading ? 'Logging in...' : 'Sign In'
                            })
                        })
                    ]
                })
            })
        ]
    });
}


function $dcf148fd720b51d5$export$b25f57c16f88d7e0() {
    const storedToken = localStorage.getItem('admin_token');
    const [isAuthenticated, setIsAuthenticated] = (0, $acw62.useState)(storedToken !== null);
    const [token, setToken] = (0, $acw62.useState)(storedToken);
    const [password, setPassword] = (0, $acw62.useState)('');
    const [error, setError] = (0, $acw62.useState)('');
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const handleLogin = async (e)=>{
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    password: password
                })
            });
            const data = await response.json();
            if (response.ok && data.success) {
                localStorage.setItem('admin_token', data.token);
                setToken(data.token);
                setIsAuthenticated(true);
            } else setError(data.message || 'Login failed');
        } catch (err) {
            setError('An error occurred. Please try again.');
        } finally{
            setIsLoading(false);
        }
    };
    const handleLogout = ()=>{
        localStorage.removeItem('admin_token');
        setToken(null);
        setIsAuthenticated(false);
        setPassword('');
    };
    if (!isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01d63b147b2fbfdf$export$b67224528f094be9), {
        error: error,
        password: password,
        isLoading: isLoading,
        onPasswordChange: setPassword,
        onSubmit: handleLogin
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e59c051c6e223fd$export$b6157acb76836c1e), {
        token: token,
        onLogout: handleLogout
    });
}


var $339d72b11d4ba0a8$exports = {};
$339d72b11d4ba0a8$exports = new URL("logo.5daeb6bd.png", import.meta.url).toString();


const $cd93687958c8007e$var$logoUrl = new URL($339d72b11d4ba0a8$exports).href;
const $cd93687958c8007e$var$rootRoute = (0, $e621c732959f7f46$export$f20dca7d42ad6c55)({
    component: ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "flex flex-col items-center min-h-screen font-sans bg-[#292d6e]",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                    className: "w-full bg-white shadow-md p-4",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "max-w-6xl mx-auto flex justify-center items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15b3b5f25f2a096d$export$a6c7ac8248d6e38a), {
                            to: "/",
                            "aria-label": "Home",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: $cd93687958c8007e$var$logoUrl,
                                alt: "Must Have Music",
                                className: "h-30 w-auto"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9af09e1809bab698$export$910ae8079b2c2852), {})
            ]
        })
});
const $cd93687958c8007e$var$indexRoute = (0, $e621c732959f7f46$export$544c268deaca2597)({
    getParentRoute: ()=>$cd93687958c8007e$var$rootRoute,
    path: '/',
    component: (0, $7e865508b8b721dd$export$8931430458a8a419)
});
const $cd93687958c8007e$var$adminRoute = (0, $e621c732959f7f46$export$544c268deaca2597)({
    getParentRoute: ()=>$cd93687958c8007e$var$rootRoute,
    path: '/admin',
    component: (0, $dcf148fd720b51d5$export$b25f57c16f88d7e0)
});
const $cd93687958c8007e$var$routeTree = $cd93687958c8007e$var$rootRoute.addChildren([
    $cd93687958c8007e$var$indexRoute,
    $cd93687958c8007e$var$adminRoute
]);
const $cd93687958c8007e$var$router = (0, $ab96d7f38df4df97$export$baddd0131ee8c05b)({
    routeTree: $cd93687958c8007e$var$routeTree
});
function $cd93687958c8007e$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3a97195fa5ff954$export$323e4fc2fa4753fb), {
        router: $cd93687958c8007e$var$router
    });
}









var $c3b25629722ddda6$var$_queries;
var $c3b25629722ddda6$export$5dde0cd941da8468 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $c3b25629722ddda6$var$_queries, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $c3b25629722ddda6$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $9dc680c629ca4c63$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).has(query.queryHash)) {
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $c3b25629722ddda6$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $002159551d1c4551$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$c3b25629722ddda6$var$_queries = new WeakMap();







var $faef27284cfa645e$var$_mutations, $faef27284cfa645e$var$_scopes, $faef27284cfa645e$var$_mutationId;
var $faef27284cfa645e$export$1fcfd9a244434844 = class extends (0, $46c0846a49a6d58e$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutations, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $faef27284cfa645e$var$_scopes, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $faef27284cfa645e$var$_mutationId, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutations, /* @__PURE__ */ new Set());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_scopes, /* @__PURE__ */ new Map());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $faef27284cfa645e$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $96f19558542b246f$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $340986ac0d7e4aac$export$b1fe7cbb4502036b)(this, $faef27284cfa645e$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).add(mutation);
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).delete(mutation)) {
            const scope = $faef27284cfa645e$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $faef27284cfa645e$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations).clear();
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $faef27284cfa645e$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $002159551d1c4551$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $002159551d1c4551$export$8793edee2d425525)))));
    }
};
$faef27284cfa645e$var$_mutations = new WeakMap();
$faef27284cfa645e$var$_scopes = new WeakMap();
$faef27284cfa645e$var$_mutationId = new WeakMap();
function $faef27284cfa645e$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $45a641ae9a292711$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $002159551d1c4551$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        client: context.client,
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $002159551d1c4551$export$8c6246b73dd61f4a) : (0, $002159551d1c4551$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $45a641ae9a292711$var$getPreviousPageParam : $45a641ae9a292711$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $45a641ae9a292711$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $45a641ae9a292711$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $45a641ae9a292711$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $45a641ae9a292711$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $45a641ae9a292711$var$getNextPageParam(options, data) != null;
}
function $45a641ae9a292711$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $45a641ae9a292711$var$getPreviousPageParam(options, data) != null;
}


var $f71a9ec256bb1e8c$var$_queryCache, $f71a9ec256bb1e8c$var$_mutationCache, $f71a9ec256bb1e8c$var$_defaultOptions, $f71a9ec256bb1e8c$var$_queryDefaults, $f71a9ec256bb1e8c$var$_mutationDefaults, $f71a9ec256bb1e8c$var$_mountCount, $f71a9ec256bb1e8c$var$_unsubscribeFocus, $f71a9ec256bb1e8c$var$_unsubscribeOnline;
var $f71a9ec256bb1e8c$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryCache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationCache, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_defaultOptions, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_queryDefaults, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_mountCount, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (0, $340986ac0d7e4aac$export$addf369becd23283)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryCache, config.queryCache || new (0, $c3b25629722ddda6$export$5dde0cd941da8468)());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationCache, config.mutationCache || new (0, $faef27284cfa645e$export$1fcfd9a244434844)());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, config.defaultOptions || {});
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_mountCount, 0);
    }
    mount() {
        (0, $340986ac0d7e4aac$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._++;
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 1) return;
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, (0, $1d15693d13279fb4$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onFocus();
            }
        }));
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, (0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $340986ac0d7e4aac$export$b1fe7cbb4502036b)(this, $f71a9ec256bb1e8c$var$_mountCount)._--;
        if ((0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mountCount) !== 0) return;
        (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeFocus, void 0);
        (_b = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $002159551d1c4551$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>{
            (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $798266f99c432533$export$520687f44db6e1ab).batch(()=>(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $002159551d1c4551$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $002159551d1c4551$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $002159551d1c4551$export$8793edee2d425525)).catch((0, $002159551d1c4551$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $45a641ae9a292711$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $9606ae1cfceeea19$export$b113e788b2dd3fdc).isOnline()) return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache);
    }
    getMutationCache() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $340986ac0d7e4aac$export$42432efe6614d3b4)(this, $f71a9ec256bb1e8c$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).set((0, $002159551d1c4551$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $002159551d1c4551$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $002159551d1c4551$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $002159551d1c4551$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_queryCache).clear();
        (0, $340986ac0d7e4aac$export$18a094aefa070634)(this, $f71a9ec256bb1e8c$var$_mutationCache).clear();
    }
};
$f71a9ec256bb1e8c$var$_queryCache = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationCache = new WeakMap();
$f71a9ec256bb1e8c$var$_defaultOptions = new WeakMap();
$f71a9ec256bb1e8c$var$_queryDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mutationDefaults = new WeakMap();
$f71a9ec256bb1e8c$var$_mountCount = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeFocus = new WeakMap();
$f71a9ec256bb1e8c$var$_unsubscribeOnline = new WeakMap();


const $70fc9a727fa662ae$var$queryClient = new (0, $f71a9ec256bb1e8c$export$405d0624ed55a03f)();
const $70fc9a727fa662ae$var$container = document.getElementById('root');
const $70fc9a727fa662ae$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).StrictMode, {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $aeeeb04cd6721116$export$45604f0cc8ae667b), {
        client: $70fc9a727fa662ae$var$queryClient,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})
    })
}));


//# sourceMappingURL=index.9513e20a.js.map
